// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v6.33.4
// source: commands.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import {
  DisclaimerMessageUpdateDisclaimerMessage,
  GreetingUpdateGreeting,
  LanguageBehaviorUpdateLanguageBehavior,
  PersonalityUpdatePersonality,
  RoleUpdateRole,
  RulesUpdateRules,
} from "./agent_settings";
import {
  ApiIntegrationConfigUpdate,
  ApiIntegrationCreate,
  ApiIntegrationDelete,
  ApiIntegrationOperationCreate,
  ApiIntegrationOperationDelete,
  ApiIntegrationOperationUpdate,
  ApiIntegrationUpdate,
} from "./api_integrations";
import { ASRSettingsUpdateASRSettings } from "./asr_settings";
import {
  ChannelUpdateGreeting,
  ChannelUpdateLLMSettings,
  ChannelUpdateSafetyFilters,
  ChannelUpdateStatus,
  ChannelUpdateStylePrompt,
  VoiceChannelResetAsrConfig,
  VoiceChannelResetAudioEnhancement,
  VoiceChannelResetBargeInConfig,
  VoiceChannelResetSilenceFillerUtterances,
  VoiceChannelResetTemperature,
  VoiceChannelResetVadConfig,
  VoiceChannelUpdateAsrConfig,
  VoiceChannelUpdateASRSettings,
  VoiceChannelUpdateAudioEnhancement,
  VoiceChannelUpdateBargeInConfig,
  VoiceChannelUpdateDisclaimer,
  VoiceChannelUpdateSilenceFillerUtterances,
  VoiceChannelUpdateTemperature,
  VoiceChannelUpdateVadConfig,
} from "./channels";
import { ContentFilterSettingsUpdateContentFilterSettings } from "./content_filter_settings";
import { CSATUpdateConfig } from "./csat";
import { EndFunctionCreate, EndFunctionDelete, EndFunctionUpdate } from "./end_function";
import { EntityCreate, EntityDelete, EntityUpdate } from "./entities";
import { ExperimentalConfigUpdateConfig } from "./experimental_config";
import {
  CreateNoCodeCondition,
  CreateNoCodeStep,
  CreateStep,
  CreateStepCondition,
  DeleteNoCodeCondition,
  DeleteNoCodeStep,
  DeleteStep,
  DeleteStepCondition,
  FlowCreateFlow,
  FlowCreateStep,
  FlowCreateTransitionFunction,
  FlowDeleteFlow,
  FlowDeleteStep,
  FlowDeleteTransitionFunction,
  FlowImportFlow,
  FlowUpdateFlow,
  FlowUpdateStep,
  FlowUpdateStepAsrConfig,
  FlowUpdateStepDtmfConfig,
  FlowUpdateStepPosition,
  FlowUpdateStepPositions,
  FlowUpdateTransitionFunction,
  FlowUpdateTransitionFunctionLatencyControl,
  MoveFlowComponent,
  MoveFlowComponents,
  UpdateNoCodeCondition,
  UpdateNoCodeConditionExitFlowPosition,
  UpdateNoCodeConditionPosition,
  UpdateNoCodeStep,
  UpdateNoCodeStepPosition,
  UpdateStep,
  UpdateStepCondition,
  UpdateStepConditionPosition,
} from "./flows";
import {
  FunctionCreateFunction,
  FunctionDeleteFunction,
  FunctionUpdateFunction,
  FunctionUpdateLatencyControl,
} from "./functions";
import { Struct } from "./google/protobuf/struct";
import { Timestamp } from "./google/protobuf/timestamp";
import { HandoffCreate, HandoffDelete, HandoffResetHandoffConfigs, HandoffSetDefault, HandoffUpdate } from "./handoff";
import {
  IntegrationConnect,
  IntegrationDisable,
  IntegrationDisconnect,
  IntegrationEnable,
  IntegrationUpdateFunctions,
  MCPConfigUpdate,
} from "./integrations";
import {
  KeyphraseBoostingCreateKeyphrase,
  KeyphraseBoostingDeleteKeyphrase,
  KeyphraseBoostingUpdateKeyphrase,
} from "./keyphrase_boosting";
import {
  KnowledgeBaseCreateTopic,
  KnowledgeBaseDeleteTopic,
  KnowledgeBaseImportTopics,
  KnowledgeBaseToggleTopicStatus,
  KnowledgeBaseUpdateTopic,
} from "./knowledge_base";
import { LanguagesAddLanguage, LanguagesDeleteLanguage, LanguagesUpdateDefaultLanguage } from "./languages";
import { LLMSettingsUpdateLLMSettings } from "./llm_settings";
import {
  PronunciationsCreatePronunciation,
  PronunciationsDeletePronunciation,
  PronunciationsReorderPronunciations,
  PronunciationsUpdatePronunciation,
} from "./pronunciations";
import { SMSCreateTemplate, SMSDeleteTemplate, SMSUpdateTemplate } from "./sms";
import { StartFunctionCreate, StartFunctionDelete, StartFunctionUpdate } from "./start_function";
import { StopKeywordCreate, StopKeywordDelete, StopKeywordUpdate } from "./stop_keywords";
import {
  TranscriptCorrectionsCreateTranscriptCorrections,
  TranscriptCorrectionsDeleteTranscriptCorrections,
  TranscriptCorrectionsUpdateTranscriptCorrections,
} from "./transcript_corrections";
import {
  LanguageHubTranslationsCreate,
  LanguageHubTranslationsDelete,
  LanguageHubTranslationsUpdate,
} from "./translations";
import { VariableCreate, VariableDelete, VariableUpdate } from "./variables";
import {
  VariantCreateAttribute,
  VariantCreateVariant,
  VariantDeleteAttribute,
  VariantDeleteVariant,
  VariantImportVariants,
  VariantSetDefaultVariant,
  VariantUpdateAttribute,
  VariantUpdateVariant,
} from "./variant";
import {
  VoiceAddAgentVoice,
  VoiceAddFavoriteVoice,
  VoiceCreateAgentVoiceSettings,
  VoiceCreateDisclaimerVoiceSettings,
  VoiceDeleteAgentVoice,
  VoiceRemoveFavoriteVoice,
  VoiceUpdateAgentVoice,
  VoiceUpdateAgentVoiceSettings,
  VoiceUpdateDisclaimerVoice,
  VoiceUpdateDisclaimerVoiceSettings,
} from "./voice";

export const protobufPackage = "";

export enum ResolutionStrategy {
  theirs = 0,
  ours = 1,
  base = 2,
  UNRECOGNIZED = -1,
}

export function resolutionStrategyFromJSON(object: any): ResolutionStrategy {
  switch (object) {
    case 0:
    case "theirs":
      return ResolutionStrategy.theirs;
    case 1:
    case "ours":
      return ResolutionStrategy.ours;
    case 2:
    case "base":
      return ResolutionStrategy.base;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResolutionStrategy.UNRECOGNIZED;
  }
}

export function resolutionStrategyToJSON(object: ResolutionStrategy): string {
  switch (object) {
    case ResolutionStrategy.theirs:
      return "theirs";
    case ResolutionStrategy.ours:
      return "ours";
    case ResolutionStrategy.base:
      return "base";
    case ResolutionStrategy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Metadata {
  createdAt: Date | undefined;
  createdBy: string;
}

/** events that clients receive over websocket */
export interface Event {
  sequence: Long;
  /** UUID for the command this is a response to */
  commandId: string;
  serverTimestamp: Date | undefined;
  metadata:
    | Metadata
    | undefined;
  /** events that are the result of Commnds */
  payload:
    | //
    /** Knowledge Base */
    { $case: "createTopic"; value: KnowledgeBaseCreateTopic }
    | { $case: "updateTopic"; value: KnowledgeBaseUpdateTopic }
    | { $case: "deleteTopic"; value: KnowledgeBaseDeleteTopic }
    | { $case: "importTopics"; value: KnowledgeBaseImportTopics }
    | { $case: "toggleTopicStatus"; value: KnowledgeBaseToggleTopicStatus }
    | //
    /** SMS */
    { $case: "smsCreateTemplate"; value: SMSCreateTemplate }
    | { $case: "smsUpdateTemplate"; value: SMSUpdateTemplate }
    | { $case: "smsDeleteTemplate"; value: SMSDeleteTemplate }
    | //
    /** Handoff */
    { $case: "handoffCreate"; value: HandoffCreate }
    | { $case: "handoffUpdate"; value: HandoffUpdate }
    | { $case: "handoffDelete"; value: HandoffDelete }
    | { $case: "handoffSetDefault"; value: HandoffSetDefault }
    | { $case: "handoffResetHandoffConfigs"; value: HandoffResetHandoffConfigs }
    | //
    /** Flows */
    { $case: "createFlowStep"; value: FlowCreateStep }
    | { $case: "updateFlowStep"; value: FlowUpdateStep }
    | { $case: "deleteFlowStep"; value: FlowDeleteStep }
    | { $case: "updateFlowStepPosition"; value: FlowUpdateStepPosition }
    | { $case: "updateFlowStepPositions"; value: FlowUpdateStepPositions }
    | { $case: "updateFlowStepDtmfConfig"; value: FlowUpdateStepDtmfConfig }
    | { $case: "updateFlowStepAsrConfig"; value: FlowUpdateStepAsrConfig }
    | { $case: "createFlowTransitionFunction"; value: FlowCreateTransitionFunction }
    | { $case: "updateFlowTransitionFunction"; value: FlowUpdateTransitionFunction }
    | { $case: "deleteFlowTransitionFunction"; value: FlowDeleteTransitionFunction }
    | { $case: "deleteFlow"; value: FlowDeleteFlow }
    | { $case: "createFlow"; value: FlowCreateFlow }
    | { $case: "importFlow"; value: FlowImportFlow }
    | { $case: "updateFlow"; value: FlowUpdateFlow }
    | { $case: "updateFlowTransitionFunctionLatencyControl"; value: FlowUpdateTransitionFunctionLatencyControl }
    | //
    /** flows: no code steps */
    { $case: "createNoCodeStep"; value: CreateNoCodeStep }
    | { $case: "updateNoCodeStep"; value: UpdateNoCodeStep }
    | { $case: "deleteNoCodeStep"; value: DeleteNoCodeStep }
    | { $case: "updateNoCodeStepPosition"; value: UpdateNoCodeStepPosition }
    | { $case: "createNoCodeCondition"; value: CreateNoCodeCondition }
    | { $case: "deleteNoCodeCondition"; value: DeleteNoCodeCondition }
    | { $case: "updateNoCodeCondition"; value: UpdateNoCodeCondition }
    | { $case: "updateNoCodeConditionPosition"; value: UpdateNoCodeConditionPosition }
    | { $case: "updateNoCodeConditionExitFlowPosition"; value: UpdateNoCodeConditionExitFlowPosition }
    | //
    /** flows: generic commands (v2) */
    { $case: "moveFlowComponent"; value: MoveFlowComponent }
    | { $case: "moveFlowComponents"; value: MoveFlowComponents }
    | { $case: "createStep"; value: CreateStep }
    | { $case: "updateStep"; value: UpdateStep }
    | { $case: "deleteStep"; value: DeleteStep }
    | { $case: "createStepCondition"; value: CreateStepCondition }
    | { $case: "updateStepCondition"; value: UpdateStepCondition }
    | { $case: "deleteStepCondition"; value: DeleteStepCondition }
    | { $case: "updateStepConditionPosition"; value: UpdateStepConditionPosition }
    | //
    /** Variants */
    { $case: "variantCreateAttribute"; value: VariantCreateAttribute }
    | { $case: "variantUpdateAttribute"; value: VariantUpdateAttribute }
    | { $case: "variantDeleteAttribute"; value: VariantDeleteAttribute }
    | { $case: "variantCreateVariant"; value: VariantCreateVariant }
    | { $case: "variantUpdateVariant"; value: VariantUpdateVariant }
    | { $case: "variantDeleteVariant"; value: VariantDeleteVariant }
    | { $case: "variantSetDefaultVariant"; value: VariantSetDefaultVariant }
    | { $case: "variantImportVariants"; value: VariantImportVariants }
    | //
    /** Stop Keywords */
    { $case: "stopKeywordsCreate"; value: StopKeywordCreate }
    | { $case: "stopKeywordsUpdate"; value: StopKeywordUpdate }
    | { $case: "stopKeywordsDelete"; value: StopKeywordDelete }
    | //
    /** Project settings */
    { $case: "updateLlmSettings"; value: LLMSettingsUpdateLLMSettings }
    | { $case: "updateContentFilterSettings"; value: ContentFilterSettingsUpdateContentFilterSettings }
    | { $case: "updateAsrSettings"; value: ASRSettingsUpdateASRSettings }
    | { $case: "updateTtsSettings"; value: LanguagesUpdateDefaultLanguage }
    | { $case: "languagesUpdateDefaultLanguage"; value: LanguagesUpdateDefaultLanguage }
    | { $case: "languagesAddLanguage"; value: LanguagesAddLanguage }
    | { $case: "languagesDeleteLanguage"; value: LanguagesDeleteLanguage }
    | //
    /** Experimental Config */
    { $case: "experimentalConfigUpdateConfig"; value: ExperimentalConfigUpdateConfig }
    | //
    /** Pronunciations */
    { $case: "pronunciationsCreatePronunciation"; value: PronunciationsCreatePronunciation }
    | { $case: "pronunciationsUpdatePronunciation"; value: PronunciationsUpdatePronunciation }
    | { $case: "pronunciationsDeletePronunciation"; value: PronunciationsDeletePronunciation }
    | { $case: "pronunciationsReorderPronunciations"; value: PronunciationsReorderPronunciations }
    | //
    /** Transcript Corrections */
    { $case: "createTranscriptCorrections"; value: TranscriptCorrectionsCreateTranscriptCorrections }
    | { $case: "updateTranscriptCorrections"; value: TranscriptCorrectionsUpdateTranscriptCorrections }
    | { $case: "deleteTranscriptCorrections"; value: TranscriptCorrectionsDeleteTranscriptCorrections }
    | //
    /** Agent */
    { $case: "updateGreeting"; value: GreetingUpdateGreeting }
    | { $case: "updatePersonality"; value: PersonalityUpdatePersonality }
    | { $case: "updateRole"; value: RoleUpdateRole }
    | { $case: "updateDisclaimerMessage"; value: DisclaimerMessageUpdateDisclaimerMessage }
    | { $case: "updateRules"; value: RulesUpdateRules }
    | { $case: "updateLanguageBehavior"; value: LanguageBehaviorUpdateLanguageBehavior }
    | //
    /** Functions */
    { $case: "createFunction"; value: FunctionCreateFunction }
    | { $case: "updateFunction"; value: FunctionUpdateFunction }
    | { $case: "deleteFunction"; value: FunctionDeleteFunction }
    | { $case: "updateLatencyControl"; value: FunctionUpdateLatencyControl }
    | //
    /** Start function */
    { $case: "createStartFunction"; value: StartFunctionCreate }
    | { $case: "updateStartFunction"; value: StartFunctionUpdate }
    | { $case: "deleteStartFunction"; value: StartFunctionDelete }
    | //
    /** End function */
    { $case: "createEndFunction"; value: EndFunctionCreate }
    | { $case: "updateEndFunction"; value: EndFunctionUpdate }
    | { $case: "deleteEndFunction"; value: EndFunctionDelete }
    | //
    /** Keyphrase boosting */
    { $case: "createKeyphraseBoosting"; value: KeyphraseBoostingCreateKeyphrase }
    | { $case: "updateKeyphraseBoosting"; value: KeyphraseBoostingUpdateKeyphrase }
    | { $case: "deleteKeyphraseBoosting"; value: KeyphraseBoostingDeleteKeyphrase }
    | //
    /** Voice */
    { $case: "voiceAddAgentVoice"; value: VoiceAddAgentVoice }
    | { $case: "voiceDeleteAgentVoice"; value: VoiceDeleteAgentVoice }
    | { $case: "voiceUpdateAgentVoice"; value: VoiceUpdateAgentVoice }
    | { $case: "voiceCreateAgentVoiceSettings"; value: VoiceCreateAgentVoiceSettings }
    | { $case: "voiceUpdateAgentVoiceSettings"; value: VoiceUpdateAgentVoiceSettings }
    | { $case: "voiceUpdateDisclaimerVoice"; value: VoiceUpdateDisclaimerVoice }
    | { $case: "voiceCreateDisclaimerVoiceSettings"; value: VoiceCreateDisclaimerVoiceSettings }
    | { $case: "voiceUpdateDisclaimerVoiceSettings"; value: VoiceUpdateDisclaimerVoiceSettings }
    | { $case: "voiceAddFavoriteVoice"; value: VoiceAddFavoriteVoice }
    | { $case: "voiceRemoveFavoriteVoice"; value: VoiceRemoveFavoriteVoice }
    | //
    /** events that are not the result of Commands */
    { $case: "branchTriggerMerge"; value: BranchTriggerMerge }
    | { $case: "branchCreated"; value: BranchCreated }
    | { $case: "branchMerged"; value: BranchMerged }
    | { $case: "branchDeleted"; value: BranchDeleted }
    | { $case: "projectCreated"; value: ProjectCreated }
    | { $case: "projectLoadedFromJupiter"; value: ProjectLoadedFromJupiter }
    | { $case: "deploymentCompleted"; value: DeploymentCompleted }
    | { $case: "deploymentRollback"; value: DeploymentRollback }
    | //
    /** Entities (for entity extraction) */
    { $case: "entityCreate"; value: EntityCreate }
    | { $case: "entityUpdate"; value: EntityUpdate }
    | { $case: "entityDelete"; value: EntityDelete }
    | //
    /** Variables */
    { $case: "variableCreate"; value: VariableCreate }
    | { $case: "variableUpdate"; value: VariableUpdate }
    | { $case: "variableDelete"; value: VariableDelete }
    | { $case: "functionDeploymentCompleted"; value: FunctionDeploymentCompleted }
    | //
    /** API Integrations: fields 300 - 350 */
    { $case: "createApiIntegration"; value: ApiIntegrationCreate }
    | { $case: "updateApiIntegration"; value: ApiIntegrationUpdate }
    | { $case: "deleteApiIntegration"; value: ApiIntegrationDelete }
    | { $case: "updateApiIntegrationConfig"; value: ApiIntegrationConfigUpdate }
    | { $case: "createApiIntegrationOperation"; value: ApiIntegrationOperationCreate }
    | { $case: "updateApiIntegrationOperation"; value: ApiIntegrationOperationUpdate }
    | { $case: "deleteApiIntegrationOperation"; value: ApiIntegrationOperationDelete }
    | //
    /** Language Hub Translations */
    { $case: "createTranslation"; value: LanguageHubTranslationsCreate }
    | { $case: "updateTranslation"; value: LanguageHubTranslationsUpdate }
    | { $case: "deleteTranslation"; value: LanguageHubTranslationsDelete }
    | //
    /** Channels - Voice */
    { $case: "voiceChannelUpdateAsrSettings"; value: VoiceChannelUpdateASRSettings }
    | { $case: "voiceChannelUpdateDisclaimer"; value: VoiceChannelUpdateDisclaimer }
    | { $case: "voiceChannelUpdateVadConfig"; value: VoiceChannelUpdateVadConfig }
    | { $case: "voiceChannelUpdateAudioEnhancement"; value: VoiceChannelUpdateAudioEnhancement }
    | { $case: "voiceChannelUpdateSilenceFillerUtterances"; value: VoiceChannelUpdateSilenceFillerUtterances }
    | { $case: "voiceChannelUpdateAsrConfig"; value: VoiceChannelUpdateAsrConfig }
    | { $case: "voiceChannelUpdateBargeInConfig"; value: VoiceChannelUpdateBargeInConfig }
    | { $case: "voiceChannelUpdateTemperature"; value: VoiceChannelUpdateTemperature }
    | { $case: "voiceChannelResetBargeInConfig"; value: VoiceChannelResetBargeInConfig }
    | { $case: "voiceChannelResetTemperature"; value: VoiceChannelResetTemperature }
    | { $case: "voiceChannelResetVadConfig"; value: VoiceChannelResetVadConfig }
    | { $case: "voiceChannelResetAudioEnhancement"; value: VoiceChannelResetAudioEnhancement }
    | { $case: "voiceChannelResetSilenceFillerUtterances"; value: VoiceChannelResetSilenceFillerUtterances }
    | { $case: "voiceChannelResetAsrConfig"; value: VoiceChannelResetAsrConfig }
    | //
    /** Channels - Shared config */
    { $case: "channelUpdateGreeting"; value: ChannelUpdateGreeting }
    | { $case: "channelUpdateStylePrompt"; value: ChannelUpdateStylePrompt }
    | { $case: "channelUpdateSafetyFilters"; value: ChannelUpdateSafetyFilters }
    | { $case: "channelUpdateLlmSettings"; value: ChannelUpdateLLMSettings }
    | { $case: "channelUpdateStatus"; value: ChannelUpdateStatus }
    | //
    /** CSAT */
    { $case: "csatUpdateConfig"; value: CSATUpdateConfig }
    | //
    /** Integrations */
    { $case: "connectIntegration"; value: IntegrationConnect }
    | { $case: "enableIntegration"; value: IntegrationEnable }
    | { $case: "disableIntegration"; value: IntegrationDisable }
    | { $case: "updateIntegrationFunctions"; value: IntegrationUpdateFunctions }
    | { $case: "disconnectIntegration"; value: IntegrationDisconnect }
    | //
    /** MCP Config */
    { $case: "updateMcpConfig"; value: MCPConfigUpdate }
    | undefined;
}

export interface EventBatch {
  events: Event[];
}

/** a message only sent to client to catch up to the current state; not persisted */
export interface SetProjection {
  sequence: Long;
  /** json representation of the redux state */
  projection: Uint8Array;
  serverTimestamp: Date | undefined;
}

export interface SocketError {
  message: string;
}

/** type for messages the client receives over websocket */
export interface Envelope {
  message:
    | { $case: "eventBatch"; value: EventBatch }
    | { $case: "setProjection"; value: SetProjection }
    | { $case: "notification"; value: Notification }
    | { $case: "error"; value: SocketError }
    | undefined;
}

/**
 * for things the client needs to know about that are not persisted in the event
 * history
 */
export interface Notification {
  type: string;
  payload:
    | { $case: "branchCreated"; value: BranchCreated }
    | { $case: "branchMerged"; value: BranchMerged }
    | { $case: "branchDeleted"; value: BranchDeleted }
    | { $case: "branchTriggerMerge"; value: BranchTriggerMerge }
    | undefined;
}

/**
 * type for commands the client sends using HTTP POST
 * NOTE: next available field is 60
 */
export interface Command {
  type: string;
  /** UUID for the command being issued */
  metadata: Metadata | undefined;
  commandId: string;
  payload:
    | //
    /** Knowledge base */
    { $case: "createTopic"; value: KnowledgeBaseCreateTopic }
    | { $case: "updateTopic"; value: KnowledgeBaseUpdateTopic }
    | { $case: "deleteTopic"; value: KnowledgeBaseDeleteTopic }
    | { $case: "importTopics"; value: KnowledgeBaseImportTopics }
    | { $case: "toggleTopicStatus"; value: KnowledgeBaseToggleTopicStatus }
    | //
    /** SMS */
    { $case: "smsCreateTemplate"; value: SMSCreateTemplate }
    | { $case: "smsUpdateTemplate"; value: SMSUpdateTemplate }
    | { $case: "smsDeleteTemplate"; value: SMSDeleteTemplate }
    | //
    /** Handoff */
    { $case: "handoffCreate"; value: HandoffCreate }
    | { $case: "handoffUpdate"; value: HandoffUpdate }
    | { $case: "handoffDelete"; value: HandoffDelete }
    | { $case: "handoffSetDefault"; value: HandoffSetDefault }
    | { $case: "handoffResetHandoffConfigs"; value: HandoffResetHandoffConfigs }
    | //
    /** Variant */
    { $case: "variantCreateAttribute"; value: VariantCreateAttribute }
    | { $case: "variantUpdateAttribute"; value: VariantUpdateAttribute }
    | { $case: "variantDeleteAttribute"; value: VariantDeleteAttribute }
    | { $case: "variantCreateVariant"; value: VariantCreateVariant }
    | { $case: "variantUpdateVariant"; value: VariantUpdateVariant }
    | { $case: "variantDeleteVariant"; value: VariantDeleteVariant }
    | { $case: "variantSetDefaultVariant"; value: VariantSetDefaultVariant }
    | { $case: "variantImportVariants"; value: VariantImportVariants }
    | //
    /** Stop Keywords */
    { $case: "stopKeywordsCreate"; value: StopKeywordCreate }
    | { $case: "stopKeywordsUpdate"; value: StopKeywordUpdate }
    | { $case: "stopKeywordsDelete"; value: StopKeywordDelete }
    | //
    /** Project settings */
    { $case: "updateLlmSettings"; value: LLMSettingsUpdateLLMSettings }
    | { $case: "updateContentFilterSettings"; value: ContentFilterSettingsUpdateContentFilterSettings }
    | { $case: "updateAsrSettings"; value: ASRSettingsUpdateASRSettings }
    | { $case: "updateTtsSettings"; value: LanguagesUpdateDefaultLanguage }
    | { $case: "languagesUpdateDefaultLanguage"; value: LanguagesUpdateDefaultLanguage }
    | { $case: "languagesAddLanguage"; value: LanguagesAddLanguage }
    | { $case: "languagesDeleteLanguage"; value: LanguagesDeleteLanguage }
    | //
    /** Experimental Config */
    { $case: "experimentalConfigUpdateConfig"; value: ExperimentalConfigUpdateConfig }
    | //
    /** Pronunciations */
    { $case: "pronunciationsCreatePronunciation"; value: PronunciationsCreatePronunciation }
    | { $case: "pronunciationsUpdatePronunciation"; value: PronunciationsUpdatePronunciation }
    | { $case: "pronunciationsDeletePronunciation"; value: PronunciationsDeletePronunciation }
    | { $case: "pronunciationsReorderPronunciations"; value: PronunciationsReorderPronunciations }
    | //
    /** Transcript Corrections */
    { $case: "createTranscriptCorrections"; value: TranscriptCorrectionsCreateTranscriptCorrections }
    | { $case: "updateTranscriptCorrections"; value: TranscriptCorrectionsUpdateTranscriptCorrections }
    | { $case: "deleteTranscriptCorrections"; value: TranscriptCorrectionsDeleteTranscriptCorrections }
    | //
    /** Agent */
    { $case: "updateGreeting"; value: GreetingUpdateGreeting }
    | { $case: "updatePersonality"; value: PersonalityUpdatePersonality }
    | { $case: "updateRole"; value: RoleUpdateRole }
    | { $case: "updateDisclaimerMessage"; value: DisclaimerMessageUpdateDisclaimerMessage }
    | { $case: "updateRules"; value: RulesUpdateRules }
    | { $case: "updateLanguageBehavior"; value: LanguageBehaviorUpdateLanguageBehavior }
    | //
    /** Functions */
    { $case: "createFunction"; value: FunctionCreateFunction }
    | { $case: "updateFunction"; value: FunctionUpdateFunction }
    | { $case: "deleteFunction"; value: FunctionDeleteFunction }
    | { $case: "updateLatencyControl"; value: FunctionUpdateLatencyControl }
    | //
    /** Start function */
    { $case: "createStartFunction"; value: StartFunctionCreate }
    | { $case: "updateStartFunction"; value: StartFunctionUpdate }
    | { $case: "deleteStartFunction"; value: StartFunctionDelete }
    | //
    /** End function */
    { $case: "createEndFunction"; value: EndFunctionCreate }
    | { $case: "updateEndFunction"; value: EndFunctionUpdate }
    | { $case: "deleteEndFunction"; value: EndFunctionDelete }
    | //
    /** Voice */
    { $case: "voiceAddAgentVoice"; value: VoiceAddAgentVoice }
    | { $case: "voiceDeleteAgentVoice"; value: VoiceDeleteAgentVoice }
    | { $case: "voiceUpdateAgentVoice"; value: VoiceUpdateAgentVoice }
    | { $case: "voiceCreateAgentVoiceSettings"; value: VoiceCreateAgentVoiceSettings }
    | { $case: "voiceUpdateAgentVoiceSettings"; value: VoiceUpdateAgentVoiceSettings }
    | { $case: "voiceUpdateDisclaimerVoice"; value: VoiceUpdateDisclaimerVoice }
    | { $case: "voiceCreateDisclaimerVoiceSettings"; value: VoiceCreateDisclaimerVoiceSettings }
    | { $case: "voiceUpdateDisclaimerVoiceSettings"; value: VoiceUpdateDisclaimerVoiceSettings }
    | { $case: "voiceAddFavoriteVoice"; value: VoiceAddFavoriteVoice }
    | { $case: "voiceRemoveFavoriteVoice"; value: VoiceRemoveFavoriteVoice }
    | //
    /** Entities (for entity extraction) */
    { $case: "entityCreate"; value: EntityCreate }
    | { $case: "entityUpdate"; value: EntityUpdate }
    | { $case: "entityDelete"; value: EntityDelete }
    | //
    /** Variables */
    { $case: "variableCreate"; value: VariableCreate }
    | { $case: "variableUpdate"; value: VariableUpdate }
    | { $case: "variableDelete"; value: VariableDelete }
    | //
    /** Flows */
    { $case: "createFlowStep"; value: FlowCreateStep }
    | { $case: "updateFlowStep"; value: FlowUpdateStep }
    | { $case: "deleteFlowStep"; value: FlowDeleteStep }
    | { $case: "updateFlowStepPosition"; value: FlowUpdateStepPosition }
    | { $case: "updateFlowStepPositions"; value: FlowUpdateStepPositions }
    | { $case: "updateFlowStepDtmfConfig"; value: FlowUpdateStepDtmfConfig }
    | { $case: "updateFlowStepAsrConfig"; value: FlowUpdateStepAsrConfig }
    | { $case: "createFlowTransitionFunction"; value: FlowCreateTransitionFunction }
    | { $case: "updateFlowTransitionFunction"; value: FlowUpdateTransitionFunction }
    | { $case: "deleteFlowTransitionFunction"; value: FlowDeleteTransitionFunction }
    | { $case: "deleteFlow"; value: FlowDeleteFlow }
    | { $case: "createFlow"; value: FlowCreateFlow }
    | { $case: "importFlow"; value: FlowImportFlow }
    | { $case: "updateFlow"; value: FlowUpdateFlow }
    | { $case: "updateFlowTransitionFunctionLatencyControl"; value: FlowUpdateTransitionFunctionLatencyControl }
    | //
    /** Flows: NoCode Steps */
    { $case: "createNoCodeStep"; value: CreateNoCodeStep }
    | { $case: "updateNoCodeStep"; value: UpdateNoCodeStep }
    | { $case: "deleteNoCodeStep"; value: DeleteNoCodeStep }
    | { $case: "updateNoCodeStepPosition"; value: UpdateNoCodeStepPosition }
    | { $case: "createNoCodeCondition"; value: CreateNoCodeCondition }
    | { $case: "deleteNoCodeCondition"; value: DeleteNoCodeCondition }
    | { $case: "updateNoCodeCondition"; value: UpdateNoCodeCondition }
    | { $case: "updateNoCodeConditionPosition"; value: UpdateNoCodeConditionPosition }
    | { $case: "updateNoCodeConditionExitFlowPosition"; value: UpdateNoCodeConditionExitFlowPosition }
    | { $case: "moveFlowComponent"; value: MoveFlowComponent }
    | { $case: "moveFlowComponents"; value: MoveFlowComponents }
    | { $case: "createStep"; value: CreateStep }
    | { $case: "updateStep"; value: UpdateStep }
    | { $case: "deleteStep"; value: DeleteStep }
    | { $case: "createStepCondition"; value: CreateStepCondition }
    | { $case: "updateStepCondition"; value: UpdateStepCondition }
    | { $case: "deleteStepCondition"; value: DeleteStepCondition }
    | { $case: "updateStepConditionPosition"; value: UpdateStepConditionPosition }
    | //
    /** Keyphrase boosting */
    { $case: "createKeyphraseBoosting"; value: KeyphraseBoostingCreateKeyphrase }
    | { $case: "updateKeyphraseBoosting"; value: KeyphraseBoostingUpdateKeyphrase }
    | { $case: "deleteKeyphraseBoosting"; value: KeyphraseBoostingDeleteKeyphrase }
    | //
    /** Api Integrations: fields 300 - 350 */
    { $case: "createApiIntegration"; value: ApiIntegrationCreate }
    | { $case: "updateApiIntegration"; value: ApiIntegrationUpdate }
    | { $case: "deleteApiIntegration"; value: ApiIntegrationDelete }
    | { $case: "updateApiIntegrationConfig"; value: ApiIntegrationConfigUpdate }
    | { $case: "createApiIntegrationOperation"; value: ApiIntegrationOperationCreate }
    | { $case: "updateApiIntegrationOperation"; value: ApiIntegrationOperationUpdate }
    | { $case: "deleteApiIntegrationOperation"; value: ApiIntegrationOperationDelete }
    | //
    /** Language Hub Translations */
    { $case: "createTranslation"; value: LanguageHubTranslationsCreate }
    | { $case: "updateTranslation"; value: LanguageHubTranslationsUpdate }
    | { $case: "deleteTranslation"; value: LanguageHubTranslationsDelete }
    | //
    /** Channels - Voice */
    { $case: "voiceChannelUpdateAsrSettings"; value: VoiceChannelUpdateASRSettings }
    | { $case: "voiceChannelUpdateDisclaimer"; value: VoiceChannelUpdateDisclaimer }
    | { $case: "voiceChannelUpdateBargeInConfig"; value: VoiceChannelUpdateBargeInConfig }
    | { $case: "voiceChannelUpdateTemperature"; value: VoiceChannelUpdateTemperature }
    | { $case: "voiceChannelResetBargeInConfig"; value: VoiceChannelResetBargeInConfig }
    | { $case: "voiceChannelResetTemperature"; value: VoiceChannelResetTemperature }
    | { $case: "voiceChannelResetVadConfig"; value: VoiceChannelResetVadConfig }
    | { $case: "voiceChannelResetAudioEnhancement"; value: VoiceChannelResetAudioEnhancement }
    | { $case: "voiceChannelResetSilenceFillerUtterances"; value: VoiceChannelResetSilenceFillerUtterances }
    | { $case: "voiceChannelResetAsrConfig"; value: VoiceChannelResetAsrConfig }
    | //
    /** Channels - Shared config */
    { $case: "channelUpdateGreeting"; value: ChannelUpdateGreeting }
    | { $case: "channelUpdateStylePrompt"; value: ChannelUpdateStylePrompt }
    | { $case: "channelUpdateSafetyFilters"; value: ChannelUpdateSafetyFilters }
    | { $case: "channelUpdateLlmSettings"; value: ChannelUpdateLLMSettings }
    | { $case: "channelUpdateStatus"; value: ChannelUpdateStatus }
    | { $case: "voiceChannelUpdateVadConfig"; value: VoiceChannelUpdateVadConfig }
    | { $case: "voiceChannelUpdateAudioEnhancement"; value: VoiceChannelUpdateAudioEnhancement }
    | { $case: "voiceChannelUpdateSilenceFillerUtterances"; value: VoiceChannelUpdateSilenceFillerUtterances }
    | { $case: "voiceChannelUpdateAsrConfig"; value: VoiceChannelUpdateAsrConfig }
    | //
    /** csat */
    { $case: "csatUpdateConfig"; value: CSATUpdateConfig }
    | //
    /** Integrations */
    { $case: "connectIntegration"; value: IntegrationConnect }
    | { $case: "enableIntegration"; value: IntegrationEnable }
    | { $case: "disableIntegration"; value: IntegrationDisable }
    | { $case: "updateIntegrationFunctions"; value: IntegrationUpdateFunctions }
    | { $case: "disconnectIntegration"; value: IntegrationDisconnect }
    | //
    /** MCP Config */
    { $case: "updateMcpConfig"; value: MCPConfigUpdate }
    | undefined;
}

export interface CommandBatch {
  lastKnownSequence: Long;
  commands: Command[];
}

/**
 * creating a draft is done with a specific POST request, so this message only
 * shows up as an Event
 */
export interface BranchCreated {
  id: string;
  createdAt: Date | undefined;
  createdBy: string;
  snapshotKey: string;
}

/**
 * merging a draft is done with a specific POST request, so this message only
 * shows up as an Event unlike other operations, merging a draft is not applied
 * optimistically on the client side.
 */
export interface BranchTriggerMerge {
  branchId: string;
  userTimestamp:
    | Date
    | undefined;
  /** user ID of who triggered the merge */
  triggeredBy: string;
}

export interface ConflictResolution {
  path: string[];
  strategy: ResolutionStrategy;
  value?: { [key: string]: any } | undefined;
}

/**
 * this event shows up on both the draft and the main branch
 * it includes the snapshot ID, so it provides an explicit
 * checkpoint when looking back through the event history
 */
export interface BranchMerged {
  branchId: string;
  mergedAt: Date | undefined;
  mergedBy: string;
  /** the sequence number of the event on the main branch */
  mainSequence: Long;
  /** the ID of the saved snapshot that was created as a result of the merge */
  snapshotKey: string;
  resolutions: ConflictResolution[];
}

export interface BranchDeleted {
  branchId: string;
  deletedAt: Date | undefined;
  deletedBy: string;
}

/**
 * event that shows up at the beginning of the main branch, when the project is
 * created by sourcerer
 */
export interface ProjectCreated {
  createdAt: Date | undefined;
  createdBy: string;
  name: string;
  snapshotKey: string;
}

/**
 * event that shows up at the beginning of the main branch, when the project is
 * loaded from Jupiter
 */
export interface ProjectLoadedFromJupiter {
  loadedAt: Date | undefined;
  artifactVersion: string;
  ragKbVersion: string;
  snapshotKey: string;
}

export interface DeploymentCompleted {
  branchId: string;
  /**
   * will always be "sandbox" for branch_id = "main" and "draft" for any other
   * draft
   */
  clientEnv: string;
  snapshotKey: string;
  artifactVersion: string;
  ragKbVersion: string;
  functionDeploymentVersion: string;
  /** the aws lambda identifier */
  lambdaDeploymentVersion: string;
  /** the user-facing hash of the deployment */
  versionHash: string;
}

/**
 * event that shows up when user rolls back sandbox to a previous deployment
 * rolling back client_env other than sandbox does not show up as an event
 */
export interface DeploymentRollback {
  branchId: string;
  snapshotKey: string;
  artifactVersion: string;
  ragKbVersion: string;
  functionDeploymentVersion: string;
  versionHash: string;
}

export interface LoadedFromBundle {
  snapshotKey: string;
}

export interface FunctionDeploymentCompleted {
  branchId: string;
  snapshotKey: string;
  functionDeploymentId: string;
  lambdaDeploymentVersion: string;
}

function createBaseMetadata(): Metadata {
  return { createdAt: undefined, createdBy: "" };
}

export const Metadata: MessageFns<Metadata> = {
  encode(message: Metadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(34).string(message.createdBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Metadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Metadata {
    return {
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
    };
  },

  toJSON(message: Metadata): unknown {
    const obj: any = {};
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    return obj;
  },

  create(base?: DeepPartial<Metadata>): Metadata {
    return Metadata.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Metadata>): Metadata {
    const message = createBaseMetadata();
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    return message;
  },
};

function createBaseEvent(): Event {
  return { sequence: Long.UZERO, commandId: "", serverTimestamp: undefined, metadata: undefined, payload: undefined };
}

export const Event: MessageFns<Event> = {
  encode(message: Event, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (!message.sequence.equals(Long.UZERO)) {
      writer.uint32(8).uint64(message.sequence.toString());
    }
    if (message.commandId !== "") {
      writer.uint32(18).string(message.commandId);
    }
    if (message.serverTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.serverTimestamp), writer.uint32(26).fork()).join();
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(1602).fork()).join();
    }
    switch (message.payload?.$case) {
      case "createTopic":
        KnowledgeBaseCreateTopic.encode(message.payload.value, writer.uint32(34).fork()).join();
        break;
      case "updateTopic":
        KnowledgeBaseUpdateTopic.encode(message.payload.value, writer.uint32(42).fork()).join();
        break;
      case "deleteTopic":
        KnowledgeBaseDeleteTopic.encode(message.payload.value, writer.uint32(50).fork()).join();
        break;
      case "importTopics":
        KnowledgeBaseImportTopics.encode(message.payload.value, writer.uint32(946).fork()).join();
        break;
      case "toggleTopicStatus":
        KnowledgeBaseToggleTopicStatus.encode(message.payload.value, writer.uint32(954).fork()).join();
        break;
      case "smsCreateTemplate":
        SMSCreateTemplate.encode(message.payload.value, writer.uint32(58).fork()).join();
        break;
      case "smsUpdateTemplate":
        SMSUpdateTemplate.encode(message.payload.value, writer.uint32(66).fork()).join();
        break;
      case "smsDeleteTemplate":
        SMSDeleteTemplate.encode(message.payload.value, writer.uint32(74).fork()).join();
        break;
      case "handoffCreate":
        HandoffCreate.encode(message.payload.value, writer.uint32(82).fork()).join();
        break;
      case "handoffUpdate":
        HandoffUpdate.encode(message.payload.value, writer.uint32(90).fork()).join();
        break;
      case "handoffDelete":
        HandoffDelete.encode(message.payload.value, writer.uint32(98).fork()).join();
        break;
      case "handoffSetDefault":
        HandoffSetDefault.encode(message.payload.value, writer.uint32(370).fork()).join();
        break;
      case "handoffResetHandoffConfigs":
        HandoffResetHandoffConfigs.encode(message.payload.value, writer.uint32(578).fork()).join();
        break;
      case "createFlowStep":
        FlowCreateStep.encode(message.payload.value, writer.uint32(802).fork()).join();
        break;
      case "updateFlowStep":
        FlowUpdateStep.encode(message.payload.value, writer.uint32(810).fork()).join();
        break;
      case "deleteFlowStep":
        FlowDeleteStep.encode(message.payload.value, writer.uint32(818).fork()).join();
        break;
      case "updateFlowStepPosition":
        FlowUpdateStepPosition.encode(message.payload.value, writer.uint32(826).fork()).join();
        break;
      case "updateFlowStepPositions":
        FlowUpdateStepPositions.encode(message.payload.value, writer.uint32(834).fork()).join();
        break;
      case "updateFlowStepDtmfConfig":
        FlowUpdateStepDtmfConfig.encode(message.payload.value, writer.uint32(842).fork()).join();
        break;
      case "updateFlowStepAsrConfig":
        FlowUpdateStepAsrConfig.encode(message.payload.value, writer.uint32(850).fork()).join();
        break;
      case "createFlowTransitionFunction":
        FlowCreateTransitionFunction.encode(message.payload.value, writer.uint32(858).fork()).join();
        break;
      case "updateFlowTransitionFunction":
        FlowUpdateTransitionFunction.encode(message.payload.value, writer.uint32(866).fork()).join();
        break;
      case "deleteFlowTransitionFunction":
        FlowDeleteTransitionFunction.encode(message.payload.value, writer.uint32(874).fork()).join();
        break;
      case "deleteFlow":
        FlowDeleteFlow.encode(message.payload.value, writer.uint32(882).fork()).join();
        break;
      case "createFlow":
        FlowCreateFlow.encode(message.payload.value, writer.uint32(890).fork()).join();
        break;
      case "importFlow":
        FlowImportFlow.encode(message.payload.value, writer.uint32(898).fork()).join();
        break;
      case "updateFlow":
        FlowUpdateFlow.encode(message.payload.value, writer.uint32(906).fork()).join();
        break;
      case "updateFlowTransitionFunctionLatencyControl":
        FlowUpdateTransitionFunctionLatencyControl.encode(message.payload.value, writer.uint32(914).fork()).join();
        break;
      case "createNoCodeStep":
        CreateNoCodeStep.encode(message.payload.value, writer.uint32(1714).fork()).join();
        break;
      case "updateNoCodeStep":
        UpdateNoCodeStep.encode(message.payload.value, writer.uint32(1722).fork()).join();
        break;
      case "deleteNoCodeStep":
        DeleteNoCodeStep.encode(message.payload.value, writer.uint32(1730).fork()).join();
        break;
      case "updateNoCodeStepPosition":
        UpdateNoCodeStepPosition.encode(message.payload.value, writer.uint32(1738).fork()).join();
        break;
      case "createNoCodeCondition":
        CreateNoCodeCondition.encode(message.payload.value, writer.uint32(1746).fork()).join();
        break;
      case "deleteNoCodeCondition":
        DeleteNoCodeCondition.encode(message.payload.value, writer.uint32(1754).fork()).join();
        break;
      case "updateNoCodeCondition":
        UpdateNoCodeCondition.encode(message.payload.value, writer.uint32(1762).fork()).join();
        break;
      case "updateNoCodeConditionPosition":
        UpdateNoCodeConditionPosition.encode(message.payload.value, writer.uint32(1770).fork()).join();
        break;
      case "updateNoCodeConditionExitFlowPosition":
        UpdateNoCodeConditionExitFlowPosition.encode(message.payload.value, writer.uint32(1778).fork()).join();
        break;
      case "moveFlowComponent":
        MoveFlowComponent.encode(message.payload.value, writer.uint32(1786).fork()).join();
        break;
      case "moveFlowComponents":
        MoveFlowComponents.encode(message.payload.value, writer.uint32(1794).fork()).join();
        break;
      case "createStep":
        CreateStep.encode(message.payload.value, writer.uint32(2458).fork()).join();
        break;
      case "updateStep":
        UpdateStep.encode(message.payload.value, writer.uint32(2466).fork()).join();
        break;
      case "deleteStep":
        DeleteStep.encode(message.payload.value, writer.uint32(2474).fork()).join();
        break;
      case "createStepCondition":
        CreateStepCondition.encode(message.payload.value, writer.uint32(2482).fork()).join();
        break;
      case "updateStepCondition":
        UpdateStepCondition.encode(message.payload.value, writer.uint32(2490).fork()).join();
        break;
      case "deleteStepCondition":
        DeleteStepCondition.encode(message.payload.value, writer.uint32(2498).fork()).join();
        break;
      case "updateStepConditionPosition":
        UpdateStepConditionPosition.encode(message.payload.value, writer.uint32(2506).fork()).join();
        break;
      case "variantCreateAttribute":
        VariantCreateAttribute.encode(message.payload.value, writer.uint32(146).fork()).join();
        break;
      case "variantUpdateAttribute":
        VariantUpdateAttribute.encode(message.payload.value, writer.uint32(154).fork()).join();
        break;
      case "variantDeleteAttribute":
        VariantDeleteAttribute.encode(message.payload.value, writer.uint32(162).fork()).join();
        break;
      case "variantCreateVariant":
        VariantCreateVariant.encode(message.payload.value, writer.uint32(170).fork()).join();
        break;
      case "variantUpdateVariant":
        VariantUpdateVariant.encode(message.payload.value, writer.uint32(178).fork()).join();
        break;
      case "variantDeleteVariant":
        VariantDeleteVariant.encode(message.payload.value, writer.uint32(186).fork()).join();
        break;
      case "variantSetDefaultVariant":
        VariantSetDefaultVariant.encode(message.payload.value, writer.uint32(194).fork()).join();
        break;
      case "variantImportVariants":
        VariantImportVariants.encode(message.payload.value, writer.uint32(402).fork()).join();
        break;
      case "stopKeywordsCreate":
        StopKeywordCreate.encode(message.payload.value, writer.uint32(202).fork()).join();
        break;
      case "stopKeywordsUpdate":
        StopKeywordUpdate.encode(message.payload.value, writer.uint32(210).fork()).join();
        break;
      case "stopKeywordsDelete":
        StopKeywordDelete.encode(message.payload.value, writer.uint32(218).fork()).join();
        break;
      case "updateLlmSettings":
        LLMSettingsUpdateLLMSettings.encode(message.payload.value, writer.uint32(226).fork()).join();
        break;
      case "updateContentFilterSettings":
        ContentFilterSettingsUpdateContentFilterSettings.encode(message.payload.value, writer.uint32(234).fork())
          .join();
        break;
      case "updateAsrSettings":
        ASRSettingsUpdateASRSettings.encode(message.payload.value, writer.uint32(242).fork()).join();
        break;
      case "updateTtsSettings":
        LanguagesUpdateDefaultLanguage.encode(message.payload.value, writer.uint32(250).fork()).join();
        break;
      case "languagesUpdateDefaultLanguage":
        LanguagesUpdateDefaultLanguage.encode(message.payload.value, writer.uint32(1826).fork()).join();
        break;
      case "languagesAddLanguage":
        LanguagesAddLanguage.encode(message.payload.value, writer.uint32(1834).fork()).join();
        break;
      case "languagesDeleteLanguage":
        LanguagesDeleteLanguage.encode(message.payload.value, writer.uint32(1842).fork()).join();
        break;
      case "experimentalConfigUpdateConfig":
        ExperimentalConfigUpdateConfig.encode(message.payload.value, writer.uint32(258).fork()).join();
        break;
      case "pronunciationsCreatePronunciation":
        PronunciationsCreatePronunciation.encode(message.payload.value, writer.uint32(266).fork()).join();
        break;
      case "pronunciationsUpdatePronunciation":
        PronunciationsUpdatePronunciation.encode(message.payload.value, writer.uint32(274).fork()).join();
        break;
      case "pronunciationsDeletePronunciation":
        PronunciationsDeletePronunciation.encode(message.payload.value, writer.uint32(282).fork()).join();
        break;
      case "pronunciationsReorderPronunciations":
        PronunciationsReorderPronunciations.encode(message.payload.value, writer.uint32(2922).fork()).join();
        break;
      case "createTranscriptCorrections":
        TranscriptCorrectionsCreateTranscriptCorrections.encode(message.payload.value, writer.uint32(298).fork())
          .join();
        break;
      case "updateTranscriptCorrections":
        TranscriptCorrectionsUpdateTranscriptCorrections.encode(message.payload.value, writer.uint32(306).fork())
          .join();
        break;
      case "deleteTranscriptCorrections":
        TranscriptCorrectionsDeleteTranscriptCorrections.encode(message.payload.value, writer.uint32(314).fork())
          .join();
        break;
      case "updateGreeting":
        GreetingUpdateGreeting.encode(message.payload.value, writer.uint32(322).fork()).join();
        break;
      case "updatePersonality":
        PersonalityUpdatePersonality.encode(message.payload.value, writer.uint32(330).fork()).join();
        break;
      case "updateRole":
        RoleUpdateRole.encode(message.payload.value, writer.uint32(338).fork()).join();
        break;
      case "updateDisclaimerMessage":
        DisclaimerMessageUpdateDisclaimerMessage.encode(message.payload.value, writer.uint32(346).fork()).join();
        break;
      case "updateRules":
        RulesUpdateRules.encode(message.payload.value, writer.uint32(354).fork()).join();
        break;
      case "updateLanguageBehavior":
        LanguageBehaviorUpdateLanguageBehavior.encode(message.payload.value, writer.uint32(570).fork()).join();
        break;
      case "createFunction":
        FunctionCreateFunction.encode(message.payload.value, writer.uint32(362).fork()).join();
        break;
      case "updateFunction":
        FunctionUpdateFunction.encode(message.payload.value, writer.uint32(386).fork()).join();
        break;
      case "deleteFunction":
        FunctionDeleteFunction.encode(message.payload.value, writer.uint32(394).fork()).join();
        break;
      case "updateLatencyControl":
        FunctionUpdateLatencyControl.encode(message.payload.value, writer.uint32(474).fork()).join();
        break;
      case "createStartFunction":
        StartFunctionCreate.encode(message.payload.value, writer.uint32(482).fork()).join();
        break;
      case "updateStartFunction":
        StartFunctionUpdate.encode(message.payload.value, writer.uint32(490).fork()).join();
        break;
      case "deleteStartFunction":
        StartFunctionDelete.encode(message.payload.value, writer.uint32(522).fork()).join();
        break;
      case "createEndFunction":
        EndFunctionCreate.encode(message.payload.value, writer.uint32(498).fork()).join();
        break;
      case "updateEndFunction":
        EndFunctionUpdate.encode(message.payload.value, writer.uint32(506).fork()).join();
        break;
      case "deleteEndFunction":
        EndFunctionDelete.encode(message.payload.value, writer.uint32(530).fork()).join();
        break;
      case "createKeyphraseBoosting":
        KeyphraseBoostingCreateKeyphrase.encode(message.payload.value, writer.uint32(922).fork()).join();
        break;
      case "updateKeyphraseBoosting":
        KeyphraseBoostingUpdateKeyphrase.encode(message.payload.value, writer.uint32(930).fork()).join();
        break;
      case "deleteKeyphraseBoosting":
        KeyphraseBoostingDeleteKeyphrase.encode(message.payload.value, writer.uint32(938).fork()).join();
        break;
      case "voiceAddAgentVoice":
        VoiceAddAgentVoice.encode(message.payload.value, writer.uint32(410).fork()).join();
        break;
      case "voiceDeleteAgentVoice":
        VoiceDeleteAgentVoice.encode(message.payload.value, writer.uint32(418).fork()).join();
        break;
      case "voiceUpdateAgentVoice":
        VoiceUpdateAgentVoice.encode(message.payload.value, writer.uint32(426).fork()).join();
        break;
      case "voiceCreateAgentVoiceSettings":
        VoiceCreateAgentVoiceSettings.encode(message.payload.value, writer.uint32(434).fork()).join();
        break;
      case "voiceUpdateAgentVoiceSettings":
        VoiceUpdateAgentVoiceSettings.encode(message.payload.value, writer.uint32(442).fork()).join();
        break;
      case "voiceUpdateDisclaimerVoice":
        VoiceUpdateDisclaimerVoice.encode(message.payload.value, writer.uint32(450).fork()).join();
        break;
      case "voiceCreateDisclaimerVoiceSettings":
        VoiceCreateDisclaimerVoiceSettings.encode(message.payload.value, writer.uint32(458).fork()).join();
        break;
      case "voiceUpdateDisclaimerVoiceSettings":
        VoiceUpdateDisclaimerVoiceSettings.encode(message.payload.value, writer.uint32(466).fork()).join();
        break;
      case "voiceAddFavoriteVoice":
        VoiceAddFavoriteVoice.encode(message.payload.value, writer.uint32(962).fork()).join();
        break;
      case "voiceRemoveFavoriteVoice":
        VoiceRemoveFavoriteVoice.encode(message.payload.value, writer.uint32(970).fork()).join();
        break;
      case "branchTriggerMerge":
        BranchTriggerMerge.encode(message.payload.value, writer.uint32(106).fork()).join();
        break;
      case "branchCreated":
        BranchCreated.encode(message.payload.value, writer.uint32(114).fork()).join();
        break;
      case "branchMerged":
        BranchMerged.encode(message.payload.value, writer.uint32(122).fork()).join();
        break;
      case "branchDeleted":
        BranchDeleted.encode(message.payload.value, writer.uint32(378).fork()).join();
        break;
      case "projectCreated":
        ProjectCreated.encode(message.payload.value, writer.uint32(130).fork()).join();
        break;
      case "projectLoadedFromJupiter":
        ProjectLoadedFromJupiter.encode(message.payload.value, writer.uint32(138).fork()).join();
        break;
      case "deploymentCompleted":
        DeploymentCompleted.encode(message.payload.value, writer.uint32(290).fork()).join();
        break;
      case "deploymentRollback":
        DeploymentRollback.encode(message.payload.value, writer.uint32(514).fork()).join();
        break;
      case "entityCreate":
        EntityCreate.encode(message.payload.value, writer.uint32(538).fork()).join();
        break;
      case "entityUpdate":
        EntityUpdate.encode(message.payload.value, writer.uint32(546).fork()).join();
        break;
      case "entityDelete":
        EntityDelete.encode(message.payload.value, writer.uint32(554).fork()).join();
        break;
      case "variableCreate":
        VariableCreate.encode(message.payload.value, writer.uint32(1802).fork()).join();
        break;
      case "variableUpdate":
        VariableUpdate.encode(message.payload.value, writer.uint32(1810).fork()).join();
        break;
      case "variableDelete":
        VariableDelete.encode(message.payload.value, writer.uint32(1818).fork()).join();
        break;
      case "functionDeploymentCompleted":
        FunctionDeploymentCompleted.encode(message.payload.value, writer.uint32(562).fork()).join();
        break;
      case "createApiIntegration":
        ApiIntegrationCreate.encode(message.payload.value, writer.uint32(2402).fork()).join();
        break;
      case "updateApiIntegration":
        ApiIntegrationUpdate.encode(message.payload.value, writer.uint32(2410).fork()).join();
        break;
      case "deleteApiIntegration":
        ApiIntegrationDelete.encode(message.payload.value, writer.uint32(2418).fork()).join();
        break;
      case "updateApiIntegrationConfig":
        ApiIntegrationConfigUpdate.encode(message.payload.value, writer.uint32(2426).fork()).join();
        break;
      case "createApiIntegrationOperation":
        ApiIntegrationOperationCreate.encode(message.payload.value, writer.uint32(2434).fork()).join();
        break;
      case "updateApiIntegrationOperation":
        ApiIntegrationOperationUpdate.encode(message.payload.value, writer.uint32(2442).fork()).join();
        break;
      case "deleteApiIntegrationOperation":
        ApiIntegrationOperationDelete.encode(message.payload.value, writer.uint32(2450).fork()).join();
        break;
      case "createTranslation":
        LanguageHubTranslationsCreate.encode(message.payload.value, writer.uint32(2810).fork()).join();
        break;
      case "updateTranslation":
        LanguageHubTranslationsUpdate.encode(message.payload.value, writer.uint32(2818).fork()).join();
        break;
      case "deleteTranslation":
        LanguageHubTranslationsDelete.encode(message.payload.value, writer.uint32(2826).fork()).join();
        break;
      case "voiceChannelUpdateAsrSettings":
        VoiceChannelUpdateASRSettings.encode(message.payload.value, writer.uint32(2866).fork()).join();
        break;
      case "voiceChannelUpdateDisclaimer":
        VoiceChannelUpdateDisclaimer.encode(message.payload.value, writer.uint32(2874).fork()).join();
        break;
      case "voiceChannelUpdateVadConfig":
        VoiceChannelUpdateVadConfig.encode(message.payload.value, writer.uint32(3050).fork()).join();
        break;
      case "voiceChannelUpdateAudioEnhancement":
        VoiceChannelUpdateAudioEnhancement.encode(message.payload.value, writer.uint32(3058).fork()).join();
        break;
      case "voiceChannelUpdateSilenceFillerUtterances":
        VoiceChannelUpdateSilenceFillerUtterances.encode(message.payload.value, writer.uint32(3066).fork()).join();
        break;
      case "voiceChannelUpdateAsrConfig":
        VoiceChannelUpdateAsrConfig.encode(message.payload.value, writer.uint32(3074).fork()).join();
        break;
      case "voiceChannelUpdateBargeInConfig":
        VoiceChannelUpdateBargeInConfig.encode(message.payload.value, writer.uint32(3082).fork()).join();
        break;
      case "voiceChannelUpdateTemperature":
        VoiceChannelUpdateTemperature.encode(message.payload.value, writer.uint32(3090).fork()).join();
        break;
      case "voiceChannelResetBargeInConfig":
        VoiceChannelResetBargeInConfig.encode(message.payload.value, writer.uint32(3098).fork()).join();
        break;
      case "voiceChannelResetTemperature":
        VoiceChannelResetTemperature.encode(message.payload.value, writer.uint32(3106).fork()).join();
        break;
      case "voiceChannelResetVadConfig":
        VoiceChannelResetVadConfig.encode(message.payload.value, writer.uint32(3114).fork()).join();
        break;
      case "voiceChannelResetAudioEnhancement":
        VoiceChannelResetAudioEnhancement.encode(message.payload.value, writer.uint32(3122).fork()).join();
        break;
      case "voiceChannelResetSilenceFillerUtterances":
        VoiceChannelResetSilenceFillerUtterances.encode(message.payload.value, writer.uint32(3130).fork()).join();
        break;
      case "voiceChannelResetAsrConfig":
        VoiceChannelResetAsrConfig.encode(message.payload.value, writer.uint32(3138).fork()).join();
        break;
      case "channelUpdateGreeting":
        ChannelUpdateGreeting.encode(message.payload.value, writer.uint32(3010).fork()).join();
        break;
      case "channelUpdateStylePrompt":
        ChannelUpdateStylePrompt.encode(message.payload.value, writer.uint32(3018).fork()).join();
        break;
      case "channelUpdateSafetyFilters":
        ChannelUpdateSafetyFilters.encode(message.payload.value, writer.uint32(3026).fork()).join();
        break;
      case "channelUpdateLlmSettings":
        ChannelUpdateLLMSettings.encode(message.payload.value, writer.uint32(3034).fork()).join();
        break;
      case "channelUpdateStatus":
        ChannelUpdateStatus.encode(message.payload.value, writer.uint32(3042).fork()).join();
        break;
      case "csatUpdateConfig":
        CSATUpdateConfig.encode(message.payload.value, writer.uint32(2962).fork()).join();
        break;
      case "connectIntegration":
        IntegrationConnect.encode(message.payload.value, writer.uint32(2970).fork()).join();
        break;
      case "enableIntegration":
        IntegrationEnable.encode(message.payload.value, writer.uint32(2978).fork()).join();
        break;
      case "disableIntegration":
        IntegrationDisable.encode(message.payload.value, writer.uint32(3002).fork()).join();
        break;
      case "updateIntegrationFunctions":
        IntegrationUpdateFunctions.encode(message.payload.value, writer.uint32(2986).fork()).join();
        break;
      case "disconnectIntegration":
        IntegrationDisconnect.encode(message.payload.value, writer.uint32(2994).fork()).join();
        break;
      case "updateMcpConfig":
        MCPConfigUpdate.encode(message.payload.value, writer.uint32(3082).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Event {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sequence = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commandId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serverTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 200: {
          if (tag !== 1602) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.payload = { $case: "createTopic", value: KnowledgeBaseCreateTopic.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.payload = { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.payload = { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.decode(reader, reader.uint32()) };
          continue;
        }
        case 118: {
          if (tag !== 946) {
            break;
          }

          message.payload = { $case: "importTopics", value: KnowledgeBaseImportTopics.decode(reader, reader.uint32()) };
          continue;
        }
        case 119: {
          if (tag !== 954) {
            break;
          }

          message.payload = {
            $case: "toggleTopicStatus",
            value: KnowledgeBaseToggleTopicStatus.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.payload = { $case: "smsCreateTemplate", value: SMSCreateTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.payload = { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.payload = { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.payload = { $case: "handoffCreate", value: HandoffCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.payload = { $case: "handoffUpdate", value: HandoffUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.payload = { $case: "handoffDelete", value: HandoffDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.payload = { $case: "handoffSetDefault", value: HandoffSetDefault.decode(reader, reader.uint32()) };
          continue;
        }
        case 72: {
          if (tag !== 578) {
            break;
          }

          message.payload = {
            $case: "handoffResetHandoffConfigs",
            value: HandoffResetHandoffConfigs.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.payload = { $case: "createFlowStep", value: FlowCreateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.payload = { $case: "updateFlowStep", value: FlowUpdateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.payload = { $case: "deleteFlowStep", value: FlowDeleteStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepPosition",
            value: FlowUpdateStepPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepPositions",
            value: FlowUpdateStepPositions.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepDtmfConfig",
            value: FlowUpdateStepDtmfConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 106: {
          if (tag !== 850) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepAsrConfig",
            value: FlowUpdateStepAsrConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 107: {
          if (tag !== 858) {
            break;
          }

          message.payload = {
            $case: "createFlowTransitionFunction",
            value: FlowCreateTransitionFunction.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.payload = {
            $case: "updateFlowTransitionFunction",
            value: FlowUpdateTransitionFunction.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 109: {
          if (tag !== 874) {
            break;
          }

          message.payload = {
            $case: "deleteFlowTransitionFunction",
            value: FlowDeleteTransitionFunction.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 110: {
          if (tag !== 882) {
            break;
          }

          message.payload = { $case: "deleteFlow", value: FlowDeleteFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 111: {
          if (tag !== 890) {
            break;
          }

          message.payload = { $case: "createFlow", value: FlowCreateFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 112: {
          if (tag !== 898) {
            break;
          }

          message.payload = { $case: "importFlow", value: FlowImportFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 113: {
          if (tag !== 906) {
            break;
          }

          message.payload = { $case: "updateFlow", value: FlowUpdateFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 114: {
          if (tag !== 914) {
            break;
          }

          message.payload = {
            $case: "updateFlowTransitionFunctionLatencyControl",
            value: FlowUpdateTransitionFunctionLatencyControl.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 214: {
          if (tag !== 1714) {
            break;
          }

          message.payload = { $case: "createNoCodeStep", value: CreateNoCodeStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 215: {
          if (tag !== 1722) {
            break;
          }

          message.payload = { $case: "updateNoCodeStep", value: UpdateNoCodeStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 216: {
          if (tag !== 1730) {
            break;
          }

          message.payload = { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 217: {
          if (tag !== 1738) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeStepPosition",
            value: UpdateNoCodeStepPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 218: {
          if (tag !== 1746) {
            break;
          }

          message.payload = {
            $case: "createNoCodeCondition",
            value: CreateNoCodeCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 219: {
          if (tag !== 1754) {
            break;
          }

          message.payload = {
            $case: "deleteNoCodeCondition",
            value: DeleteNoCodeCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 220: {
          if (tag !== 1762) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeCondition",
            value: UpdateNoCodeCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 221: {
          if (tag !== 1770) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeConditionPosition",
            value: UpdateNoCodeConditionPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 222: {
          if (tag !== 1778) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeConditionExitFlowPosition",
            value: UpdateNoCodeConditionExitFlowPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 223: {
          if (tag !== 1786) {
            break;
          }

          message.payload = { $case: "moveFlowComponent", value: MoveFlowComponent.decode(reader, reader.uint32()) };
          continue;
        }
        case 224: {
          if (tag !== 1794) {
            break;
          }

          message.payload = { $case: "moveFlowComponents", value: MoveFlowComponents.decode(reader, reader.uint32()) };
          continue;
        }
        case 307: {
          if (tag !== 2458) {
            break;
          }

          message.payload = { $case: "createStep", value: CreateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 308: {
          if (tag !== 2466) {
            break;
          }

          message.payload = { $case: "updateStep", value: UpdateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 309: {
          if (tag !== 2474) {
            break;
          }

          message.payload = { $case: "deleteStep", value: DeleteStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 310: {
          if (tag !== 2482) {
            break;
          }

          message.payload = {
            $case: "createStepCondition",
            value: CreateStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 311: {
          if (tag !== 2490) {
            break;
          }

          message.payload = {
            $case: "updateStepCondition",
            value: UpdateStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 312: {
          if (tag !== 2498) {
            break;
          }

          message.payload = {
            $case: "deleteStepCondition",
            value: DeleteStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 313: {
          if (tag !== 2506) {
            break;
          }

          message.payload = {
            $case: "updateStepConditionPosition",
            value: UpdateStepConditionPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.payload = {
            $case: "variantCreateAttribute",
            value: VariantCreateAttribute.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.payload = {
            $case: "variantUpdateAttribute",
            value: VariantUpdateAttribute.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.payload = {
            $case: "variantDeleteAttribute",
            value: VariantDeleteAttribute.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.payload = {
            $case: "variantCreateVariant",
            value: VariantCreateVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.payload = {
            $case: "variantUpdateVariant",
            value: VariantUpdateVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.payload = {
            $case: "variantDeleteVariant",
            value: VariantDeleteVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.payload = {
            $case: "variantSetDefaultVariant",
            value: VariantSetDefaultVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.payload = {
            $case: "variantImportVariants",
            value: VariantImportVariants.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.payload = { $case: "stopKeywordsCreate", value: StopKeywordCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.payload = { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.payload = { $case: "stopKeywordsDelete", value: StopKeywordDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.payload = {
            $case: "updateLlmSettings",
            value: LLMSettingsUpdateLLMSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.payload = {
            $case: "updateContentFilterSettings",
            value: ContentFilterSettingsUpdateContentFilterSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.payload = {
            $case: "updateAsrSettings",
            value: ASRSettingsUpdateASRSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.payload = {
            $case: "updateTtsSettings",
            value: LanguagesUpdateDefaultLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 228: {
          if (tag !== 1826) {
            break;
          }

          message.payload = {
            $case: "languagesUpdateDefaultLanguage",
            value: LanguagesUpdateDefaultLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 229: {
          if (tag !== 1834) {
            break;
          }

          message.payload = {
            $case: "languagesAddLanguage",
            value: LanguagesAddLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 230: {
          if (tag !== 1842) {
            break;
          }

          message.payload = {
            $case: "languagesDeleteLanguage",
            value: LanguagesDeleteLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.payload = {
            $case: "experimentalConfigUpdateConfig",
            value: ExperimentalConfigUpdateConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.payload = {
            $case: "pronunciationsCreatePronunciation",
            value: PronunciationsCreatePronunciation.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.payload = {
            $case: "pronunciationsUpdatePronunciation",
            value: PronunciationsUpdatePronunciation.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.payload = {
            $case: "pronunciationsDeletePronunciation",
            value: PronunciationsDeletePronunciation.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 365: {
          if (tag !== 2922) {
            break;
          }

          message.payload = {
            $case: "pronunciationsReorderPronunciations",
            value: PronunciationsReorderPronunciations.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.payload = {
            $case: "createTranscriptCorrections",
            value: TranscriptCorrectionsCreateTranscriptCorrections.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.payload = {
            $case: "updateTranscriptCorrections",
            value: TranscriptCorrectionsUpdateTranscriptCorrections.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.payload = {
            $case: "deleteTranscriptCorrections",
            value: TranscriptCorrectionsDeleteTranscriptCorrections.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.payload = { $case: "updateGreeting", value: GreetingUpdateGreeting.decode(reader, reader.uint32()) };
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.payload = {
            $case: "updatePersonality",
            value: PersonalityUpdatePersonality.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.payload = { $case: "updateRole", value: RoleUpdateRole.decode(reader, reader.uint32()) };
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.payload = {
            $case: "updateDisclaimerMessage",
            value: DisclaimerMessageUpdateDisclaimerMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.payload = { $case: "updateRules", value: RulesUpdateRules.decode(reader, reader.uint32()) };
          continue;
        }
        case 71: {
          if (tag !== 570) {
            break;
          }

          message.payload = {
            $case: "updateLanguageBehavior",
            value: LanguageBehaviorUpdateLanguageBehavior.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.payload = { $case: "createFunction", value: FunctionCreateFunction.decode(reader, reader.uint32()) };
          continue;
        }
        case 48: {
          if (tag !== 386) {
            break;
          }

          message.payload = { $case: "updateFunction", value: FunctionUpdateFunction.decode(reader, reader.uint32()) };
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.payload = { $case: "deleteFunction", value: FunctionDeleteFunction.decode(reader, reader.uint32()) };
          continue;
        }
        case 59: {
          if (tag !== 474) {
            break;
          }

          message.payload = {
            $case: "updateLatencyControl",
            value: FunctionUpdateLatencyControl.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 60: {
          if (tag !== 482) {
            break;
          }

          message.payload = {
            $case: "createStartFunction",
            value: StartFunctionCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 61: {
          if (tag !== 490) {
            break;
          }

          message.payload = {
            $case: "updateStartFunction",
            value: StartFunctionUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 65: {
          if (tag !== 522) {
            break;
          }

          message.payload = {
            $case: "deleteStartFunction",
            value: StartFunctionDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 62: {
          if (tag !== 498) {
            break;
          }

          message.payload = { $case: "createEndFunction", value: EndFunctionCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 63: {
          if (tag !== 506) {
            break;
          }

          message.payload = { $case: "updateEndFunction", value: EndFunctionUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 66: {
          if (tag !== 530) {
            break;
          }

          message.payload = { $case: "deleteEndFunction", value: EndFunctionDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 115: {
          if (tag !== 922) {
            break;
          }

          message.payload = {
            $case: "createKeyphraseBoosting",
            value: KeyphraseBoostingCreateKeyphrase.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 116: {
          if (tag !== 930) {
            break;
          }

          message.payload = {
            $case: "updateKeyphraseBoosting",
            value: KeyphraseBoostingUpdateKeyphrase.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 117: {
          if (tag !== 938) {
            break;
          }

          message.payload = {
            $case: "deleteKeyphraseBoosting",
            value: KeyphraseBoostingDeleteKeyphrase.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.payload = { $case: "voiceAddAgentVoice", value: VoiceAddAgentVoice.decode(reader, reader.uint32()) };
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.payload = {
            $case: "voiceDeleteAgentVoice",
            value: VoiceDeleteAgentVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateAgentVoice",
            value: VoiceUpdateAgentVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 54: {
          if (tag !== 434) {
            break;
          }

          message.payload = {
            $case: "voiceCreateAgentVoiceSettings",
            value: VoiceCreateAgentVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateAgentVoiceSettings",
            value: VoiceUpdateAgentVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 56: {
          if (tag !== 450) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateDisclaimerVoice",
            value: VoiceUpdateDisclaimerVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 57: {
          if (tag !== 458) {
            break;
          }

          message.payload = {
            $case: "voiceCreateDisclaimerVoiceSettings",
            value: VoiceCreateDisclaimerVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 58: {
          if (tag !== 466) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateDisclaimerVoiceSettings",
            value: VoiceUpdateDisclaimerVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 120: {
          if (tag !== 962) {
            break;
          }

          message.payload = {
            $case: "voiceAddFavoriteVoice",
            value: VoiceAddFavoriteVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 121: {
          if (tag !== 970) {
            break;
          }

          message.payload = {
            $case: "voiceRemoveFavoriteVoice",
            value: VoiceRemoveFavoriteVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.payload = { $case: "branchTriggerMerge", value: BranchTriggerMerge.decode(reader, reader.uint32()) };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.payload = { $case: "branchCreated", value: BranchCreated.decode(reader, reader.uint32()) };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.payload = { $case: "branchMerged", value: BranchMerged.decode(reader, reader.uint32()) };
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.payload = { $case: "branchDeleted", value: BranchDeleted.decode(reader, reader.uint32()) };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.payload = { $case: "projectCreated", value: ProjectCreated.decode(reader, reader.uint32()) };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.payload = {
            $case: "projectLoadedFromJupiter",
            value: ProjectLoadedFromJupiter.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.payload = {
            $case: "deploymentCompleted",
            value: DeploymentCompleted.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 64: {
          if (tag !== 514) {
            break;
          }

          message.payload = { $case: "deploymentRollback", value: DeploymentRollback.decode(reader, reader.uint32()) };
          continue;
        }
        case 67: {
          if (tag !== 538) {
            break;
          }

          message.payload = { $case: "entityCreate", value: EntityCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 68: {
          if (tag !== 546) {
            break;
          }

          message.payload = { $case: "entityUpdate", value: EntityUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 69: {
          if (tag !== 554) {
            break;
          }

          message.payload = { $case: "entityDelete", value: EntityDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 225: {
          if (tag !== 1802) {
            break;
          }

          message.payload = { $case: "variableCreate", value: VariableCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 226: {
          if (tag !== 1810) {
            break;
          }

          message.payload = { $case: "variableUpdate", value: VariableUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 227: {
          if (tag !== 1818) {
            break;
          }

          message.payload = { $case: "variableDelete", value: VariableDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 70: {
          if (tag !== 562) {
            break;
          }

          message.payload = {
            $case: "functionDeploymentCompleted",
            value: FunctionDeploymentCompleted.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 300: {
          if (tag !== 2402) {
            break;
          }

          message.payload = {
            $case: "createApiIntegration",
            value: ApiIntegrationCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 301: {
          if (tag !== 2410) {
            break;
          }

          message.payload = {
            $case: "updateApiIntegration",
            value: ApiIntegrationUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 302: {
          if (tag !== 2418) {
            break;
          }

          message.payload = {
            $case: "deleteApiIntegration",
            value: ApiIntegrationDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 303: {
          if (tag !== 2426) {
            break;
          }

          message.payload = {
            $case: "updateApiIntegrationConfig",
            value: ApiIntegrationConfigUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 304: {
          if (tag !== 2434) {
            break;
          }

          message.payload = {
            $case: "createApiIntegrationOperation",
            value: ApiIntegrationOperationCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 305: {
          if (tag !== 2442) {
            break;
          }

          message.payload = {
            $case: "updateApiIntegrationOperation",
            value: ApiIntegrationOperationUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 306: {
          if (tag !== 2450) {
            break;
          }

          message.payload = {
            $case: "deleteApiIntegrationOperation",
            value: ApiIntegrationOperationDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 351: {
          if (tag !== 2810) {
            break;
          }

          message.payload = {
            $case: "createTranslation",
            value: LanguageHubTranslationsCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 352: {
          if (tag !== 2818) {
            break;
          }

          message.payload = {
            $case: "updateTranslation",
            value: LanguageHubTranslationsUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 353: {
          if (tag !== 2826) {
            break;
          }

          message.payload = {
            $case: "deleteTranslation",
            value: LanguageHubTranslationsDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 358: {
          if (tag !== 2866) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateAsrSettings",
            value: VoiceChannelUpdateASRSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 359: {
          if (tag !== 2874) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateDisclaimer",
            value: VoiceChannelUpdateDisclaimer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 381: {
          if (tag !== 3050) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateVadConfig",
            value: VoiceChannelUpdateVadConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 382: {
          if (tag !== 3058) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateAudioEnhancement",
            value: VoiceChannelUpdateAudioEnhancement.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 383: {
          if (tag !== 3066) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateSilenceFillerUtterances",
            value: VoiceChannelUpdateSilenceFillerUtterances.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 384: {
          if (tag !== 3074) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateAsrConfig",
            value: VoiceChannelUpdateAsrConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 385: {
          if (tag !== 3082) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateBargeInConfig",
            value: VoiceChannelUpdateBargeInConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 386: {
          if (tag !== 3090) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateTemperature",
            value: VoiceChannelUpdateTemperature.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 387: {
          if (tag !== 3098) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetBargeInConfig",
            value: VoiceChannelResetBargeInConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 388: {
          if (tag !== 3106) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetTemperature",
            value: VoiceChannelResetTemperature.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 389: {
          if (tag !== 3114) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetVadConfig",
            value: VoiceChannelResetVadConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 390: {
          if (tag !== 3122) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetAudioEnhancement",
            value: VoiceChannelResetAudioEnhancement.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 391: {
          if (tag !== 3130) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetSilenceFillerUtterances",
            value: VoiceChannelResetSilenceFillerUtterances.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 392: {
          if (tag !== 3138) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetAsrConfig",
            value: VoiceChannelResetAsrConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 376: {
          if (tag !== 3010) {
            break;
          }

          message.payload = {
            $case: "channelUpdateGreeting",
            value: ChannelUpdateGreeting.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 377: {
          if (tag !== 3018) {
            break;
          }

          message.payload = {
            $case: "channelUpdateStylePrompt",
            value: ChannelUpdateStylePrompt.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 378: {
          if (tag !== 3026) {
            break;
          }

          message.payload = {
            $case: "channelUpdateSafetyFilters",
            value: ChannelUpdateSafetyFilters.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 379: {
          if (tag !== 3034) {
            break;
          }

          message.payload = {
            $case: "channelUpdateLlmSettings",
            value: ChannelUpdateLLMSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 380: {
          if (tag !== 3042) {
            break;
          }

          message.payload = {
            $case: "channelUpdateStatus",
            value: ChannelUpdateStatus.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 370: {
          if (tag !== 2962) {
            break;
          }

          message.payload = { $case: "csatUpdateConfig", value: CSATUpdateConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 371: {
          if (tag !== 2970) {
            break;
          }

          message.payload = { $case: "connectIntegration", value: IntegrationConnect.decode(reader, reader.uint32()) };
          continue;
        }
        case 372: {
          if (tag !== 2978) {
            break;
          }

          message.payload = { $case: "enableIntegration", value: IntegrationEnable.decode(reader, reader.uint32()) };
          continue;
        }
        case 375: {
          if (tag !== 3002) {
            break;
          }

          message.payload = { $case: "disableIntegration", value: IntegrationDisable.decode(reader, reader.uint32()) };
          continue;
        }
        case 373: {
          if (tag !== 2986) {
            break;
          }

          message.payload = {
            $case: "updateIntegrationFunctions",
            value: IntegrationUpdateFunctions.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 374: {
          if (tag !== 2994) {
            break;
          }

          message.payload = {
            $case: "disconnectIntegration",
            value: IntegrationDisconnect.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 385: {
          if (tag !== 3082) {
            break;
          }

          message.payload = { $case: "updateMcpConfig", value: MCPConfigUpdate.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Event {
    return {
      sequence: isSet(object.sequence) ? Long.fromValue(object.sequence) : Long.UZERO,
      commandId: isSet(object.commandId)
        ? globalThis.String(object.commandId)
        : isSet(object.command_id)
        ? globalThis.String(object.command_id)
        : "",
      serverTimestamp: isSet(object.serverTimestamp)
        ? fromJsonTimestamp(object.serverTimestamp)
        : isSet(object.server_timestamp)
        ? fromJsonTimestamp(object.server_timestamp)
        : undefined,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      payload: isSet(object.createTopic)
        ? { $case: "createTopic", value: KnowledgeBaseCreateTopic.fromJSON(object.createTopic) }
        : isSet(object.create_topic)
        ? { $case: "createTopic", value: KnowledgeBaseCreateTopic.fromJSON(object.create_topic) }
        : isSet(object.updateTopic)
        ? { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.fromJSON(object.updateTopic) }
        : isSet(object.update_topic)
        ? { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.fromJSON(object.update_topic) }
        : isSet(object.deleteTopic)
        ? { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.fromJSON(object.deleteTopic) }
        : isSet(object.delete_topic)
        ? { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.fromJSON(object.delete_topic) }
        : isSet(object.importTopics)
        ? { $case: "importTopics", value: KnowledgeBaseImportTopics.fromJSON(object.importTopics) }
        : isSet(object.import_topics)
        ? { $case: "importTopics", value: KnowledgeBaseImportTopics.fromJSON(object.import_topics) }
        : isSet(object.toggleTopicStatus)
        ? { $case: "toggleTopicStatus", value: KnowledgeBaseToggleTopicStatus.fromJSON(object.toggleTopicStatus) }
        : isSet(object.toggle_topic_status)
        ? { $case: "toggleTopicStatus", value: KnowledgeBaseToggleTopicStatus.fromJSON(object.toggle_topic_status) }
        : isSet(object.smsCreateTemplate)
        ? { $case: "smsCreateTemplate", value: SMSCreateTemplate.fromJSON(object.smsCreateTemplate) }
        : isSet(object.sms_create_template)
        ? { $case: "smsCreateTemplate", value: SMSCreateTemplate.fromJSON(object.sms_create_template) }
        : isSet(object.smsUpdateTemplate)
        ? { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.fromJSON(object.smsUpdateTemplate) }
        : isSet(object.sms_update_template)
        ? { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.fromJSON(object.sms_update_template) }
        : isSet(object.smsDeleteTemplate)
        ? { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.fromJSON(object.smsDeleteTemplate) }
        : isSet(object.sms_delete_template)
        ? { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.fromJSON(object.sms_delete_template) }
        : isSet(object.handoffCreate)
        ? { $case: "handoffCreate", value: HandoffCreate.fromJSON(object.handoffCreate) }
        : isSet(object.handoff_create)
        ? { $case: "handoffCreate", value: HandoffCreate.fromJSON(object.handoff_create) }
        : isSet(object.handoffUpdate)
        ? { $case: "handoffUpdate", value: HandoffUpdate.fromJSON(object.handoffUpdate) }
        : isSet(object.handoff_update)
        ? { $case: "handoffUpdate", value: HandoffUpdate.fromJSON(object.handoff_update) }
        : isSet(object.handoffDelete)
        ? { $case: "handoffDelete", value: HandoffDelete.fromJSON(object.handoffDelete) }
        : isSet(object.handoff_delete)
        ? { $case: "handoffDelete", value: HandoffDelete.fromJSON(object.handoff_delete) }
        : isSet(object.handoffSetDefault)
        ? { $case: "handoffSetDefault", value: HandoffSetDefault.fromJSON(object.handoffSetDefault) }
        : isSet(object.handoff_set_default)
        ? { $case: "handoffSetDefault", value: HandoffSetDefault.fromJSON(object.handoff_set_default) }
        : isSet(object.handoffResetHandoffConfigs)
        ? {
          $case: "handoffResetHandoffConfigs",
          value: HandoffResetHandoffConfigs.fromJSON(object.handoffResetHandoffConfigs),
        }
        : isSet(object.handoff_reset_handoff_configs)
        ? {
          $case: "handoffResetHandoffConfigs",
          value: HandoffResetHandoffConfigs.fromJSON(object.handoff_reset_handoff_configs),
        }
        : isSet(object.createFlowStep)
        ? { $case: "createFlowStep", value: FlowCreateStep.fromJSON(object.createFlowStep) }
        : isSet(object.create_flow_step)
        ? { $case: "createFlowStep", value: FlowCreateStep.fromJSON(object.create_flow_step) }
        : isSet(object.updateFlowStep)
        ? { $case: "updateFlowStep", value: FlowUpdateStep.fromJSON(object.updateFlowStep) }
        : isSet(object.update_flow_step)
        ? { $case: "updateFlowStep", value: FlowUpdateStep.fromJSON(object.update_flow_step) }
        : isSet(object.deleteFlowStep)
        ? { $case: "deleteFlowStep", value: FlowDeleteStep.fromJSON(object.deleteFlowStep) }
        : isSet(object.delete_flow_step)
        ? { $case: "deleteFlowStep", value: FlowDeleteStep.fromJSON(object.delete_flow_step) }
        : isSet(object.updateFlowStepPosition)
        ? { $case: "updateFlowStepPosition", value: FlowUpdateStepPosition.fromJSON(object.updateFlowStepPosition) }
        : isSet(object.update_flow_step_position)
        ? { $case: "updateFlowStepPosition", value: FlowUpdateStepPosition.fromJSON(object.update_flow_step_position) }
        : isSet(object.updateFlowStepPositions)
        ? { $case: "updateFlowStepPositions", value: FlowUpdateStepPositions.fromJSON(object.updateFlowStepPositions) }
        : isSet(object.update_flow_step_positions)
        ? {
          $case: "updateFlowStepPositions",
          value: FlowUpdateStepPositions.fromJSON(object.update_flow_step_positions),
        }
        : isSet(object.updateFlowStepDtmfConfig)
        ? {
          $case: "updateFlowStepDtmfConfig",
          value: FlowUpdateStepDtmfConfig.fromJSON(object.updateFlowStepDtmfConfig),
        }
        : isSet(object.update_flow_step_dtmf_config)
        ? {
          $case: "updateFlowStepDtmfConfig",
          value: FlowUpdateStepDtmfConfig.fromJSON(object.update_flow_step_dtmf_config),
        }
        : isSet(object.updateFlowStepAsrConfig)
        ? { $case: "updateFlowStepAsrConfig", value: FlowUpdateStepAsrConfig.fromJSON(object.updateFlowStepAsrConfig) }
        : isSet(object.update_flow_step_asr_config)
        ? {
          $case: "updateFlowStepAsrConfig",
          value: FlowUpdateStepAsrConfig.fromJSON(object.update_flow_step_asr_config),
        }
        : isSet(object.createFlowTransitionFunction)
        ? {
          $case: "createFlowTransitionFunction",
          value: FlowCreateTransitionFunction.fromJSON(object.createFlowTransitionFunction),
        }
        : isSet(object.create_flow_transition_function)
        ? {
          $case: "createFlowTransitionFunction",
          value: FlowCreateTransitionFunction.fromJSON(object.create_flow_transition_function),
        }
        : isSet(object.updateFlowTransitionFunction)
        ? {
          $case: "updateFlowTransitionFunction",
          value: FlowUpdateTransitionFunction.fromJSON(object.updateFlowTransitionFunction),
        }
        : isSet(object.update_flow_transition_function)
        ? {
          $case: "updateFlowTransitionFunction",
          value: FlowUpdateTransitionFunction.fromJSON(object.update_flow_transition_function),
        }
        : isSet(object.deleteFlowTransitionFunction)
        ? {
          $case: "deleteFlowTransitionFunction",
          value: FlowDeleteTransitionFunction.fromJSON(object.deleteFlowTransitionFunction),
        }
        : isSet(object.delete_flow_transition_function)
        ? {
          $case: "deleteFlowTransitionFunction",
          value: FlowDeleteTransitionFunction.fromJSON(object.delete_flow_transition_function),
        }
        : isSet(object.deleteFlow)
        ? { $case: "deleteFlow", value: FlowDeleteFlow.fromJSON(object.deleteFlow) }
        : isSet(object.delete_flow)
        ? { $case: "deleteFlow", value: FlowDeleteFlow.fromJSON(object.delete_flow) }
        : isSet(object.createFlow)
        ? { $case: "createFlow", value: FlowCreateFlow.fromJSON(object.createFlow) }
        : isSet(object.create_flow)
        ? { $case: "createFlow", value: FlowCreateFlow.fromJSON(object.create_flow) }
        : isSet(object.importFlow)
        ? { $case: "importFlow", value: FlowImportFlow.fromJSON(object.importFlow) }
        : isSet(object.import_flow)
        ? { $case: "importFlow", value: FlowImportFlow.fromJSON(object.import_flow) }
        : isSet(object.updateFlow)
        ? { $case: "updateFlow", value: FlowUpdateFlow.fromJSON(object.updateFlow) }
        : isSet(object.update_flow)
        ? { $case: "updateFlow", value: FlowUpdateFlow.fromJSON(object.update_flow) }
        : isSet(object.updateFlowTransitionFunctionLatencyControl)
        ? {
          $case: "updateFlowTransitionFunctionLatencyControl",
          value: FlowUpdateTransitionFunctionLatencyControl.fromJSON(object.updateFlowTransitionFunctionLatencyControl),
        }
        : isSet(object.update_flow_transition_function_latency_control)
        ? {
          $case: "updateFlowTransitionFunctionLatencyControl",
          value: FlowUpdateTransitionFunctionLatencyControl.fromJSON(
            object.update_flow_transition_function_latency_control,
          ),
        }
        : isSet(object.createNoCodeStep)
        ? { $case: "createNoCodeStep", value: CreateNoCodeStep.fromJSON(object.createNoCodeStep) }
        : isSet(object.create_no_code_step)
        ? { $case: "createNoCodeStep", value: CreateNoCodeStep.fromJSON(object.create_no_code_step) }
        : isSet(object.updateNoCodeStep)
        ? { $case: "updateNoCodeStep", value: UpdateNoCodeStep.fromJSON(object.updateNoCodeStep) }
        : isSet(object.update_no_code_step)
        ? { $case: "updateNoCodeStep", value: UpdateNoCodeStep.fromJSON(object.update_no_code_step) }
        : isSet(object.deleteNoCodeStep)
        ? { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.fromJSON(object.deleteNoCodeStep) }
        : isSet(object.delete_no_code_step)
        ? { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.fromJSON(object.delete_no_code_step) }
        : isSet(object.updateNoCodeStepPosition)
        ? {
          $case: "updateNoCodeStepPosition",
          value: UpdateNoCodeStepPosition.fromJSON(object.updateNoCodeStepPosition),
        }
        : isSet(object.update_no_code_step_position)
        ? {
          $case: "updateNoCodeStepPosition",
          value: UpdateNoCodeStepPosition.fromJSON(object.update_no_code_step_position),
        }
        : isSet(object.createNoCodeCondition)
        ? { $case: "createNoCodeCondition", value: CreateNoCodeCondition.fromJSON(object.createNoCodeCondition) }
        : isSet(object.create_no_code_condition)
        ? { $case: "createNoCodeCondition", value: CreateNoCodeCondition.fromJSON(object.create_no_code_condition) }
        : isSet(object.deleteNoCodeCondition)
        ? { $case: "deleteNoCodeCondition", value: DeleteNoCodeCondition.fromJSON(object.deleteNoCodeCondition) }
        : isSet(object.delete_no_code_condition)
        ? { $case: "deleteNoCodeCondition", value: DeleteNoCodeCondition.fromJSON(object.delete_no_code_condition) }
        : isSet(object.updateNoCodeCondition)
        ? { $case: "updateNoCodeCondition", value: UpdateNoCodeCondition.fromJSON(object.updateNoCodeCondition) }
        : isSet(object.update_no_code_condition)
        ? { $case: "updateNoCodeCondition", value: UpdateNoCodeCondition.fromJSON(object.update_no_code_condition) }
        : isSet(object.updateNoCodeConditionPosition)
        ? {
          $case: "updateNoCodeConditionPosition",
          value: UpdateNoCodeConditionPosition.fromJSON(object.updateNoCodeConditionPosition),
        }
        : isSet(object.update_no_code_condition_position)
        ? {
          $case: "updateNoCodeConditionPosition",
          value: UpdateNoCodeConditionPosition.fromJSON(object.update_no_code_condition_position),
        }
        : isSet(object.updateNoCodeConditionExitFlowPosition)
        ? {
          $case: "updateNoCodeConditionExitFlowPosition",
          value: UpdateNoCodeConditionExitFlowPosition.fromJSON(object.updateNoCodeConditionExitFlowPosition),
        }
        : isSet(object.update_no_code_condition_exit_flow_position)
        ? {
          $case: "updateNoCodeConditionExitFlowPosition",
          value: UpdateNoCodeConditionExitFlowPosition.fromJSON(object.update_no_code_condition_exit_flow_position),
        }
        : isSet(object.moveFlowComponent)
        ? { $case: "moveFlowComponent", value: MoveFlowComponent.fromJSON(object.moveFlowComponent) }
        : isSet(object.move_flow_component)
        ? { $case: "moveFlowComponent", value: MoveFlowComponent.fromJSON(object.move_flow_component) }
        : isSet(object.moveFlowComponents)
        ? { $case: "moveFlowComponents", value: MoveFlowComponents.fromJSON(object.moveFlowComponents) }
        : isSet(object.move_flow_components)
        ? { $case: "moveFlowComponents", value: MoveFlowComponents.fromJSON(object.move_flow_components) }
        : isSet(object.createStep)
        ? { $case: "createStep", value: CreateStep.fromJSON(object.createStep) }
        : isSet(object.create_step)
        ? { $case: "createStep", value: CreateStep.fromJSON(object.create_step) }
        : isSet(object.updateStep)
        ? { $case: "updateStep", value: UpdateStep.fromJSON(object.updateStep) }
        : isSet(object.update_step)
        ? { $case: "updateStep", value: UpdateStep.fromJSON(object.update_step) }
        : isSet(object.deleteStep)
        ? { $case: "deleteStep", value: DeleteStep.fromJSON(object.deleteStep) }
        : isSet(object.delete_step)
        ? { $case: "deleteStep", value: DeleteStep.fromJSON(object.delete_step) }
        : isSet(object.createStepCondition)
        ? { $case: "createStepCondition", value: CreateStepCondition.fromJSON(object.createStepCondition) }
        : isSet(object.create_step_condition)
        ? { $case: "createStepCondition", value: CreateStepCondition.fromJSON(object.create_step_condition) }
        : isSet(object.updateStepCondition)
        ? { $case: "updateStepCondition", value: UpdateStepCondition.fromJSON(object.updateStepCondition) }
        : isSet(object.update_step_condition)
        ? { $case: "updateStepCondition", value: UpdateStepCondition.fromJSON(object.update_step_condition) }
        : isSet(object.deleteStepCondition)
        ? { $case: "deleteStepCondition", value: DeleteStepCondition.fromJSON(object.deleteStepCondition) }
        : isSet(object.delete_step_condition)
        ? { $case: "deleteStepCondition", value: DeleteStepCondition.fromJSON(object.delete_step_condition) }
        : isSet(object.updateStepConditionPosition)
        ? {
          $case: "updateStepConditionPosition",
          value: UpdateStepConditionPosition.fromJSON(object.updateStepConditionPosition),
        }
        : isSet(object.update_step_condition_position)
        ? {
          $case: "updateStepConditionPosition",
          value: UpdateStepConditionPosition.fromJSON(object.update_step_condition_position),
        }
        : isSet(object.variantCreateAttribute)
        ? { $case: "variantCreateAttribute", value: VariantCreateAttribute.fromJSON(object.variantCreateAttribute) }
        : isSet(object.variant_create_attribute)
        ? { $case: "variantCreateAttribute", value: VariantCreateAttribute.fromJSON(object.variant_create_attribute) }
        : isSet(object.variantUpdateAttribute)
        ? { $case: "variantUpdateAttribute", value: VariantUpdateAttribute.fromJSON(object.variantUpdateAttribute) }
        : isSet(object.variant_update_attribute)
        ? { $case: "variantUpdateAttribute", value: VariantUpdateAttribute.fromJSON(object.variant_update_attribute) }
        : isSet(object.variantDeleteAttribute)
        ? { $case: "variantDeleteAttribute", value: VariantDeleteAttribute.fromJSON(object.variantDeleteAttribute) }
        : isSet(object.variant_delete_attribute)
        ? { $case: "variantDeleteAttribute", value: VariantDeleteAttribute.fromJSON(object.variant_delete_attribute) }
        : isSet(object.variantCreateVariant)
        ? { $case: "variantCreateVariant", value: VariantCreateVariant.fromJSON(object.variantCreateVariant) }
        : isSet(object.variant_create_variant)
        ? { $case: "variantCreateVariant", value: VariantCreateVariant.fromJSON(object.variant_create_variant) }
        : isSet(object.variantUpdateVariant)
        ? { $case: "variantUpdateVariant", value: VariantUpdateVariant.fromJSON(object.variantUpdateVariant) }
        : isSet(object.variant_update_variant)
        ? { $case: "variantUpdateVariant", value: VariantUpdateVariant.fromJSON(object.variant_update_variant) }
        : isSet(object.variantDeleteVariant)
        ? { $case: "variantDeleteVariant", value: VariantDeleteVariant.fromJSON(object.variantDeleteVariant) }
        : isSet(object.variant_delete_variant)
        ? { $case: "variantDeleteVariant", value: VariantDeleteVariant.fromJSON(object.variant_delete_variant) }
        : isSet(object.variantSetDefaultVariant)
        ? {
          $case: "variantSetDefaultVariant",
          value: VariantSetDefaultVariant.fromJSON(object.variantSetDefaultVariant),
        }
        : isSet(object.variant_set_default_variant)
        ? {
          $case: "variantSetDefaultVariant",
          value: VariantSetDefaultVariant.fromJSON(object.variant_set_default_variant),
        }
        : isSet(object.variantImportVariants)
        ? { $case: "variantImportVariants", value: VariantImportVariants.fromJSON(object.variantImportVariants) }
        : isSet(object.variant_import_variants)
        ? { $case: "variantImportVariants", value: VariantImportVariants.fromJSON(object.variant_import_variants) }
        : isSet(object.stopKeywordsCreate)
        ? { $case: "stopKeywordsCreate", value: StopKeywordCreate.fromJSON(object.stopKeywordsCreate) }
        : isSet(object.stop_keywords_create)
        ? { $case: "stopKeywordsCreate", value: StopKeywordCreate.fromJSON(object.stop_keywords_create) }
        : isSet(object.stopKeywordsUpdate)
        ? { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.fromJSON(object.stopKeywordsUpdate) }
        : isSet(object.stop_keywords_update)
        ? { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.fromJSON(object.stop_keywords_update) }
        : isSet(object.stopKeywordsDelete)
        ? { $case: "stopKeywordsDelete", value: StopKeywordDelete.fromJSON(object.stopKeywordsDelete) }
        : isSet(object.stop_keywords_delete)
        ? { $case: "stopKeywordsDelete", value: StopKeywordDelete.fromJSON(object.stop_keywords_delete) }
        : isSet(object.updateLlmSettings)
        ? { $case: "updateLlmSettings", value: LLMSettingsUpdateLLMSettings.fromJSON(object.updateLlmSettings) }
        : isSet(object.update_llm_settings)
        ? { $case: "updateLlmSettings", value: LLMSettingsUpdateLLMSettings.fromJSON(object.update_llm_settings) }
        : isSet(object.updateContentFilterSettings)
        ? {
          $case: "updateContentFilterSettings",
          value: ContentFilterSettingsUpdateContentFilterSettings.fromJSON(object.updateContentFilterSettings),
        }
        : isSet(object.update_content_filter_settings)
        ? {
          $case: "updateContentFilterSettings",
          value: ContentFilterSettingsUpdateContentFilterSettings.fromJSON(object.update_content_filter_settings),
        }
        : isSet(object.updateAsrSettings)
        ? { $case: "updateAsrSettings", value: ASRSettingsUpdateASRSettings.fromJSON(object.updateAsrSettings) }
        : isSet(object.update_asr_settings)
        ? { $case: "updateAsrSettings", value: ASRSettingsUpdateASRSettings.fromJSON(object.update_asr_settings) }
        : isSet(object.updateTtsSettings)
        ? { $case: "updateTtsSettings", value: LanguagesUpdateDefaultLanguage.fromJSON(object.updateTtsSettings) }
        : isSet(object.update_tts_settings)
        ? { $case: "updateTtsSettings", value: LanguagesUpdateDefaultLanguage.fromJSON(object.update_tts_settings) }
        : isSet(object.languagesUpdateDefaultLanguage)
        ? {
          $case: "languagesUpdateDefaultLanguage",
          value: LanguagesUpdateDefaultLanguage.fromJSON(object.languagesUpdateDefaultLanguage),
        }
        : isSet(object.languages_update_default_language)
        ? {
          $case: "languagesUpdateDefaultLanguage",
          value: LanguagesUpdateDefaultLanguage.fromJSON(object.languages_update_default_language),
        }
        : isSet(object.languagesAddLanguage)
        ? { $case: "languagesAddLanguage", value: LanguagesAddLanguage.fromJSON(object.languagesAddLanguage) }
        : isSet(object.languages_add_language)
        ? { $case: "languagesAddLanguage", value: LanguagesAddLanguage.fromJSON(object.languages_add_language) }
        : isSet(object.languagesDeleteLanguage)
        ? { $case: "languagesDeleteLanguage", value: LanguagesDeleteLanguage.fromJSON(object.languagesDeleteLanguage) }
        : isSet(object.languages_delete_language)
        ? {
          $case: "languagesDeleteLanguage",
          value: LanguagesDeleteLanguage.fromJSON(object.languages_delete_language),
        }
        : isSet(object.experimentalConfigUpdateConfig)
        ? {
          $case: "experimentalConfigUpdateConfig",
          value: ExperimentalConfigUpdateConfig.fromJSON(object.experimentalConfigUpdateConfig),
        }
        : isSet(object.experimental_config_update_config)
        ? {
          $case: "experimentalConfigUpdateConfig",
          value: ExperimentalConfigUpdateConfig.fromJSON(object.experimental_config_update_config),
        }
        : isSet(object.pronunciationsCreatePronunciation)
        ? {
          $case: "pronunciationsCreatePronunciation",
          value: PronunciationsCreatePronunciation.fromJSON(object.pronunciationsCreatePronunciation),
        }
        : isSet(object.pronunciations_create_pronunciation)
        ? {
          $case: "pronunciationsCreatePronunciation",
          value: PronunciationsCreatePronunciation.fromJSON(object.pronunciations_create_pronunciation),
        }
        : isSet(object.pronunciationsUpdatePronunciation)
        ? {
          $case: "pronunciationsUpdatePronunciation",
          value: PronunciationsUpdatePronunciation.fromJSON(object.pronunciationsUpdatePronunciation),
        }
        : isSet(object.pronunciations_update_pronunciation)
        ? {
          $case: "pronunciationsUpdatePronunciation",
          value: PronunciationsUpdatePronunciation.fromJSON(object.pronunciations_update_pronunciation),
        }
        : isSet(object.pronunciationsDeletePronunciation)
        ? {
          $case: "pronunciationsDeletePronunciation",
          value: PronunciationsDeletePronunciation.fromJSON(object.pronunciationsDeletePronunciation),
        }
        : isSet(object.pronunciations_delete_pronunciation)
        ? {
          $case: "pronunciationsDeletePronunciation",
          value: PronunciationsDeletePronunciation.fromJSON(object.pronunciations_delete_pronunciation),
        }
        : isSet(object.pronunciationsReorderPronunciations)
        ? {
          $case: "pronunciationsReorderPronunciations",
          value: PronunciationsReorderPronunciations.fromJSON(object.pronunciationsReorderPronunciations),
        }
        : isSet(object.pronunciations_reorder_pronunciations)
        ? {
          $case: "pronunciationsReorderPronunciations",
          value: PronunciationsReorderPronunciations.fromJSON(object.pronunciations_reorder_pronunciations),
        }
        : isSet(object.createTranscriptCorrections)
        ? {
          $case: "createTranscriptCorrections",
          value: TranscriptCorrectionsCreateTranscriptCorrections.fromJSON(object.createTranscriptCorrections),
        }
        : isSet(object.create_transcript_corrections)
        ? {
          $case: "createTranscriptCorrections",
          value: TranscriptCorrectionsCreateTranscriptCorrections.fromJSON(object.create_transcript_corrections),
        }
        : isSet(object.updateTranscriptCorrections)
        ? {
          $case: "updateTranscriptCorrections",
          value: TranscriptCorrectionsUpdateTranscriptCorrections.fromJSON(object.updateTranscriptCorrections),
        }
        : isSet(object.update_transcript_corrections)
        ? {
          $case: "updateTranscriptCorrections",
          value: TranscriptCorrectionsUpdateTranscriptCorrections.fromJSON(object.update_transcript_corrections),
        }
        : isSet(object.deleteTranscriptCorrections)
        ? {
          $case: "deleteTranscriptCorrections",
          value: TranscriptCorrectionsDeleteTranscriptCorrections.fromJSON(object.deleteTranscriptCorrections),
        }
        : isSet(object.delete_transcript_corrections)
        ? {
          $case: "deleteTranscriptCorrections",
          value: TranscriptCorrectionsDeleteTranscriptCorrections.fromJSON(object.delete_transcript_corrections),
        }
        : isSet(object.updateGreeting)
        ? { $case: "updateGreeting", value: GreetingUpdateGreeting.fromJSON(object.updateGreeting) }
        : isSet(object.update_greeting)
        ? { $case: "updateGreeting", value: GreetingUpdateGreeting.fromJSON(object.update_greeting) }
        : isSet(object.updatePersonality)
        ? { $case: "updatePersonality", value: PersonalityUpdatePersonality.fromJSON(object.updatePersonality) }
        : isSet(object.update_personality)
        ? { $case: "updatePersonality", value: PersonalityUpdatePersonality.fromJSON(object.update_personality) }
        : isSet(object.updateRole)
        ? { $case: "updateRole", value: RoleUpdateRole.fromJSON(object.updateRole) }
        : isSet(object.update_role)
        ? { $case: "updateRole", value: RoleUpdateRole.fromJSON(object.update_role) }
        : isSet(object.updateDisclaimerMessage)
        ? {
          $case: "updateDisclaimerMessage",
          value: DisclaimerMessageUpdateDisclaimerMessage.fromJSON(object.updateDisclaimerMessage),
        }
        : isSet(object.update_disclaimer_message)
        ? {
          $case: "updateDisclaimerMessage",
          value: DisclaimerMessageUpdateDisclaimerMessage.fromJSON(object.update_disclaimer_message),
        }
        : isSet(object.updateRules)
        ? { $case: "updateRules", value: RulesUpdateRules.fromJSON(object.updateRules) }
        : isSet(object.update_rules)
        ? { $case: "updateRules", value: RulesUpdateRules.fromJSON(object.update_rules) }
        : isSet(object.updateLanguageBehavior)
        ? {
          $case: "updateLanguageBehavior",
          value: LanguageBehaviorUpdateLanguageBehavior.fromJSON(object.updateLanguageBehavior),
        }
        : isSet(object.update_language_behavior)
        ? {
          $case: "updateLanguageBehavior",
          value: LanguageBehaviorUpdateLanguageBehavior.fromJSON(object.update_language_behavior),
        }
        : isSet(object.createFunction)
        ? { $case: "createFunction", value: FunctionCreateFunction.fromJSON(object.createFunction) }
        : isSet(object.create_function)
        ? { $case: "createFunction", value: FunctionCreateFunction.fromJSON(object.create_function) }
        : isSet(object.updateFunction)
        ? { $case: "updateFunction", value: FunctionUpdateFunction.fromJSON(object.updateFunction) }
        : isSet(object.update_function)
        ? { $case: "updateFunction", value: FunctionUpdateFunction.fromJSON(object.update_function) }
        : isSet(object.deleteFunction)
        ? { $case: "deleteFunction", value: FunctionDeleteFunction.fromJSON(object.deleteFunction) }
        : isSet(object.delete_function)
        ? { $case: "deleteFunction", value: FunctionDeleteFunction.fromJSON(object.delete_function) }
        : isSet(object.updateLatencyControl)
        ? { $case: "updateLatencyControl", value: FunctionUpdateLatencyControl.fromJSON(object.updateLatencyControl) }
        : isSet(object.update_latency_control)
        ? { $case: "updateLatencyControl", value: FunctionUpdateLatencyControl.fromJSON(object.update_latency_control) }
        : isSet(object.createStartFunction)
        ? { $case: "createStartFunction", value: StartFunctionCreate.fromJSON(object.createStartFunction) }
        : isSet(object.create_start_function)
        ? { $case: "createStartFunction", value: StartFunctionCreate.fromJSON(object.create_start_function) }
        : isSet(object.updateStartFunction)
        ? { $case: "updateStartFunction", value: StartFunctionUpdate.fromJSON(object.updateStartFunction) }
        : isSet(object.update_start_function)
        ? { $case: "updateStartFunction", value: StartFunctionUpdate.fromJSON(object.update_start_function) }
        : isSet(object.deleteStartFunction)
        ? { $case: "deleteStartFunction", value: StartFunctionDelete.fromJSON(object.deleteStartFunction) }
        : isSet(object.delete_start_function)
        ? { $case: "deleteStartFunction", value: StartFunctionDelete.fromJSON(object.delete_start_function) }
        : isSet(object.createEndFunction)
        ? { $case: "createEndFunction", value: EndFunctionCreate.fromJSON(object.createEndFunction) }
        : isSet(object.create_end_function)
        ? { $case: "createEndFunction", value: EndFunctionCreate.fromJSON(object.create_end_function) }
        : isSet(object.updateEndFunction)
        ? { $case: "updateEndFunction", value: EndFunctionUpdate.fromJSON(object.updateEndFunction) }
        : isSet(object.update_end_function)
        ? { $case: "updateEndFunction", value: EndFunctionUpdate.fromJSON(object.update_end_function) }
        : isSet(object.deleteEndFunction)
        ? { $case: "deleteEndFunction", value: EndFunctionDelete.fromJSON(object.deleteEndFunction) }
        : isSet(object.delete_end_function)
        ? { $case: "deleteEndFunction", value: EndFunctionDelete.fromJSON(object.delete_end_function) }
        : isSet(object.createKeyphraseBoosting)
        ? {
          $case: "createKeyphraseBoosting",
          value: KeyphraseBoostingCreateKeyphrase.fromJSON(object.createKeyphraseBoosting),
        }
        : isSet(object.create_keyphrase_boosting)
        ? {
          $case: "createKeyphraseBoosting",
          value: KeyphraseBoostingCreateKeyphrase.fromJSON(object.create_keyphrase_boosting),
        }
        : isSet(object.updateKeyphraseBoosting)
        ? {
          $case: "updateKeyphraseBoosting",
          value: KeyphraseBoostingUpdateKeyphrase.fromJSON(object.updateKeyphraseBoosting),
        }
        : isSet(object.update_keyphrase_boosting)
        ? {
          $case: "updateKeyphraseBoosting",
          value: KeyphraseBoostingUpdateKeyphrase.fromJSON(object.update_keyphrase_boosting),
        }
        : isSet(object.deleteKeyphraseBoosting)
        ? {
          $case: "deleteKeyphraseBoosting",
          value: KeyphraseBoostingDeleteKeyphrase.fromJSON(object.deleteKeyphraseBoosting),
        }
        : isSet(object.delete_keyphrase_boosting)
        ? {
          $case: "deleteKeyphraseBoosting",
          value: KeyphraseBoostingDeleteKeyphrase.fromJSON(object.delete_keyphrase_boosting),
        }
        : isSet(object.voiceAddAgentVoice)
        ? { $case: "voiceAddAgentVoice", value: VoiceAddAgentVoice.fromJSON(object.voiceAddAgentVoice) }
        : isSet(object.voice_add_agent_voice)
        ? { $case: "voiceAddAgentVoice", value: VoiceAddAgentVoice.fromJSON(object.voice_add_agent_voice) }
        : isSet(object.voiceDeleteAgentVoice)
        ? { $case: "voiceDeleteAgentVoice", value: VoiceDeleteAgentVoice.fromJSON(object.voiceDeleteAgentVoice) }
        : isSet(object.voice_delete_agent_voice)
        ? { $case: "voiceDeleteAgentVoice", value: VoiceDeleteAgentVoice.fromJSON(object.voice_delete_agent_voice) }
        : isSet(object.voiceUpdateAgentVoice)
        ? { $case: "voiceUpdateAgentVoice", value: VoiceUpdateAgentVoice.fromJSON(object.voiceUpdateAgentVoice) }
        : isSet(object.voice_update_agent_voice)
        ? { $case: "voiceUpdateAgentVoice", value: VoiceUpdateAgentVoice.fromJSON(object.voice_update_agent_voice) }
        : isSet(object.voiceCreateAgentVoiceSettings)
        ? {
          $case: "voiceCreateAgentVoiceSettings",
          value: VoiceCreateAgentVoiceSettings.fromJSON(object.voiceCreateAgentVoiceSettings),
        }
        : isSet(object.voice_create_agent_voice_settings)
        ? {
          $case: "voiceCreateAgentVoiceSettings",
          value: VoiceCreateAgentVoiceSettings.fromJSON(object.voice_create_agent_voice_settings),
        }
        : isSet(object.voiceUpdateAgentVoiceSettings)
        ? {
          $case: "voiceUpdateAgentVoiceSettings",
          value: VoiceUpdateAgentVoiceSettings.fromJSON(object.voiceUpdateAgentVoiceSettings),
        }
        : isSet(object.voice_update_agent_voice_settings)
        ? {
          $case: "voiceUpdateAgentVoiceSettings",
          value: VoiceUpdateAgentVoiceSettings.fromJSON(object.voice_update_agent_voice_settings),
        }
        : isSet(object.voiceUpdateDisclaimerVoice)
        ? {
          $case: "voiceUpdateDisclaimerVoice",
          value: VoiceUpdateDisclaimerVoice.fromJSON(object.voiceUpdateDisclaimerVoice),
        }
        : isSet(object.voice_update_disclaimer_voice)
        ? {
          $case: "voiceUpdateDisclaimerVoice",
          value: VoiceUpdateDisclaimerVoice.fromJSON(object.voice_update_disclaimer_voice),
        }
        : isSet(object.voiceCreateDisclaimerVoiceSettings)
        ? {
          $case: "voiceCreateDisclaimerVoiceSettings",
          value: VoiceCreateDisclaimerVoiceSettings.fromJSON(object.voiceCreateDisclaimerVoiceSettings),
        }
        : isSet(object.voice_create_disclaimer_voice_settings)
        ? {
          $case: "voiceCreateDisclaimerVoiceSettings",
          value: VoiceCreateDisclaimerVoiceSettings.fromJSON(object.voice_create_disclaimer_voice_settings),
        }
        : isSet(object.voiceUpdateDisclaimerVoiceSettings)
        ? {
          $case: "voiceUpdateDisclaimerVoiceSettings",
          value: VoiceUpdateDisclaimerVoiceSettings.fromJSON(object.voiceUpdateDisclaimerVoiceSettings),
        }
        : isSet(object.voice_update_disclaimer_voice_settings)
        ? {
          $case: "voiceUpdateDisclaimerVoiceSettings",
          value: VoiceUpdateDisclaimerVoiceSettings.fromJSON(object.voice_update_disclaimer_voice_settings),
        }
        : isSet(object.voiceAddFavoriteVoice)
        ? { $case: "voiceAddFavoriteVoice", value: VoiceAddFavoriteVoice.fromJSON(object.voiceAddFavoriteVoice) }
        : isSet(object.voice_add_favorite_voice)
        ? { $case: "voiceAddFavoriteVoice", value: VoiceAddFavoriteVoice.fromJSON(object.voice_add_favorite_voice) }
        : isSet(object.voiceRemoveFavoriteVoice)
        ? {
          $case: "voiceRemoveFavoriteVoice",
          value: VoiceRemoveFavoriteVoice.fromJSON(object.voiceRemoveFavoriteVoice),
        }
        : isSet(object.voice_remove_favorite_voice)
        ? {
          $case: "voiceRemoveFavoriteVoice",
          value: VoiceRemoveFavoriteVoice.fromJSON(object.voice_remove_favorite_voice),
        }
        : isSet(object.branchTriggerMerge)
        ? { $case: "branchTriggerMerge", value: BranchTriggerMerge.fromJSON(object.branchTriggerMerge) }
        : isSet(object.branch_trigger_merge)
        ? { $case: "branchTriggerMerge", value: BranchTriggerMerge.fromJSON(object.branch_trigger_merge) }
        : isSet(object.branchCreated)
        ? { $case: "branchCreated", value: BranchCreated.fromJSON(object.branchCreated) }
        : isSet(object.branch_created)
        ? { $case: "branchCreated", value: BranchCreated.fromJSON(object.branch_created) }
        : isSet(object.branchMerged)
        ? { $case: "branchMerged", value: BranchMerged.fromJSON(object.branchMerged) }
        : isSet(object.branch_merged)
        ? { $case: "branchMerged", value: BranchMerged.fromJSON(object.branch_merged) }
        : isSet(object.branchDeleted)
        ? { $case: "branchDeleted", value: BranchDeleted.fromJSON(object.branchDeleted) }
        : isSet(object.branch_deleted)
        ? { $case: "branchDeleted", value: BranchDeleted.fromJSON(object.branch_deleted) }
        : isSet(object.projectCreated)
        ? { $case: "projectCreated", value: ProjectCreated.fromJSON(object.projectCreated) }
        : isSet(object.project_created)
        ? { $case: "projectCreated", value: ProjectCreated.fromJSON(object.project_created) }
        : isSet(object.projectLoadedFromJupiter)
        ? {
          $case: "projectLoadedFromJupiter",
          value: ProjectLoadedFromJupiter.fromJSON(object.projectLoadedFromJupiter),
        }
        : isSet(object.project_loaded_from_jupiter)
        ? {
          $case: "projectLoadedFromJupiter",
          value: ProjectLoadedFromJupiter.fromJSON(object.project_loaded_from_jupiter),
        }
        : isSet(object.deploymentCompleted)
        ? { $case: "deploymentCompleted", value: DeploymentCompleted.fromJSON(object.deploymentCompleted) }
        : isSet(object.deployment_completed)
        ? { $case: "deploymentCompleted", value: DeploymentCompleted.fromJSON(object.deployment_completed) }
        : isSet(object.deploymentRollback)
        ? { $case: "deploymentRollback", value: DeploymentRollback.fromJSON(object.deploymentRollback) }
        : isSet(object.deployment_rollback)
        ? { $case: "deploymentRollback", value: DeploymentRollback.fromJSON(object.deployment_rollback) }
        : isSet(object.entityCreate)
        ? { $case: "entityCreate", value: EntityCreate.fromJSON(object.entityCreate) }
        : isSet(object.entity_create)
        ? { $case: "entityCreate", value: EntityCreate.fromJSON(object.entity_create) }
        : isSet(object.entityUpdate)
        ? { $case: "entityUpdate", value: EntityUpdate.fromJSON(object.entityUpdate) }
        : isSet(object.entity_update)
        ? { $case: "entityUpdate", value: EntityUpdate.fromJSON(object.entity_update) }
        : isSet(object.entityDelete)
        ? { $case: "entityDelete", value: EntityDelete.fromJSON(object.entityDelete) }
        : isSet(object.entity_delete)
        ? { $case: "entityDelete", value: EntityDelete.fromJSON(object.entity_delete) }
        : isSet(object.variableCreate)
        ? { $case: "variableCreate", value: VariableCreate.fromJSON(object.variableCreate) }
        : isSet(object.variable_create)
        ? { $case: "variableCreate", value: VariableCreate.fromJSON(object.variable_create) }
        : isSet(object.variableUpdate)
        ? { $case: "variableUpdate", value: VariableUpdate.fromJSON(object.variableUpdate) }
        : isSet(object.variable_update)
        ? { $case: "variableUpdate", value: VariableUpdate.fromJSON(object.variable_update) }
        : isSet(object.variableDelete)
        ? { $case: "variableDelete", value: VariableDelete.fromJSON(object.variableDelete) }
        : isSet(object.variable_delete)
        ? { $case: "variableDelete", value: VariableDelete.fromJSON(object.variable_delete) }
        : isSet(object.functionDeploymentCompleted)
        ? {
          $case: "functionDeploymentCompleted",
          value: FunctionDeploymentCompleted.fromJSON(object.functionDeploymentCompleted),
        }
        : isSet(object.function_deployment_completed)
        ? {
          $case: "functionDeploymentCompleted",
          value: FunctionDeploymentCompleted.fromJSON(object.function_deployment_completed),
        }
        : isSet(object.createApiIntegration)
        ? { $case: "createApiIntegration", value: ApiIntegrationCreate.fromJSON(object.createApiIntegration) }
        : isSet(object.create_api_integration)
        ? { $case: "createApiIntegration", value: ApiIntegrationCreate.fromJSON(object.create_api_integration) }
        : isSet(object.updateApiIntegration)
        ? { $case: "updateApiIntegration", value: ApiIntegrationUpdate.fromJSON(object.updateApiIntegration) }
        : isSet(object.update_api_integration)
        ? { $case: "updateApiIntegration", value: ApiIntegrationUpdate.fromJSON(object.update_api_integration) }
        : isSet(object.deleteApiIntegration)
        ? { $case: "deleteApiIntegration", value: ApiIntegrationDelete.fromJSON(object.deleteApiIntegration) }
        : isSet(object.delete_api_integration)
        ? { $case: "deleteApiIntegration", value: ApiIntegrationDelete.fromJSON(object.delete_api_integration) }
        : isSet(object.updateApiIntegrationConfig)
        ? {
          $case: "updateApiIntegrationConfig",
          value: ApiIntegrationConfigUpdate.fromJSON(object.updateApiIntegrationConfig),
        }
        : isSet(object.update_api_integration_config)
        ? {
          $case: "updateApiIntegrationConfig",
          value: ApiIntegrationConfigUpdate.fromJSON(object.update_api_integration_config),
        }
        : isSet(object.createApiIntegrationOperation)
        ? {
          $case: "createApiIntegrationOperation",
          value: ApiIntegrationOperationCreate.fromJSON(object.createApiIntegrationOperation),
        }
        : isSet(object.create_api_integration_operation)
        ? {
          $case: "createApiIntegrationOperation",
          value: ApiIntegrationOperationCreate.fromJSON(object.create_api_integration_operation),
        }
        : isSet(object.updateApiIntegrationOperation)
        ? {
          $case: "updateApiIntegrationOperation",
          value: ApiIntegrationOperationUpdate.fromJSON(object.updateApiIntegrationOperation),
        }
        : isSet(object.update_api_integration_operation)
        ? {
          $case: "updateApiIntegrationOperation",
          value: ApiIntegrationOperationUpdate.fromJSON(object.update_api_integration_operation),
        }
        : isSet(object.deleteApiIntegrationOperation)
        ? {
          $case: "deleteApiIntegrationOperation",
          value: ApiIntegrationOperationDelete.fromJSON(object.deleteApiIntegrationOperation),
        }
        : isSet(object.delete_api_integration_operation)
        ? {
          $case: "deleteApiIntegrationOperation",
          value: ApiIntegrationOperationDelete.fromJSON(object.delete_api_integration_operation),
        }
        : isSet(object.createTranslation)
        ? { $case: "createTranslation", value: LanguageHubTranslationsCreate.fromJSON(object.createTranslation) }
        : isSet(object.create_translation)
        ? { $case: "createTranslation", value: LanguageHubTranslationsCreate.fromJSON(object.create_translation) }
        : isSet(object.updateTranslation)
        ? { $case: "updateTranslation", value: LanguageHubTranslationsUpdate.fromJSON(object.updateTranslation) }
        : isSet(object.update_translation)
        ? { $case: "updateTranslation", value: LanguageHubTranslationsUpdate.fromJSON(object.update_translation) }
        : isSet(object.deleteTranslation)
        ? { $case: "deleteTranslation", value: LanguageHubTranslationsDelete.fromJSON(object.deleteTranslation) }
        : isSet(object.delete_translation)
        ? { $case: "deleteTranslation", value: LanguageHubTranslationsDelete.fromJSON(object.delete_translation) }
        : isSet(object.voiceChannelUpdateAsrSettings)
        ? {
          $case: "voiceChannelUpdateAsrSettings",
          value: VoiceChannelUpdateASRSettings.fromJSON(object.voiceChannelUpdateAsrSettings),
        }
        : isSet(object.voice_channel_update_asr_settings)
        ? {
          $case: "voiceChannelUpdateAsrSettings",
          value: VoiceChannelUpdateASRSettings.fromJSON(object.voice_channel_update_asr_settings),
        }
        : isSet(object.voiceChannelUpdateDisclaimer)
        ? {
          $case: "voiceChannelUpdateDisclaimer",
          value: VoiceChannelUpdateDisclaimer.fromJSON(object.voiceChannelUpdateDisclaimer),
        }
        : isSet(object.voice_channel_update_disclaimer)
        ? {
          $case: "voiceChannelUpdateDisclaimer",
          value: VoiceChannelUpdateDisclaimer.fromJSON(object.voice_channel_update_disclaimer),
        }
        : isSet(object.voiceChannelUpdateVadConfig)
        ? {
          $case: "voiceChannelUpdateVadConfig",
          value: VoiceChannelUpdateVadConfig.fromJSON(object.voiceChannelUpdateVadConfig),
        }
        : isSet(object.voice_channel_update_vad_config)
        ? {
          $case: "voiceChannelUpdateVadConfig",
          value: VoiceChannelUpdateVadConfig.fromJSON(object.voice_channel_update_vad_config),
        }
        : isSet(object.voiceChannelUpdateAudioEnhancement)
        ? {
          $case: "voiceChannelUpdateAudioEnhancement",
          value: VoiceChannelUpdateAudioEnhancement.fromJSON(object.voiceChannelUpdateAudioEnhancement),
        }
        : isSet(object.voice_channel_update_audio_enhancement)
        ? {
          $case: "voiceChannelUpdateAudioEnhancement",
          value: VoiceChannelUpdateAudioEnhancement.fromJSON(object.voice_channel_update_audio_enhancement),
        }
        : isSet(object.voiceChannelUpdateSilenceFillerUtterances)
        ? {
          $case: "voiceChannelUpdateSilenceFillerUtterances",
          value: VoiceChannelUpdateSilenceFillerUtterances.fromJSON(object.voiceChannelUpdateSilenceFillerUtterances),
        }
        : isSet(object.voice_channel_update_silence_filler_utterances)
        ? {
          $case: "voiceChannelUpdateSilenceFillerUtterances",
          value: VoiceChannelUpdateSilenceFillerUtterances.fromJSON(
            object.voice_channel_update_silence_filler_utterances,
          ),
        }
        : isSet(object.voiceChannelUpdateAsrConfig)
        ? {
          $case: "voiceChannelUpdateAsrConfig",
          value: VoiceChannelUpdateAsrConfig.fromJSON(object.voiceChannelUpdateAsrConfig),
        }
        : isSet(object.voice_channel_update_asr_config)
        ? {
          $case: "voiceChannelUpdateAsrConfig",
          value: VoiceChannelUpdateAsrConfig.fromJSON(object.voice_channel_update_asr_config),
        }
        : isSet(object.voiceChannelUpdateBargeInConfig)
        ? {
          $case: "voiceChannelUpdateBargeInConfig",
          value: VoiceChannelUpdateBargeInConfig.fromJSON(object.voiceChannelUpdateBargeInConfig),
        }
        : isSet(object.voice_channel_update_barge_in_config)
        ? {
          $case: "voiceChannelUpdateBargeInConfig",
          value: VoiceChannelUpdateBargeInConfig.fromJSON(object.voice_channel_update_barge_in_config),
        }
        : isSet(object.voiceChannelUpdateTemperature)
        ? {
          $case: "voiceChannelUpdateTemperature",
          value: VoiceChannelUpdateTemperature.fromJSON(object.voiceChannelUpdateTemperature),
        }
        : isSet(object.voice_channel_update_temperature)
        ? {
          $case: "voiceChannelUpdateTemperature",
          value: VoiceChannelUpdateTemperature.fromJSON(object.voice_channel_update_temperature),
        }
        : isSet(object.voiceChannelResetBargeInConfig)
        ? {
          $case: "voiceChannelResetBargeInConfig",
          value: VoiceChannelResetBargeInConfig.fromJSON(object.voiceChannelResetBargeInConfig),
        }
        : isSet(object.voice_channel_reset_barge_in_config)
        ? {
          $case: "voiceChannelResetBargeInConfig",
          value: VoiceChannelResetBargeInConfig.fromJSON(object.voice_channel_reset_barge_in_config),
        }
        : isSet(object.voiceChannelResetTemperature)
        ? {
          $case: "voiceChannelResetTemperature",
          value: VoiceChannelResetTemperature.fromJSON(object.voiceChannelResetTemperature),
        }
        : isSet(object.voice_channel_reset_temperature)
        ? {
          $case: "voiceChannelResetTemperature",
          value: VoiceChannelResetTemperature.fromJSON(object.voice_channel_reset_temperature),
        }
        : isSet(object.voiceChannelResetVadConfig)
        ? {
          $case: "voiceChannelResetVadConfig",
          value: VoiceChannelResetVadConfig.fromJSON(object.voiceChannelResetVadConfig),
        }
        : isSet(object.voice_channel_reset_vad_config)
        ? {
          $case: "voiceChannelResetVadConfig",
          value: VoiceChannelResetVadConfig.fromJSON(object.voice_channel_reset_vad_config),
        }
        : isSet(object.voiceChannelResetAudioEnhancement)
        ? {
          $case: "voiceChannelResetAudioEnhancement",
          value: VoiceChannelResetAudioEnhancement.fromJSON(object.voiceChannelResetAudioEnhancement),
        }
        : isSet(object.voice_channel_reset_audio_enhancement)
        ? {
          $case: "voiceChannelResetAudioEnhancement",
          value: VoiceChannelResetAudioEnhancement.fromJSON(object.voice_channel_reset_audio_enhancement),
        }
        : isSet(object.voiceChannelResetSilenceFillerUtterances)
        ? {
          $case: "voiceChannelResetSilenceFillerUtterances",
          value: VoiceChannelResetSilenceFillerUtterances.fromJSON(object.voiceChannelResetSilenceFillerUtterances),
        }
        : isSet(object.voice_channel_reset_silence_filler_utterances)
        ? {
          $case: "voiceChannelResetSilenceFillerUtterances",
          value: VoiceChannelResetSilenceFillerUtterances.fromJSON(
            object.voice_channel_reset_silence_filler_utterances,
          ),
        }
        : isSet(object.voiceChannelResetAsrConfig)
        ? {
          $case: "voiceChannelResetAsrConfig",
          value: VoiceChannelResetAsrConfig.fromJSON(object.voiceChannelResetAsrConfig),
        }
        : isSet(object.voice_channel_reset_asr_config)
        ? {
          $case: "voiceChannelResetAsrConfig",
          value: VoiceChannelResetAsrConfig.fromJSON(object.voice_channel_reset_asr_config),
        }
        : isSet(object.channelUpdateGreeting)
        ? { $case: "channelUpdateGreeting", value: ChannelUpdateGreeting.fromJSON(object.channelUpdateGreeting) }
        : isSet(object.channel_update_greeting)
        ? { $case: "channelUpdateGreeting", value: ChannelUpdateGreeting.fromJSON(object.channel_update_greeting) }
        : isSet(object.channelUpdateStylePrompt)
        ? {
          $case: "channelUpdateStylePrompt",
          value: ChannelUpdateStylePrompt.fromJSON(object.channelUpdateStylePrompt),
        }
        : isSet(object.channel_update_style_prompt)
        ? {
          $case: "channelUpdateStylePrompt",
          value: ChannelUpdateStylePrompt.fromJSON(object.channel_update_style_prompt),
        }
        : isSet(object.channelUpdateSafetyFilters)
        ? {
          $case: "channelUpdateSafetyFilters",
          value: ChannelUpdateSafetyFilters.fromJSON(object.channelUpdateSafetyFilters),
        }
        : isSet(object.channel_update_safety_filters)
        ? {
          $case: "channelUpdateSafetyFilters",
          value: ChannelUpdateSafetyFilters.fromJSON(object.channel_update_safety_filters),
        }
        : isSet(object.channelUpdateLlmSettings)
        ? {
          $case: "channelUpdateLlmSettings",
          value: ChannelUpdateLLMSettings.fromJSON(object.channelUpdateLlmSettings),
        }
        : isSet(object.channel_update_llm_settings)
        ? {
          $case: "channelUpdateLlmSettings",
          value: ChannelUpdateLLMSettings.fromJSON(object.channel_update_llm_settings),
        }
        : isSet(object.channelUpdateStatus)
        ? { $case: "channelUpdateStatus", value: ChannelUpdateStatus.fromJSON(object.channelUpdateStatus) }
        : isSet(object.channel_update_status)
        ? { $case: "channelUpdateStatus", value: ChannelUpdateStatus.fromJSON(object.channel_update_status) }
        : isSet(object.csatUpdateConfig)
        ? { $case: "csatUpdateConfig", value: CSATUpdateConfig.fromJSON(object.csatUpdateConfig) }
        : isSet(object.csat_update_config)
        ? { $case: "csatUpdateConfig", value: CSATUpdateConfig.fromJSON(object.csat_update_config) }
        : isSet(object.connectIntegration)
        ? { $case: "connectIntegration", value: IntegrationConnect.fromJSON(object.connectIntegration) }
        : isSet(object.connect_integration)
        ? { $case: "connectIntegration", value: IntegrationConnect.fromJSON(object.connect_integration) }
        : isSet(object.enableIntegration)
        ? { $case: "enableIntegration", value: IntegrationEnable.fromJSON(object.enableIntegration) }
        : isSet(object.enable_integration)
        ? { $case: "enableIntegration", value: IntegrationEnable.fromJSON(object.enable_integration) }
        : isSet(object.disableIntegration)
        ? { $case: "disableIntegration", value: IntegrationDisable.fromJSON(object.disableIntegration) }
        : isSet(object.disable_integration)
        ? { $case: "disableIntegration", value: IntegrationDisable.fromJSON(object.disable_integration) }
        : isSet(object.updateIntegrationFunctions)
        ? {
          $case: "updateIntegrationFunctions",
          value: IntegrationUpdateFunctions.fromJSON(object.updateIntegrationFunctions),
        }
        : isSet(object.update_integration_functions)
        ? {
          $case: "updateIntegrationFunctions",
          value: IntegrationUpdateFunctions.fromJSON(object.update_integration_functions),
        }
        : isSet(object.disconnectIntegration)
        ? { $case: "disconnectIntegration", value: IntegrationDisconnect.fromJSON(object.disconnectIntegration) }
        : isSet(object.disconnect_integration)
        ? { $case: "disconnectIntegration", value: IntegrationDisconnect.fromJSON(object.disconnect_integration) }
        : isSet(object.updateMcpConfig)
        ? { $case: "updateMcpConfig", value: MCPConfigUpdate.fromJSON(object.updateMcpConfig) }
        : isSet(object.update_mcp_config)
        ? { $case: "updateMcpConfig", value: MCPConfigUpdate.fromJSON(object.update_mcp_config) }
        : undefined,
    };
  },

  toJSON(message: Event): unknown {
    const obj: any = {};
    if (!message.sequence.equals(Long.UZERO)) {
      obj.sequence = (message.sequence || Long.UZERO).toString();
    }
    if (message.commandId !== "") {
      obj.commandId = message.commandId;
    }
    if (message.serverTimestamp !== undefined) {
      obj.serverTimestamp = message.serverTimestamp.toISOString();
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.payload?.$case === "createTopic") {
      obj.createTopic = KnowledgeBaseCreateTopic.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTopic") {
      obj.updateTopic = KnowledgeBaseUpdateTopic.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteTopic") {
      obj.deleteTopic = KnowledgeBaseDeleteTopic.toJSON(message.payload.value);
    } else if (message.payload?.$case === "importTopics") {
      obj.importTopics = KnowledgeBaseImportTopics.toJSON(message.payload.value);
    } else if (message.payload?.$case === "toggleTopicStatus") {
      obj.toggleTopicStatus = KnowledgeBaseToggleTopicStatus.toJSON(message.payload.value);
    } else if (message.payload?.$case === "smsCreateTemplate") {
      obj.smsCreateTemplate = SMSCreateTemplate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "smsUpdateTemplate") {
      obj.smsUpdateTemplate = SMSUpdateTemplate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "smsDeleteTemplate") {
      obj.smsDeleteTemplate = SMSDeleteTemplate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffCreate") {
      obj.handoffCreate = HandoffCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffUpdate") {
      obj.handoffUpdate = HandoffUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffDelete") {
      obj.handoffDelete = HandoffDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffSetDefault") {
      obj.handoffSetDefault = HandoffSetDefault.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffResetHandoffConfigs") {
      obj.handoffResetHandoffConfigs = HandoffResetHandoffConfigs.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFlowStep") {
      obj.createFlowStep = FlowCreateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStep") {
      obj.updateFlowStep = FlowUpdateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFlowStep") {
      obj.deleteFlowStep = FlowDeleteStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepPosition") {
      obj.updateFlowStepPosition = FlowUpdateStepPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepPositions") {
      obj.updateFlowStepPositions = FlowUpdateStepPositions.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepDtmfConfig") {
      obj.updateFlowStepDtmfConfig = FlowUpdateStepDtmfConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepAsrConfig") {
      obj.updateFlowStepAsrConfig = FlowUpdateStepAsrConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFlowTransitionFunction") {
      obj.createFlowTransitionFunction = FlowCreateTransitionFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowTransitionFunction") {
      obj.updateFlowTransitionFunction = FlowUpdateTransitionFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFlowTransitionFunction") {
      obj.deleteFlowTransitionFunction = FlowDeleteTransitionFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFlow") {
      obj.deleteFlow = FlowDeleteFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFlow") {
      obj.createFlow = FlowCreateFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "importFlow") {
      obj.importFlow = FlowImportFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlow") {
      obj.updateFlow = FlowUpdateFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowTransitionFunctionLatencyControl") {
      obj.updateFlowTransitionFunctionLatencyControl = FlowUpdateTransitionFunctionLatencyControl.toJSON(
        message.payload.value,
      );
    } else if (message.payload?.$case === "createNoCodeStep") {
      obj.createNoCodeStep = CreateNoCodeStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeStep") {
      obj.updateNoCodeStep = UpdateNoCodeStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteNoCodeStep") {
      obj.deleteNoCodeStep = DeleteNoCodeStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeStepPosition") {
      obj.updateNoCodeStepPosition = UpdateNoCodeStepPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createNoCodeCondition") {
      obj.createNoCodeCondition = CreateNoCodeCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteNoCodeCondition") {
      obj.deleteNoCodeCondition = DeleteNoCodeCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeCondition") {
      obj.updateNoCodeCondition = UpdateNoCodeCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeConditionPosition") {
      obj.updateNoCodeConditionPosition = UpdateNoCodeConditionPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeConditionExitFlowPosition") {
      obj.updateNoCodeConditionExitFlowPosition = UpdateNoCodeConditionExitFlowPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "moveFlowComponent") {
      obj.moveFlowComponent = MoveFlowComponent.toJSON(message.payload.value);
    } else if (message.payload?.$case === "moveFlowComponents") {
      obj.moveFlowComponents = MoveFlowComponents.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createStep") {
      obj.createStep = CreateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStep") {
      obj.updateStep = UpdateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteStep") {
      obj.deleteStep = DeleteStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createStepCondition") {
      obj.createStepCondition = CreateStepCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStepCondition") {
      obj.updateStepCondition = UpdateStepCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteStepCondition") {
      obj.deleteStepCondition = DeleteStepCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStepConditionPosition") {
      obj.updateStepConditionPosition = UpdateStepConditionPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantCreateAttribute") {
      obj.variantCreateAttribute = VariantCreateAttribute.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantUpdateAttribute") {
      obj.variantUpdateAttribute = VariantUpdateAttribute.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantDeleteAttribute") {
      obj.variantDeleteAttribute = VariantDeleteAttribute.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantCreateVariant") {
      obj.variantCreateVariant = VariantCreateVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantUpdateVariant") {
      obj.variantUpdateVariant = VariantUpdateVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantDeleteVariant") {
      obj.variantDeleteVariant = VariantDeleteVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantSetDefaultVariant") {
      obj.variantSetDefaultVariant = VariantSetDefaultVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantImportVariants") {
      obj.variantImportVariants = VariantImportVariants.toJSON(message.payload.value);
    } else if (message.payload?.$case === "stopKeywordsCreate") {
      obj.stopKeywordsCreate = StopKeywordCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "stopKeywordsUpdate") {
      obj.stopKeywordsUpdate = StopKeywordUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "stopKeywordsDelete") {
      obj.stopKeywordsDelete = StopKeywordDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateLlmSettings") {
      obj.updateLlmSettings = LLMSettingsUpdateLLMSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateContentFilterSettings") {
      obj.updateContentFilterSettings = ContentFilterSettingsUpdateContentFilterSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateAsrSettings") {
      obj.updateAsrSettings = ASRSettingsUpdateASRSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTtsSettings") {
      obj.updateTtsSettings = LanguagesUpdateDefaultLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "languagesUpdateDefaultLanguage") {
      obj.languagesUpdateDefaultLanguage = LanguagesUpdateDefaultLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "languagesAddLanguage") {
      obj.languagesAddLanguage = LanguagesAddLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "languagesDeleteLanguage") {
      obj.languagesDeleteLanguage = LanguagesDeleteLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "experimentalConfigUpdateConfig") {
      obj.experimentalConfigUpdateConfig = ExperimentalConfigUpdateConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsCreatePronunciation") {
      obj.pronunciationsCreatePronunciation = PronunciationsCreatePronunciation.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsUpdatePronunciation") {
      obj.pronunciationsUpdatePronunciation = PronunciationsUpdatePronunciation.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsDeletePronunciation") {
      obj.pronunciationsDeletePronunciation = PronunciationsDeletePronunciation.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsReorderPronunciations") {
      obj.pronunciationsReorderPronunciations = PronunciationsReorderPronunciations.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createTranscriptCorrections") {
      obj.createTranscriptCorrections = TranscriptCorrectionsCreateTranscriptCorrections.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTranscriptCorrections") {
      obj.updateTranscriptCorrections = TranscriptCorrectionsUpdateTranscriptCorrections.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteTranscriptCorrections") {
      obj.deleteTranscriptCorrections = TranscriptCorrectionsDeleteTranscriptCorrections.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateGreeting") {
      obj.updateGreeting = GreetingUpdateGreeting.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updatePersonality") {
      obj.updatePersonality = PersonalityUpdatePersonality.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateRole") {
      obj.updateRole = RoleUpdateRole.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateDisclaimerMessage") {
      obj.updateDisclaimerMessage = DisclaimerMessageUpdateDisclaimerMessage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateRules") {
      obj.updateRules = RulesUpdateRules.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateLanguageBehavior") {
      obj.updateLanguageBehavior = LanguageBehaviorUpdateLanguageBehavior.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFunction") {
      obj.createFunction = FunctionCreateFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFunction") {
      obj.updateFunction = FunctionUpdateFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFunction") {
      obj.deleteFunction = FunctionDeleteFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateLatencyControl") {
      obj.updateLatencyControl = FunctionUpdateLatencyControl.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createStartFunction") {
      obj.createStartFunction = StartFunctionCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStartFunction") {
      obj.updateStartFunction = StartFunctionUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteStartFunction") {
      obj.deleteStartFunction = StartFunctionDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createEndFunction") {
      obj.createEndFunction = EndFunctionCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateEndFunction") {
      obj.updateEndFunction = EndFunctionUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteEndFunction") {
      obj.deleteEndFunction = EndFunctionDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createKeyphraseBoosting") {
      obj.createKeyphraseBoosting = KeyphraseBoostingCreateKeyphrase.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateKeyphraseBoosting") {
      obj.updateKeyphraseBoosting = KeyphraseBoostingUpdateKeyphrase.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteKeyphraseBoosting") {
      obj.deleteKeyphraseBoosting = KeyphraseBoostingDeleteKeyphrase.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceAddAgentVoice") {
      obj.voiceAddAgentVoice = VoiceAddAgentVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceDeleteAgentVoice") {
      obj.voiceDeleteAgentVoice = VoiceDeleteAgentVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateAgentVoice") {
      obj.voiceUpdateAgentVoice = VoiceUpdateAgentVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceCreateAgentVoiceSettings") {
      obj.voiceCreateAgentVoiceSettings = VoiceCreateAgentVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateAgentVoiceSettings") {
      obj.voiceUpdateAgentVoiceSettings = VoiceUpdateAgentVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateDisclaimerVoice") {
      obj.voiceUpdateDisclaimerVoice = VoiceUpdateDisclaimerVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceCreateDisclaimerVoiceSettings") {
      obj.voiceCreateDisclaimerVoiceSettings = VoiceCreateDisclaimerVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateDisclaimerVoiceSettings") {
      obj.voiceUpdateDisclaimerVoiceSettings = VoiceUpdateDisclaimerVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceAddFavoriteVoice") {
      obj.voiceAddFavoriteVoice = VoiceAddFavoriteVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceRemoveFavoriteVoice") {
      obj.voiceRemoveFavoriteVoice = VoiceRemoveFavoriteVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "branchTriggerMerge") {
      obj.branchTriggerMerge = BranchTriggerMerge.toJSON(message.payload.value);
    } else if (message.payload?.$case === "branchCreated") {
      obj.branchCreated = BranchCreated.toJSON(message.payload.value);
    } else if (message.payload?.$case === "branchMerged") {
      obj.branchMerged = BranchMerged.toJSON(message.payload.value);
    } else if (message.payload?.$case === "branchDeleted") {
      obj.branchDeleted = BranchDeleted.toJSON(message.payload.value);
    } else if (message.payload?.$case === "projectCreated") {
      obj.projectCreated = ProjectCreated.toJSON(message.payload.value);
    } else if (message.payload?.$case === "projectLoadedFromJupiter") {
      obj.projectLoadedFromJupiter = ProjectLoadedFromJupiter.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deploymentCompleted") {
      obj.deploymentCompleted = DeploymentCompleted.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deploymentRollback") {
      obj.deploymentRollback = DeploymentRollback.toJSON(message.payload.value);
    } else if (message.payload?.$case === "entityCreate") {
      obj.entityCreate = EntityCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "entityUpdate") {
      obj.entityUpdate = EntityUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "entityDelete") {
      obj.entityDelete = EntityDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variableCreate") {
      obj.variableCreate = VariableCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variableUpdate") {
      obj.variableUpdate = VariableUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variableDelete") {
      obj.variableDelete = VariableDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "functionDeploymentCompleted") {
      obj.functionDeploymentCompleted = FunctionDeploymentCompleted.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createApiIntegration") {
      obj.createApiIntegration = ApiIntegrationCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateApiIntegration") {
      obj.updateApiIntegration = ApiIntegrationUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteApiIntegration") {
      obj.deleteApiIntegration = ApiIntegrationDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateApiIntegrationConfig") {
      obj.updateApiIntegrationConfig = ApiIntegrationConfigUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createApiIntegrationOperation") {
      obj.createApiIntegrationOperation = ApiIntegrationOperationCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateApiIntegrationOperation") {
      obj.updateApiIntegrationOperation = ApiIntegrationOperationUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteApiIntegrationOperation") {
      obj.deleteApiIntegrationOperation = ApiIntegrationOperationDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createTranslation") {
      obj.createTranslation = LanguageHubTranslationsCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTranslation") {
      obj.updateTranslation = LanguageHubTranslationsUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteTranslation") {
      obj.deleteTranslation = LanguageHubTranslationsDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateAsrSettings") {
      obj.voiceChannelUpdateAsrSettings = VoiceChannelUpdateASRSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateDisclaimer") {
      obj.voiceChannelUpdateDisclaimer = VoiceChannelUpdateDisclaimer.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateVadConfig") {
      obj.voiceChannelUpdateVadConfig = VoiceChannelUpdateVadConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateAudioEnhancement") {
      obj.voiceChannelUpdateAudioEnhancement = VoiceChannelUpdateAudioEnhancement.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateSilenceFillerUtterances") {
      obj.voiceChannelUpdateSilenceFillerUtterances = VoiceChannelUpdateSilenceFillerUtterances.toJSON(
        message.payload.value,
      );
    } else if (message.payload?.$case === "voiceChannelUpdateAsrConfig") {
      obj.voiceChannelUpdateAsrConfig = VoiceChannelUpdateAsrConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateBargeInConfig") {
      obj.voiceChannelUpdateBargeInConfig = VoiceChannelUpdateBargeInConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateTemperature") {
      obj.voiceChannelUpdateTemperature = VoiceChannelUpdateTemperature.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetBargeInConfig") {
      obj.voiceChannelResetBargeInConfig = VoiceChannelResetBargeInConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetTemperature") {
      obj.voiceChannelResetTemperature = VoiceChannelResetTemperature.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetVadConfig") {
      obj.voiceChannelResetVadConfig = VoiceChannelResetVadConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetAudioEnhancement") {
      obj.voiceChannelResetAudioEnhancement = VoiceChannelResetAudioEnhancement.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetSilenceFillerUtterances") {
      obj.voiceChannelResetSilenceFillerUtterances = VoiceChannelResetSilenceFillerUtterances.toJSON(
        message.payload.value,
      );
    } else if (message.payload?.$case === "voiceChannelResetAsrConfig") {
      obj.voiceChannelResetAsrConfig = VoiceChannelResetAsrConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateGreeting") {
      obj.channelUpdateGreeting = ChannelUpdateGreeting.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateStylePrompt") {
      obj.channelUpdateStylePrompt = ChannelUpdateStylePrompt.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateSafetyFilters") {
      obj.channelUpdateSafetyFilters = ChannelUpdateSafetyFilters.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateLlmSettings") {
      obj.channelUpdateLlmSettings = ChannelUpdateLLMSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateStatus") {
      obj.channelUpdateStatus = ChannelUpdateStatus.toJSON(message.payload.value);
    } else if (message.payload?.$case === "csatUpdateConfig") {
      obj.csatUpdateConfig = CSATUpdateConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "connectIntegration") {
      obj.connectIntegration = IntegrationConnect.toJSON(message.payload.value);
    } else if (message.payload?.$case === "enableIntegration") {
      obj.enableIntegration = IntegrationEnable.toJSON(message.payload.value);
    } else if (message.payload?.$case === "disableIntegration") {
      obj.disableIntegration = IntegrationDisable.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateIntegrationFunctions") {
      obj.updateIntegrationFunctions = IntegrationUpdateFunctions.toJSON(message.payload.value);
    } else if (message.payload?.$case === "disconnectIntegration") {
      obj.disconnectIntegration = IntegrationDisconnect.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateMcpConfig") {
      obj.updateMcpConfig = MCPConfigUpdate.toJSON(message.payload.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Event>): Event {
    return Event.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Event>): Event {
    const message = createBaseEvent();
    message.sequence = (object.sequence !== undefined && object.sequence !== null)
      ? Long.fromValue(object.sequence)
      : Long.UZERO;
    message.commandId = object.commandId ?? "";
    message.serverTimestamp = object.serverTimestamp ?? undefined;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    switch (object.payload?.$case) {
      case "createTopic": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createTopic", value: KnowledgeBaseCreateTopic.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateTopic": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteTopic": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.fromPartial(object.payload.value) };
        }
        break;
      }
      case "importTopics": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "importTopics",
            value: KnowledgeBaseImportTopics.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "toggleTopicStatus": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "toggleTopicStatus",
            value: KnowledgeBaseToggleTopicStatus.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "smsCreateTemplate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "smsCreateTemplate", value: SMSCreateTemplate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "smsUpdateTemplate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "smsDeleteTemplate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffCreate", value: HandoffCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffUpdate", value: HandoffUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffDelete", value: HandoffDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffSetDefault": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffSetDefault", value: HandoffSetDefault.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffResetHandoffConfigs": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "handoffResetHandoffConfigs",
            value: HandoffResetHandoffConfigs.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createFlowStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createFlowStep", value: FlowCreateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlowStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateFlowStep", value: FlowUpdateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteFlowStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteFlowStep", value: FlowDeleteStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlowStepPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepPosition",
            value: FlowUpdateStepPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowStepPositions": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepPositions",
            value: FlowUpdateStepPositions.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowStepDtmfConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepDtmfConfig",
            value: FlowUpdateStepDtmfConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowStepAsrConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepAsrConfig",
            value: FlowUpdateStepAsrConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createFlowTransitionFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createFlowTransitionFunction",
            value: FlowCreateTransitionFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowTransitionFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowTransitionFunction",
            value: FlowUpdateTransitionFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteFlowTransitionFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteFlowTransitionFunction",
            value: FlowDeleteTransitionFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteFlow", value: FlowDeleteFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "createFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createFlow", value: FlowCreateFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "importFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "importFlow", value: FlowImportFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateFlow", value: FlowUpdateFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlowTransitionFunctionLatencyControl": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowTransitionFunctionLatencyControl",
            value: FlowUpdateTransitionFunctionLatencyControl.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createNoCodeStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createNoCodeStep", value: CreateNoCodeStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateNoCodeStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateNoCodeStep", value: UpdateNoCodeStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteNoCodeStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateNoCodeStepPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeStepPosition",
            value: UpdateNoCodeStepPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createNoCodeCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createNoCodeCondition",
            value: CreateNoCodeCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteNoCodeCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteNoCodeCondition",
            value: DeleteNoCodeCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateNoCodeCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeCondition",
            value: UpdateNoCodeCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateNoCodeConditionPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeConditionPosition",
            value: UpdateNoCodeConditionPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateNoCodeConditionExitFlowPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeConditionExitFlowPosition",
            value: UpdateNoCodeConditionExitFlowPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "moveFlowComponent": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "moveFlowComponent", value: MoveFlowComponent.fromPartial(object.payload.value) };
        }
        break;
      }
      case "moveFlowComponents": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "moveFlowComponents",
            value: MoveFlowComponents.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createStep", value: CreateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateStep", value: UpdateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteStep", value: DeleteStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "createStepCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createStepCondition",
            value: CreateStepCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateStepCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateStepCondition",
            value: UpdateStepCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteStepCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteStepCondition",
            value: DeleteStepCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateStepConditionPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateStepConditionPosition",
            value: UpdateStepConditionPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantCreateAttribute": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantCreateAttribute",
            value: VariantCreateAttribute.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantUpdateAttribute": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantUpdateAttribute",
            value: VariantUpdateAttribute.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantDeleteAttribute": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantDeleteAttribute",
            value: VariantDeleteAttribute.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantCreateVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantCreateVariant",
            value: VariantCreateVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantUpdateVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantUpdateVariant",
            value: VariantUpdateVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantDeleteVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantDeleteVariant",
            value: VariantDeleteVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantSetDefaultVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantSetDefaultVariant",
            value: VariantSetDefaultVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantImportVariants": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantImportVariants",
            value: VariantImportVariants.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "stopKeywordsCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "stopKeywordsCreate", value: StopKeywordCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "stopKeywordsUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "stopKeywordsDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "stopKeywordsDelete", value: StopKeywordDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateLlmSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateLlmSettings",
            value: LLMSettingsUpdateLLMSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateContentFilterSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateContentFilterSettings",
            value: ContentFilterSettingsUpdateContentFilterSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateAsrSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateAsrSettings",
            value: ASRSettingsUpdateASRSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateTtsSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateTtsSettings",
            value: LanguagesUpdateDefaultLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "languagesUpdateDefaultLanguage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "languagesUpdateDefaultLanguage",
            value: LanguagesUpdateDefaultLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "languagesAddLanguage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "languagesAddLanguage",
            value: LanguagesAddLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "languagesDeleteLanguage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "languagesDeleteLanguage",
            value: LanguagesDeleteLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "experimentalConfigUpdateConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "experimentalConfigUpdateConfig",
            value: ExperimentalConfigUpdateConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsCreatePronunciation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsCreatePronunciation",
            value: PronunciationsCreatePronunciation.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsUpdatePronunciation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsUpdatePronunciation",
            value: PronunciationsUpdatePronunciation.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsDeletePronunciation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsDeletePronunciation",
            value: PronunciationsDeletePronunciation.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsReorderPronunciations": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsReorderPronunciations",
            value: PronunciationsReorderPronunciations.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createTranscriptCorrections": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createTranscriptCorrections",
            value: TranscriptCorrectionsCreateTranscriptCorrections.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateTranscriptCorrections": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateTranscriptCorrections",
            value: TranscriptCorrectionsUpdateTranscriptCorrections.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteTranscriptCorrections": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteTranscriptCorrections",
            value: TranscriptCorrectionsDeleteTranscriptCorrections.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateGreeting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateGreeting",
            value: GreetingUpdateGreeting.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updatePersonality": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updatePersonality",
            value: PersonalityUpdatePersonality.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateRole": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateRole", value: RoleUpdateRole.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateDisclaimerMessage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateDisclaimerMessage",
            value: DisclaimerMessageUpdateDisclaimerMessage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateRules": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateRules", value: RulesUpdateRules.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateLanguageBehavior": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateLanguageBehavior",
            value: LanguageBehaviorUpdateLanguageBehavior.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createFunction",
            value: FunctionCreateFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFunction",
            value: FunctionUpdateFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteFunction",
            value: FunctionDeleteFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateLatencyControl": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateLatencyControl",
            value: FunctionUpdateLatencyControl.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createStartFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createStartFunction",
            value: StartFunctionCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateStartFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateStartFunction",
            value: StartFunctionUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteStartFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteStartFunction",
            value: StartFunctionDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createEndFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createEndFunction", value: EndFunctionCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateEndFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateEndFunction", value: EndFunctionUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteEndFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteEndFunction", value: EndFunctionDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "createKeyphraseBoosting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createKeyphraseBoosting",
            value: KeyphraseBoostingCreateKeyphrase.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateKeyphraseBoosting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateKeyphraseBoosting",
            value: KeyphraseBoostingUpdateKeyphrase.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteKeyphraseBoosting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteKeyphraseBoosting",
            value: KeyphraseBoostingDeleteKeyphrase.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceAddAgentVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceAddAgentVoice",
            value: VoiceAddAgentVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceDeleteAgentVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceDeleteAgentVoice",
            value: VoiceDeleteAgentVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateAgentVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateAgentVoice",
            value: VoiceUpdateAgentVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceCreateAgentVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceCreateAgentVoiceSettings",
            value: VoiceCreateAgentVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateAgentVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateAgentVoiceSettings",
            value: VoiceUpdateAgentVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateDisclaimerVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateDisclaimerVoice",
            value: VoiceUpdateDisclaimerVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceCreateDisclaimerVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceCreateDisclaimerVoiceSettings",
            value: VoiceCreateDisclaimerVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateDisclaimerVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateDisclaimerVoiceSettings",
            value: VoiceUpdateDisclaimerVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceAddFavoriteVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceAddFavoriteVoice",
            value: VoiceAddFavoriteVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceRemoveFavoriteVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceRemoveFavoriteVoice",
            value: VoiceRemoveFavoriteVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "branchTriggerMerge": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "branchTriggerMerge",
            value: BranchTriggerMerge.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "branchCreated": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "branchCreated", value: BranchCreated.fromPartial(object.payload.value) };
        }
        break;
      }
      case "branchMerged": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "branchMerged", value: BranchMerged.fromPartial(object.payload.value) };
        }
        break;
      }
      case "branchDeleted": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "branchDeleted", value: BranchDeleted.fromPartial(object.payload.value) };
        }
        break;
      }
      case "projectCreated": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "projectCreated", value: ProjectCreated.fromPartial(object.payload.value) };
        }
        break;
      }
      case "projectLoadedFromJupiter": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "projectLoadedFromJupiter",
            value: ProjectLoadedFromJupiter.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deploymentCompleted": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deploymentCompleted",
            value: DeploymentCompleted.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deploymentRollback": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deploymentRollback",
            value: DeploymentRollback.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "entityCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "entityCreate", value: EntityCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "entityUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "entityUpdate", value: EntityUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "entityDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "entityDelete", value: EntityDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "variableCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "variableCreate", value: VariableCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "variableUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "variableUpdate", value: VariableUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "variableDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "variableDelete", value: VariableDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "functionDeploymentCompleted": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "functionDeploymentCompleted",
            value: FunctionDeploymentCompleted.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createApiIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createApiIntegration",
            value: ApiIntegrationCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateApiIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateApiIntegration",
            value: ApiIntegrationUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteApiIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteApiIntegration",
            value: ApiIntegrationDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateApiIntegrationConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateApiIntegrationConfig",
            value: ApiIntegrationConfigUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createApiIntegrationOperation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createApiIntegrationOperation",
            value: ApiIntegrationOperationCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateApiIntegrationOperation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateApiIntegrationOperation",
            value: ApiIntegrationOperationUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteApiIntegrationOperation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteApiIntegrationOperation",
            value: ApiIntegrationOperationDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createTranslation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createTranslation",
            value: LanguageHubTranslationsCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateTranslation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateTranslation",
            value: LanguageHubTranslationsUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteTranslation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteTranslation",
            value: LanguageHubTranslationsDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateAsrSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateAsrSettings",
            value: VoiceChannelUpdateASRSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateDisclaimer": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateDisclaimer",
            value: VoiceChannelUpdateDisclaimer.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateVadConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateVadConfig",
            value: VoiceChannelUpdateVadConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateAudioEnhancement": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateAudioEnhancement",
            value: VoiceChannelUpdateAudioEnhancement.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateSilenceFillerUtterances": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateSilenceFillerUtterances",
            value: VoiceChannelUpdateSilenceFillerUtterances.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateAsrConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateAsrConfig",
            value: VoiceChannelUpdateAsrConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateBargeInConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateBargeInConfig",
            value: VoiceChannelUpdateBargeInConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateTemperature": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateTemperature",
            value: VoiceChannelUpdateTemperature.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetBargeInConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetBargeInConfig",
            value: VoiceChannelResetBargeInConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetTemperature": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetTemperature",
            value: VoiceChannelResetTemperature.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetVadConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetVadConfig",
            value: VoiceChannelResetVadConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetAudioEnhancement": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetAudioEnhancement",
            value: VoiceChannelResetAudioEnhancement.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetSilenceFillerUtterances": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetSilenceFillerUtterances",
            value: VoiceChannelResetSilenceFillerUtterances.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetAsrConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetAsrConfig",
            value: VoiceChannelResetAsrConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateGreeting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateGreeting",
            value: ChannelUpdateGreeting.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateStylePrompt": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateStylePrompt",
            value: ChannelUpdateStylePrompt.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateSafetyFilters": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateSafetyFilters",
            value: ChannelUpdateSafetyFilters.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateLlmSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateLlmSettings",
            value: ChannelUpdateLLMSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateStatus": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateStatus",
            value: ChannelUpdateStatus.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "csatUpdateConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "csatUpdateConfig", value: CSATUpdateConfig.fromPartial(object.payload.value) };
        }
        break;
      }
      case "connectIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "connectIntegration",
            value: IntegrationConnect.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "enableIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "enableIntegration", value: IntegrationEnable.fromPartial(object.payload.value) };
        }
        break;
      }
      case "disableIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "disableIntegration",
            value: IntegrationDisable.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateIntegrationFunctions": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateIntegrationFunctions",
            value: IntegrationUpdateFunctions.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "disconnectIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "disconnectIntegration",
            value: IntegrationDisconnect.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateMcpConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateMcpConfig", value: MCPConfigUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseEventBatch(): EventBatch {
  return { events: [] };
}

export const EventBatch: MessageFns<EventBatch> = {
  encode(message: EventBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      Event.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.events.push(Event.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventBatch {
    return { events: globalThis.Array.isArray(object?.events) ? object.events.map((e: any) => Event.fromJSON(e)) : [] };
  },

  toJSON(message: EventBatch): unknown {
    const obj: any = {};
    if (message.events?.length) {
      obj.events = message.events.map((e) => Event.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<EventBatch>): EventBatch {
    return EventBatch.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EventBatch>): EventBatch {
    const message = createBaseEventBatch();
    message.events = object.events?.map((e) => Event.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetProjection(): SetProjection {
  return { sequence: Long.UZERO, projection: new Uint8Array(0), serverTimestamp: undefined };
}

export const SetProjection: MessageFns<SetProjection> = {
  encode(message: SetProjection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (!message.sequence.equals(Long.UZERO)) {
      writer.uint32(8).uint64(message.sequence.toString());
    }
    if (message.projection.length !== 0) {
      writer.uint32(18).bytes(message.projection);
    }
    if (message.serverTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.serverTimestamp), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetProjection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetProjection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sequence = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projection = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serverTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetProjection {
    return {
      sequence: isSet(object.sequence) ? Long.fromValue(object.sequence) : Long.UZERO,
      projection: isSet(object.projection) ? bytesFromBase64(object.projection) : new Uint8Array(0),
      serverTimestamp: isSet(object.serverTimestamp)
        ? fromJsonTimestamp(object.serverTimestamp)
        : isSet(object.server_timestamp)
        ? fromJsonTimestamp(object.server_timestamp)
        : undefined,
    };
  },

  toJSON(message: SetProjection): unknown {
    const obj: any = {};
    if (!message.sequence.equals(Long.UZERO)) {
      obj.sequence = (message.sequence || Long.UZERO).toString();
    }
    if (message.projection.length !== 0) {
      obj.projection = base64FromBytes(message.projection);
    }
    if (message.serverTimestamp !== undefined) {
      obj.serverTimestamp = message.serverTimestamp.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<SetProjection>): SetProjection {
    return SetProjection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetProjection>): SetProjection {
    const message = createBaseSetProjection();
    message.sequence = (object.sequence !== undefined && object.sequence !== null)
      ? Long.fromValue(object.sequence)
      : Long.UZERO;
    message.projection = object.projection ?? new Uint8Array(0);
    message.serverTimestamp = object.serverTimestamp ?? undefined;
    return message;
  },
};

function createBaseSocketError(): SocketError {
  return { message: "" };
}

export const SocketError: MessageFns<SocketError> = {
  encode(message: SocketError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SocketError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSocketError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SocketError {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: SocketError): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create(base?: DeepPartial<SocketError>): SocketError {
    return SocketError.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SocketError>): SocketError {
    const message = createBaseSocketError();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseEnvelope(): Envelope {
  return { message: undefined };
}

export const Envelope: MessageFns<Envelope> = {
  encode(message: Envelope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "eventBatch":
        EventBatch.encode(message.message.value, writer.uint32(10).fork()).join();
        break;
      case "setProjection":
        SetProjection.encode(message.message.value, writer.uint32(18).fork()).join();
        break;
      case "notification":
        Notification.encode(message.message.value, writer.uint32(26).fork()).join();
        break;
      case "error":
        SocketError.encode(message.message.value, writer.uint32(34).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Envelope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnvelope();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = { $case: "eventBatch", value: EventBatch.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = { $case: "setProjection", value: SetProjection.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = { $case: "notification", value: Notification.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = { $case: "error", value: SocketError.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Envelope {
    return {
      message: isSet(object.eventBatch)
        ? { $case: "eventBatch", value: EventBatch.fromJSON(object.eventBatch) }
        : isSet(object.event_batch)
        ? { $case: "eventBatch", value: EventBatch.fromJSON(object.event_batch) }
        : isSet(object.setProjection)
        ? { $case: "setProjection", value: SetProjection.fromJSON(object.setProjection) }
        : isSet(object.set_projection)
        ? { $case: "setProjection", value: SetProjection.fromJSON(object.set_projection) }
        : isSet(object.notification)
        ? { $case: "notification", value: Notification.fromJSON(object.notification) }
        : isSet(object.error)
        ? { $case: "error", value: SocketError.fromJSON(object.error) }
        : undefined,
    };
  },

  toJSON(message: Envelope): unknown {
    const obj: any = {};
    if (message.message?.$case === "eventBatch") {
      obj.eventBatch = EventBatch.toJSON(message.message.value);
    } else if (message.message?.$case === "setProjection") {
      obj.setProjection = SetProjection.toJSON(message.message.value);
    } else if (message.message?.$case === "notification") {
      obj.notification = Notification.toJSON(message.message.value);
    } else if (message.message?.$case === "error") {
      obj.error = SocketError.toJSON(message.message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Envelope>): Envelope {
    return Envelope.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Envelope>): Envelope {
    const message = createBaseEnvelope();
    switch (object.message?.$case) {
      case "eventBatch": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "eventBatch", value: EventBatch.fromPartial(object.message.value) };
        }
        break;
      }
      case "setProjection": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "setProjection", value: SetProjection.fromPartial(object.message.value) };
        }
        break;
      }
      case "notification": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "notification", value: Notification.fromPartial(object.message.value) };
        }
        break;
      }
      case "error": {
        if (object.message?.value !== undefined && object.message?.value !== null) {
          message.message = { $case: "error", value: SocketError.fromPartial(object.message.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseNotification(): Notification {
  return { type: "", payload: undefined };
}

export const Notification: MessageFns<Notification> = {
  encode(message: Notification, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    switch (message.payload?.$case) {
      case "branchCreated":
        BranchCreated.encode(message.payload.value, writer.uint32(18).fork()).join();
        break;
      case "branchMerged":
        BranchMerged.encode(message.payload.value, writer.uint32(26).fork()).join();
        break;
      case "branchDeleted":
        BranchDeleted.encode(message.payload.value, writer.uint32(34).fork()).join();
        break;
      case "branchTriggerMerge":
        BranchTriggerMerge.encode(message.payload.value, writer.uint32(42).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Notification {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotification();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.payload = { $case: "branchCreated", value: BranchCreated.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payload = { $case: "branchMerged", value: BranchMerged.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.payload = { $case: "branchDeleted", value: BranchDeleted.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.payload = { $case: "branchTriggerMerge", value: BranchTriggerMerge.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Notification {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      payload: isSet(object.branchCreated)
        ? { $case: "branchCreated", value: BranchCreated.fromJSON(object.branchCreated) }
        : isSet(object.branch_created)
        ? { $case: "branchCreated", value: BranchCreated.fromJSON(object.branch_created) }
        : isSet(object.branchMerged)
        ? { $case: "branchMerged", value: BranchMerged.fromJSON(object.branchMerged) }
        : isSet(object.branch_merged)
        ? { $case: "branchMerged", value: BranchMerged.fromJSON(object.branch_merged) }
        : isSet(object.branchDeleted)
        ? { $case: "branchDeleted", value: BranchDeleted.fromJSON(object.branchDeleted) }
        : isSet(object.branch_deleted)
        ? { $case: "branchDeleted", value: BranchDeleted.fromJSON(object.branch_deleted) }
        : isSet(object.branchTriggerMerge)
        ? { $case: "branchTriggerMerge", value: BranchTriggerMerge.fromJSON(object.branchTriggerMerge) }
        : isSet(object.branch_trigger_merge)
        ? { $case: "branchTriggerMerge", value: BranchTriggerMerge.fromJSON(object.branch_trigger_merge) }
        : undefined,
    };
  },

  toJSON(message: Notification): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.payload?.$case === "branchCreated") {
      obj.branchCreated = BranchCreated.toJSON(message.payload.value);
    } else if (message.payload?.$case === "branchMerged") {
      obj.branchMerged = BranchMerged.toJSON(message.payload.value);
    } else if (message.payload?.$case === "branchDeleted") {
      obj.branchDeleted = BranchDeleted.toJSON(message.payload.value);
    } else if (message.payload?.$case === "branchTriggerMerge") {
      obj.branchTriggerMerge = BranchTriggerMerge.toJSON(message.payload.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Notification>): Notification {
    return Notification.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Notification>): Notification {
    const message = createBaseNotification();
    message.type = object.type ?? "";
    switch (object.payload?.$case) {
      case "branchCreated": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "branchCreated", value: BranchCreated.fromPartial(object.payload.value) };
        }
        break;
      }
      case "branchMerged": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "branchMerged", value: BranchMerged.fromPartial(object.payload.value) };
        }
        break;
      }
      case "branchDeleted": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "branchDeleted", value: BranchDeleted.fromPartial(object.payload.value) };
        }
        break;
      }
      case "branchTriggerMerge": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "branchTriggerMerge",
            value: BranchTriggerMerge.fromPartial(object.payload.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseCommand(): Command {
  return { type: "", metadata: undefined, commandId: "", payload: undefined };
}

export const Command: MessageFns<Command> = {
  encode(message: Command, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(1602).fork()).join();
    }
    if (message.commandId !== "") {
      writer.uint32(18).string(message.commandId);
    }
    switch (message.payload?.$case) {
      case "createTopic":
        KnowledgeBaseCreateTopic.encode(message.payload.value, writer.uint32(26).fork()).join();
        break;
      case "updateTopic":
        KnowledgeBaseUpdateTopic.encode(message.payload.value, writer.uint32(34).fork()).join();
        break;
      case "deleteTopic":
        KnowledgeBaseDeleteTopic.encode(message.payload.value, writer.uint32(42).fork()).join();
        break;
      case "importTopics":
        KnowledgeBaseImportTopics.encode(message.payload.value, writer.uint32(946).fork()).join();
        break;
      case "toggleTopicStatus":
        KnowledgeBaseToggleTopicStatus.encode(message.payload.value, writer.uint32(954).fork()).join();
        break;
      case "smsCreateTemplate":
        SMSCreateTemplate.encode(message.payload.value, writer.uint32(50).fork()).join();
        break;
      case "smsUpdateTemplate":
        SMSUpdateTemplate.encode(message.payload.value, writer.uint32(58).fork()).join();
        break;
      case "smsDeleteTemplate":
        SMSDeleteTemplate.encode(message.payload.value, writer.uint32(66).fork()).join();
        break;
      case "handoffCreate":
        HandoffCreate.encode(message.payload.value, writer.uint32(74).fork()).join();
        break;
      case "handoffUpdate":
        HandoffUpdate.encode(message.payload.value, writer.uint32(82).fork()).join();
        break;
      case "handoffDelete":
        HandoffDelete.encode(message.payload.value, writer.uint32(90).fork()).join();
        break;
      case "handoffSetDefault":
        HandoffSetDefault.encode(message.payload.value, writer.uint32(210).fork()).join();
        break;
      case "handoffResetHandoffConfigs":
        HandoffResetHandoffConfigs.encode(message.payload.value, writer.uint32(378).fork()).join();
        break;
      case "variantCreateAttribute":
        VariantCreateAttribute.encode(message.payload.value, writer.uint32(98).fork()).join();
        break;
      case "variantUpdateAttribute":
        VariantUpdateAttribute.encode(message.payload.value, writer.uint32(106).fork()).join();
        break;
      case "variantDeleteAttribute":
        VariantDeleteAttribute.encode(message.payload.value, writer.uint32(114).fork()).join();
        break;
      case "variantCreateVariant":
        VariantCreateVariant.encode(message.payload.value, writer.uint32(122).fork()).join();
        break;
      case "variantUpdateVariant":
        VariantUpdateVariant.encode(message.payload.value, writer.uint32(130).fork()).join();
        break;
      case "variantDeleteVariant":
        VariantDeleteVariant.encode(message.payload.value, writer.uint32(138).fork()).join();
        break;
      case "variantSetDefaultVariant":
        VariantSetDefaultVariant.encode(message.payload.value, writer.uint32(146).fork()).join();
        break;
      case "variantImportVariants":
        VariantImportVariants.encode(message.payload.value, writer.uint32(402).fork()).join();
        break;
      case "stopKeywordsCreate":
        StopKeywordCreate.encode(message.payload.value, writer.uint32(154).fork()).join();
        break;
      case "stopKeywordsUpdate":
        StopKeywordUpdate.encode(message.payload.value, writer.uint32(162).fork()).join();
        break;
      case "stopKeywordsDelete":
        StopKeywordDelete.encode(message.payload.value, writer.uint32(170).fork()).join();
        break;
      case "updateLlmSettings":
        LLMSettingsUpdateLLMSettings.encode(message.payload.value, writer.uint32(178).fork()).join();
        break;
      case "updateContentFilterSettings":
        ContentFilterSettingsUpdateContentFilterSettings.encode(message.payload.value, writer.uint32(186).fork())
          .join();
        break;
      case "updateAsrSettings":
        ASRSettingsUpdateASRSettings.encode(message.payload.value, writer.uint32(194).fork()).join();
        break;
      case "updateTtsSettings":
        LanguagesUpdateDefaultLanguage.encode(message.payload.value, writer.uint32(202).fork()).join();
        break;
      case "languagesUpdateDefaultLanguage":
        LanguagesUpdateDefaultLanguage.encode(message.payload.value, writer.uint32(1850).fork()).join();
        break;
      case "languagesAddLanguage":
        LanguagesAddLanguage.encode(message.payload.value, writer.uint32(1858).fork()).join();
        break;
      case "languagesDeleteLanguage":
        LanguagesDeleteLanguage.encode(message.payload.value, writer.uint32(1866).fork()).join();
        break;
      case "experimentalConfigUpdateConfig":
        ExperimentalConfigUpdateConfig.encode(message.payload.value, writer.uint32(314).fork()).join();
        break;
      case "pronunciationsCreatePronunciation":
        PronunciationsCreatePronunciation.encode(message.payload.value, writer.uint32(218).fork()).join();
        break;
      case "pronunciationsUpdatePronunciation":
        PronunciationsUpdatePronunciation.encode(message.payload.value, writer.uint32(226).fork()).join();
        break;
      case "pronunciationsDeletePronunciation":
        PronunciationsDeletePronunciation.encode(message.payload.value, writer.uint32(234).fork()).join();
        break;
      case "pronunciationsReorderPronunciations":
        PronunciationsReorderPronunciations.encode(message.payload.value, writer.uint32(482).fork()).join();
        break;
      case "createTranscriptCorrections":
        TranscriptCorrectionsCreateTranscriptCorrections.encode(message.payload.value, writer.uint32(242).fork())
          .join();
        break;
      case "updateTranscriptCorrections":
        TranscriptCorrectionsUpdateTranscriptCorrections.encode(message.payload.value, writer.uint32(250).fork())
          .join();
        break;
      case "deleteTranscriptCorrections":
        TranscriptCorrectionsDeleteTranscriptCorrections.encode(message.payload.value, writer.uint32(258).fork())
          .join();
        break;
      case "updateGreeting":
        GreetingUpdateGreeting.encode(message.payload.value, writer.uint32(266).fork()).join();
        break;
      case "updatePersonality":
        PersonalityUpdatePersonality.encode(message.payload.value, writer.uint32(274).fork()).join();
        break;
      case "updateRole":
        RoleUpdateRole.encode(message.payload.value, writer.uint32(282).fork()).join();
        break;
      case "updateDisclaimerMessage":
        DisclaimerMessageUpdateDisclaimerMessage.encode(message.payload.value, writer.uint32(290).fork()).join();
        break;
      case "updateRules":
        RulesUpdateRules.encode(message.payload.value, writer.uint32(298).fork()).join();
        break;
      case "updateLanguageBehavior":
        LanguageBehaviorUpdateLanguageBehavior.encode(message.payload.value, writer.uint32(474).fork()).join();
        break;
      case "createFunction":
        FunctionCreateFunction.encode(message.payload.value, writer.uint32(306).fork()).join();
        break;
      case "updateFunction":
        FunctionUpdateFunction.encode(message.payload.value, writer.uint32(322).fork()).join();
        break;
      case "deleteFunction":
        FunctionDeleteFunction.encode(message.payload.value, writer.uint32(330).fork()).join();
        break;
      case "updateLatencyControl":
        FunctionUpdateLatencyControl.encode(message.payload.value, writer.uint32(338).fork()).join();
        break;
      case "createStartFunction":
        StartFunctionCreate.encode(message.payload.value, writer.uint32(346).fork()).join();
        break;
      case "updateStartFunction":
        StartFunctionUpdate.encode(message.payload.value, writer.uint32(354).fork()).join();
        break;
      case "deleteStartFunction":
        StartFunctionDelete.encode(message.payload.value, writer.uint32(386).fork()).join();
        break;
      case "createEndFunction":
        EndFunctionCreate.encode(message.payload.value, writer.uint32(362).fork()).join();
        break;
      case "updateEndFunction":
        EndFunctionUpdate.encode(message.payload.value, writer.uint32(370).fork()).join();
        break;
      case "deleteEndFunction":
        EndFunctionDelete.encode(message.payload.value, writer.uint32(394).fork()).join();
        break;
      case "voiceAddAgentVoice":
        VoiceAddAgentVoice.encode(message.payload.value, writer.uint32(410).fork()).join();
        break;
      case "voiceDeleteAgentVoice":
        VoiceDeleteAgentVoice.encode(message.payload.value, writer.uint32(418).fork()).join();
        break;
      case "voiceUpdateAgentVoice":
        VoiceUpdateAgentVoice.encode(message.payload.value, writer.uint32(426).fork()).join();
        break;
      case "voiceCreateAgentVoiceSettings":
        VoiceCreateAgentVoiceSettings.encode(message.payload.value, writer.uint32(434).fork()).join();
        break;
      case "voiceUpdateAgentVoiceSettings":
        VoiceUpdateAgentVoiceSettings.encode(message.payload.value, writer.uint32(442).fork()).join();
        break;
      case "voiceUpdateDisclaimerVoice":
        VoiceUpdateDisclaimerVoice.encode(message.payload.value, writer.uint32(450).fork()).join();
        break;
      case "voiceCreateDisclaimerVoiceSettings":
        VoiceCreateDisclaimerVoiceSettings.encode(message.payload.value, writer.uint32(458).fork()).join();
        break;
      case "voiceUpdateDisclaimerVoiceSettings":
        VoiceUpdateDisclaimerVoiceSettings.encode(message.payload.value, writer.uint32(466).fork()).join();
        break;
      case "voiceAddFavoriteVoice":
        VoiceAddFavoriteVoice.encode(message.payload.value, writer.uint32(962).fork()).join();
        break;
      case "voiceRemoveFavoriteVoice":
        VoiceRemoveFavoriteVoice.encode(message.payload.value, writer.uint32(970).fork()).join();
        break;
      case "entityCreate":
        EntityCreate.encode(message.payload.value, writer.uint32(1322).fork()).join();
        break;
      case "entityUpdate":
        EntityUpdate.encode(message.payload.value, writer.uint32(1330).fork()).join();
        break;
      case "entityDelete":
        EntityDelete.encode(message.payload.value, writer.uint32(1338).fork()).join();
        break;
      case "variableCreate":
        VariableCreate.encode(message.payload.value, writer.uint32(1346).fork()).join();
        break;
      case "variableUpdate":
        VariableUpdate.encode(message.payload.value, writer.uint32(1354).fork()).join();
        break;
      case "variableDelete":
        VariableDelete.encode(message.payload.value, writer.uint32(1362).fork()).join();
        break;
      case "createFlowStep":
        FlowCreateStep.encode(message.payload.value, writer.uint32(802).fork()).join();
        break;
      case "updateFlowStep":
        FlowUpdateStep.encode(message.payload.value, writer.uint32(810).fork()).join();
        break;
      case "deleteFlowStep":
        FlowDeleteStep.encode(message.payload.value, writer.uint32(818).fork()).join();
        break;
      case "updateFlowStepPosition":
        FlowUpdateStepPosition.encode(message.payload.value, writer.uint32(826).fork()).join();
        break;
      case "updateFlowStepPositions":
        FlowUpdateStepPositions.encode(message.payload.value, writer.uint32(834).fork()).join();
        break;
      case "updateFlowStepDtmfConfig":
        FlowUpdateStepDtmfConfig.encode(message.payload.value, writer.uint32(842).fork()).join();
        break;
      case "updateFlowStepAsrConfig":
        FlowUpdateStepAsrConfig.encode(message.payload.value, writer.uint32(850).fork()).join();
        break;
      case "createFlowTransitionFunction":
        FlowCreateTransitionFunction.encode(message.payload.value, writer.uint32(858).fork()).join();
        break;
      case "updateFlowTransitionFunction":
        FlowUpdateTransitionFunction.encode(message.payload.value, writer.uint32(866).fork()).join();
        break;
      case "deleteFlowTransitionFunction":
        FlowDeleteTransitionFunction.encode(message.payload.value, writer.uint32(874).fork()).join();
        break;
      case "deleteFlow":
        FlowDeleteFlow.encode(message.payload.value, writer.uint32(882).fork()).join();
        break;
      case "createFlow":
        FlowCreateFlow.encode(message.payload.value, writer.uint32(890).fork()).join();
        break;
      case "importFlow":
        FlowImportFlow.encode(message.payload.value, writer.uint32(898).fork()).join();
        break;
      case "updateFlow":
        FlowUpdateFlow.encode(message.payload.value, writer.uint32(906).fork()).join();
        break;
      case "updateFlowTransitionFunctionLatencyControl":
        FlowUpdateTransitionFunctionLatencyControl.encode(message.payload.value, writer.uint32(914).fork()).join();
        break;
      case "createNoCodeStep":
        CreateNoCodeStep.encode(message.payload.value, writer.uint32(1714).fork()).join();
        break;
      case "updateNoCodeStep":
        UpdateNoCodeStep.encode(message.payload.value, writer.uint32(1722).fork()).join();
        break;
      case "deleteNoCodeStep":
        DeleteNoCodeStep.encode(message.payload.value, writer.uint32(1730).fork()).join();
        break;
      case "updateNoCodeStepPosition":
        UpdateNoCodeStepPosition.encode(message.payload.value, writer.uint32(1738).fork()).join();
        break;
      case "createNoCodeCondition":
        CreateNoCodeCondition.encode(message.payload.value, writer.uint32(1746).fork()).join();
        break;
      case "deleteNoCodeCondition":
        DeleteNoCodeCondition.encode(message.payload.value, writer.uint32(1754).fork()).join();
        break;
      case "updateNoCodeCondition":
        UpdateNoCodeCondition.encode(message.payload.value, writer.uint32(1762).fork()).join();
        break;
      case "updateNoCodeConditionPosition":
        UpdateNoCodeConditionPosition.encode(message.payload.value, writer.uint32(1770).fork()).join();
        break;
      case "updateNoCodeConditionExitFlowPosition":
        UpdateNoCodeConditionExitFlowPosition.encode(message.payload.value, writer.uint32(1778).fork()).join();
        break;
      case "moveFlowComponent":
        MoveFlowComponent.encode(message.payload.value, writer.uint32(1786).fork()).join();
        break;
      case "moveFlowComponents":
        MoveFlowComponents.encode(message.payload.value, writer.uint32(1794).fork()).join();
        break;
      case "createStep":
        CreateStep.encode(message.payload.value, writer.uint32(2458).fork()).join();
        break;
      case "updateStep":
        UpdateStep.encode(message.payload.value, writer.uint32(2466).fork()).join();
        break;
      case "deleteStep":
        DeleteStep.encode(message.payload.value, writer.uint32(2474).fork()).join();
        break;
      case "createStepCondition":
        CreateStepCondition.encode(message.payload.value, writer.uint32(2482).fork()).join();
        break;
      case "updateStepCondition":
        UpdateStepCondition.encode(message.payload.value, writer.uint32(2490).fork()).join();
        break;
      case "deleteStepCondition":
        DeleteStepCondition.encode(message.payload.value, writer.uint32(2498).fork()).join();
        break;
      case "updateStepConditionPosition":
        UpdateStepConditionPosition.encode(message.payload.value, writer.uint32(2506).fork()).join();
        break;
      case "createKeyphraseBoosting":
        KeyphraseBoostingCreateKeyphrase.encode(message.payload.value, writer.uint32(922).fork()).join();
        break;
      case "updateKeyphraseBoosting":
        KeyphraseBoostingUpdateKeyphrase.encode(message.payload.value, writer.uint32(930).fork()).join();
        break;
      case "deleteKeyphraseBoosting":
        KeyphraseBoostingDeleteKeyphrase.encode(message.payload.value, writer.uint32(938).fork()).join();
        break;
      case "createApiIntegration":
        ApiIntegrationCreate.encode(message.payload.value, writer.uint32(2402).fork()).join();
        break;
      case "updateApiIntegration":
        ApiIntegrationUpdate.encode(message.payload.value, writer.uint32(2410).fork()).join();
        break;
      case "deleteApiIntegration":
        ApiIntegrationDelete.encode(message.payload.value, writer.uint32(2418).fork()).join();
        break;
      case "updateApiIntegrationConfig":
        ApiIntegrationConfigUpdate.encode(message.payload.value, writer.uint32(2426).fork()).join();
        break;
      case "createApiIntegrationOperation":
        ApiIntegrationOperationCreate.encode(message.payload.value, writer.uint32(2434).fork()).join();
        break;
      case "updateApiIntegrationOperation":
        ApiIntegrationOperationUpdate.encode(message.payload.value, writer.uint32(2442).fork()).join();
        break;
      case "deleteApiIntegrationOperation":
        ApiIntegrationOperationDelete.encode(message.payload.value, writer.uint32(2450).fork()).join();
        break;
      case "createTranslation":
        LanguageHubTranslationsCreate.encode(message.payload.value, writer.uint32(2810).fork()).join();
        break;
      case "updateTranslation":
        LanguageHubTranslationsUpdate.encode(message.payload.value, writer.uint32(2818).fork()).join();
        break;
      case "deleteTranslation":
        LanguageHubTranslationsDelete.encode(message.payload.value, writer.uint32(2826).fork()).join();
        break;
      case "voiceChannelUpdateAsrSettings":
        VoiceChannelUpdateASRSettings.encode(message.payload.value, writer.uint32(2866).fork()).join();
        break;
      case "voiceChannelUpdateDisclaimer":
        VoiceChannelUpdateDisclaimer.encode(message.payload.value, writer.uint32(2874).fork()).join();
        break;
      case "voiceChannelUpdateBargeInConfig":
        VoiceChannelUpdateBargeInConfig.encode(message.payload.value, writer.uint32(3082).fork()).join();
        break;
      case "voiceChannelUpdateTemperature":
        VoiceChannelUpdateTemperature.encode(message.payload.value, writer.uint32(3090).fork()).join();
        break;
      case "voiceChannelResetBargeInConfig":
        VoiceChannelResetBargeInConfig.encode(message.payload.value, writer.uint32(3098).fork()).join();
        break;
      case "voiceChannelResetTemperature":
        VoiceChannelResetTemperature.encode(message.payload.value, writer.uint32(3106).fork()).join();
        break;
      case "voiceChannelResetVadConfig":
        VoiceChannelResetVadConfig.encode(message.payload.value, writer.uint32(3114).fork()).join();
        break;
      case "voiceChannelResetAudioEnhancement":
        VoiceChannelResetAudioEnhancement.encode(message.payload.value, writer.uint32(3122).fork()).join();
        break;
      case "voiceChannelResetSilenceFillerUtterances":
        VoiceChannelResetSilenceFillerUtterances.encode(message.payload.value, writer.uint32(3130).fork()).join();
        break;
      case "voiceChannelResetAsrConfig":
        VoiceChannelResetAsrConfig.encode(message.payload.value, writer.uint32(3138).fork()).join();
        break;
      case "channelUpdateGreeting":
        ChannelUpdateGreeting.encode(message.payload.value, writer.uint32(3010).fork()).join();
        break;
      case "channelUpdateStylePrompt":
        ChannelUpdateStylePrompt.encode(message.payload.value, writer.uint32(3018).fork()).join();
        break;
      case "channelUpdateSafetyFilters":
        ChannelUpdateSafetyFilters.encode(message.payload.value, writer.uint32(3026).fork()).join();
        break;
      case "channelUpdateLlmSettings":
        ChannelUpdateLLMSettings.encode(message.payload.value, writer.uint32(3034).fork()).join();
        break;
      case "channelUpdateStatus":
        ChannelUpdateStatus.encode(message.payload.value, writer.uint32(3042).fork()).join();
        break;
      case "voiceChannelUpdateVadConfig":
        VoiceChannelUpdateVadConfig.encode(message.payload.value, writer.uint32(3050).fork()).join();
        break;
      case "voiceChannelUpdateAudioEnhancement":
        VoiceChannelUpdateAudioEnhancement.encode(message.payload.value, writer.uint32(3058).fork()).join();
        break;
      case "voiceChannelUpdateSilenceFillerUtterances":
        VoiceChannelUpdateSilenceFillerUtterances.encode(message.payload.value, writer.uint32(3066).fork()).join();
        break;
      case "voiceChannelUpdateAsrConfig":
        VoiceChannelUpdateAsrConfig.encode(message.payload.value, writer.uint32(3074).fork()).join();
        break;
      case "csatUpdateConfig":
        CSATUpdateConfig.encode(message.payload.value, writer.uint32(2962).fork()).join();
        break;
      case "connectIntegration":
        IntegrationConnect.encode(message.payload.value, writer.uint32(2970).fork()).join();
        break;
      case "enableIntegration":
        IntegrationEnable.encode(message.payload.value, writer.uint32(2978).fork()).join();
        break;
      case "disableIntegration":
        IntegrationDisable.encode(message.payload.value, writer.uint32(3002).fork()).join();
        break;
      case "updateIntegrationFunctions":
        IntegrationUpdateFunctions.encode(message.payload.value, writer.uint32(2986).fork()).join();
        break;
      case "disconnectIntegration":
        IntegrationDisconnect.encode(message.payload.value, writer.uint32(2994).fork()).join();
        break;
      case "updateMcpConfig":
        MCPConfigUpdate.encode(message.payload.value, writer.uint32(3082).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Command {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 200: {
          if (tag !== 1602) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commandId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payload = { $case: "createTopic", value: KnowledgeBaseCreateTopic.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.payload = { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.payload = { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.decode(reader, reader.uint32()) };
          continue;
        }
        case 118: {
          if (tag !== 946) {
            break;
          }

          message.payload = { $case: "importTopics", value: KnowledgeBaseImportTopics.decode(reader, reader.uint32()) };
          continue;
        }
        case 119: {
          if (tag !== 954) {
            break;
          }

          message.payload = {
            $case: "toggleTopicStatus",
            value: KnowledgeBaseToggleTopicStatus.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.payload = { $case: "smsCreateTemplate", value: SMSCreateTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.payload = { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.payload = { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.payload = { $case: "handoffCreate", value: HandoffCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.payload = { $case: "handoffUpdate", value: HandoffUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.payload = { $case: "handoffDelete", value: HandoffDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.payload = { $case: "handoffSetDefault", value: HandoffSetDefault.decode(reader, reader.uint32()) };
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.payload = {
            $case: "handoffResetHandoffConfigs",
            value: HandoffResetHandoffConfigs.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.payload = {
            $case: "variantCreateAttribute",
            value: VariantCreateAttribute.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.payload = {
            $case: "variantUpdateAttribute",
            value: VariantUpdateAttribute.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.payload = {
            $case: "variantDeleteAttribute",
            value: VariantDeleteAttribute.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.payload = {
            $case: "variantCreateVariant",
            value: VariantCreateVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.payload = {
            $case: "variantUpdateVariant",
            value: VariantUpdateVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.payload = {
            $case: "variantDeleteVariant",
            value: VariantDeleteVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.payload = {
            $case: "variantSetDefaultVariant",
            value: VariantSetDefaultVariant.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.payload = {
            $case: "variantImportVariants",
            value: VariantImportVariants.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.payload = { $case: "stopKeywordsCreate", value: StopKeywordCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.payload = { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.payload = { $case: "stopKeywordsDelete", value: StopKeywordDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.payload = {
            $case: "updateLlmSettings",
            value: LLMSettingsUpdateLLMSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.payload = {
            $case: "updateContentFilterSettings",
            value: ContentFilterSettingsUpdateContentFilterSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.payload = {
            $case: "updateAsrSettings",
            value: ASRSettingsUpdateASRSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.payload = {
            $case: "updateTtsSettings",
            value: LanguagesUpdateDefaultLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 231: {
          if (tag !== 1850) {
            break;
          }

          message.payload = {
            $case: "languagesUpdateDefaultLanguage",
            value: LanguagesUpdateDefaultLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 232: {
          if (tag !== 1858) {
            break;
          }

          message.payload = {
            $case: "languagesAddLanguage",
            value: LanguagesAddLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 233: {
          if (tag !== 1866) {
            break;
          }

          message.payload = {
            $case: "languagesDeleteLanguage",
            value: LanguagesDeleteLanguage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.payload = {
            $case: "experimentalConfigUpdateConfig",
            value: ExperimentalConfigUpdateConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.payload = {
            $case: "pronunciationsCreatePronunciation",
            value: PronunciationsCreatePronunciation.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.payload = {
            $case: "pronunciationsUpdatePronunciation",
            value: PronunciationsUpdatePronunciation.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.payload = {
            $case: "pronunciationsDeletePronunciation",
            value: PronunciationsDeletePronunciation.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 60: {
          if (tag !== 482) {
            break;
          }

          message.payload = {
            $case: "pronunciationsReorderPronunciations",
            value: PronunciationsReorderPronunciations.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.payload = {
            $case: "createTranscriptCorrections",
            value: TranscriptCorrectionsCreateTranscriptCorrections.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.payload = {
            $case: "updateTranscriptCorrections",
            value: TranscriptCorrectionsUpdateTranscriptCorrections.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.payload = {
            $case: "deleteTranscriptCorrections",
            value: TranscriptCorrectionsDeleteTranscriptCorrections.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.payload = { $case: "updateGreeting", value: GreetingUpdateGreeting.decode(reader, reader.uint32()) };
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.payload = {
            $case: "updatePersonality",
            value: PersonalityUpdatePersonality.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.payload = { $case: "updateRole", value: RoleUpdateRole.decode(reader, reader.uint32()) };
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.payload = {
            $case: "updateDisclaimerMessage",
            value: DisclaimerMessageUpdateDisclaimerMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.payload = { $case: "updateRules", value: RulesUpdateRules.decode(reader, reader.uint32()) };
          continue;
        }
        case 59: {
          if (tag !== 474) {
            break;
          }

          message.payload = {
            $case: "updateLanguageBehavior",
            value: LanguageBehaviorUpdateLanguageBehavior.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.payload = { $case: "createFunction", value: FunctionCreateFunction.decode(reader, reader.uint32()) };
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.payload = { $case: "updateFunction", value: FunctionUpdateFunction.decode(reader, reader.uint32()) };
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.payload = { $case: "deleteFunction", value: FunctionDeleteFunction.decode(reader, reader.uint32()) };
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.payload = {
            $case: "updateLatencyControl",
            value: FunctionUpdateLatencyControl.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.payload = {
            $case: "createStartFunction",
            value: StartFunctionCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.payload = {
            $case: "updateStartFunction",
            value: StartFunctionUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 48: {
          if (tag !== 386) {
            break;
          }

          message.payload = {
            $case: "deleteStartFunction",
            value: StartFunctionDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.payload = { $case: "createEndFunction", value: EndFunctionCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.payload = { $case: "updateEndFunction", value: EndFunctionUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.payload = { $case: "deleteEndFunction", value: EndFunctionDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.payload = { $case: "voiceAddAgentVoice", value: VoiceAddAgentVoice.decode(reader, reader.uint32()) };
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.payload = {
            $case: "voiceDeleteAgentVoice",
            value: VoiceDeleteAgentVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateAgentVoice",
            value: VoiceUpdateAgentVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 54: {
          if (tag !== 434) {
            break;
          }

          message.payload = {
            $case: "voiceCreateAgentVoiceSettings",
            value: VoiceCreateAgentVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateAgentVoiceSettings",
            value: VoiceUpdateAgentVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 56: {
          if (tag !== 450) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateDisclaimerVoice",
            value: VoiceUpdateDisclaimerVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 57: {
          if (tag !== 458) {
            break;
          }

          message.payload = {
            $case: "voiceCreateDisclaimerVoiceSettings",
            value: VoiceCreateDisclaimerVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 58: {
          if (tag !== 466) {
            break;
          }

          message.payload = {
            $case: "voiceUpdateDisclaimerVoiceSettings",
            value: VoiceUpdateDisclaimerVoiceSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 120: {
          if (tag !== 962) {
            break;
          }

          message.payload = {
            $case: "voiceAddFavoriteVoice",
            value: VoiceAddFavoriteVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 121: {
          if (tag !== 970) {
            break;
          }

          message.payload = {
            $case: "voiceRemoveFavoriteVoice",
            value: VoiceRemoveFavoriteVoice.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 165: {
          if (tag !== 1322) {
            break;
          }

          message.payload = { $case: "entityCreate", value: EntityCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 166: {
          if (tag !== 1330) {
            break;
          }

          message.payload = { $case: "entityUpdate", value: EntityUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 167: {
          if (tag !== 1338) {
            break;
          }

          message.payload = { $case: "entityDelete", value: EntityDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 168: {
          if (tag !== 1346) {
            break;
          }

          message.payload = { $case: "variableCreate", value: VariableCreate.decode(reader, reader.uint32()) };
          continue;
        }
        case 169: {
          if (tag !== 1354) {
            break;
          }

          message.payload = { $case: "variableUpdate", value: VariableUpdate.decode(reader, reader.uint32()) };
          continue;
        }
        case 170: {
          if (tag !== 1362) {
            break;
          }

          message.payload = { $case: "variableDelete", value: VariableDelete.decode(reader, reader.uint32()) };
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.payload = { $case: "createFlowStep", value: FlowCreateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.payload = { $case: "updateFlowStep", value: FlowUpdateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.payload = { $case: "deleteFlowStep", value: FlowDeleteStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepPosition",
            value: FlowUpdateStepPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepPositions",
            value: FlowUpdateStepPositions.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepDtmfConfig",
            value: FlowUpdateStepDtmfConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 106: {
          if (tag !== 850) {
            break;
          }

          message.payload = {
            $case: "updateFlowStepAsrConfig",
            value: FlowUpdateStepAsrConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 107: {
          if (tag !== 858) {
            break;
          }

          message.payload = {
            $case: "createFlowTransitionFunction",
            value: FlowCreateTransitionFunction.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.payload = {
            $case: "updateFlowTransitionFunction",
            value: FlowUpdateTransitionFunction.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 109: {
          if (tag !== 874) {
            break;
          }

          message.payload = {
            $case: "deleteFlowTransitionFunction",
            value: FlowDeleteTransitionFunction.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 110: {
          if (tag !== 882) {
            break;
          }

          message.payload = { $case: "deleteFlow", value: FlowDeleteFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 111: {
          if (tag !== 890) {
            break;
          }

          message.payload = { $case: "createFlow", value: FlowCreateFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 112: {
          if (tag !== 898) {
            break;
          }

          message.payload = { $case: "importFlow", value: FlowImportFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 113: {
          if (tag !== 906) {
            break;
          }

          message.payload = { $case: "updateFlow", value: FlowUpdateFlow.decode(reader, reader.uint32()) };
          continue;
        }
        case 114: {
          if (tag !== 914) {
            break;
          }

          message.payload = {
            $case: "updateFlowTransitionFunctionLatencyControl",
            value: FlowUpdateTransitionFunctionLatencyControl.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 214: {
          if (tag !== 1714) {
            break;
          }

          message.payload = { $case: "createNoCodeStep", value: CreateNoCodeStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 215: {
          if (tag !== 1722) {
            break;
          }

          message.payload = { $case: "updateNoCodeStep", value: UpdateNoCodeStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 216: {
          if (tag !== 1730) {
            break;
          }

          message.payload = { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 217: {
          if (tag !== 1738) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeStepPosition",
            value: UpdateNoCodeStepPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 218: {
          if (tag !== 1746) {
            break;
          }

          message.payload = {
            $case: "createNoCodeCondition",
            value: CreateNoCodeCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 219: {
          if (tag !== 1754) {
            break;
          }

          message.payload = {
            $case: "deleteNoCodeCondition",
            value: DeleteNoCodeCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 220: {
          if (tag !== 1762) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeCondition",
            value: UpdateNoCodeCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 221: {
          if (tag !== 1770) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeConditionPosition",
            value: UpdateNoCodeConditionPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 222: {
          if (tag !== 1778) {
            break;
          }

          message.payload = {
            $case: "updateNoCodeConditionExitFlowPosition",
            value: UpdateNoCodeConditionExitFlowPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 223: {
          if (tag !== 1786) {
            break;
          }

          message.payload = { $case: "moveFlowComponent", value: MoveFlowComponent.decode(reader, reader.uint32()) };
          continue;
        }
        case 224: {
          if (tag !== 1794) {
            break;
          }

          message.payload = { $case: "moveFlowComponents", value: MoveFlowComponents.decode(reader, reader.uint32()) };
          continue;
        }
        case 307: {
          if (tag !== 2458) {
            break;
          }

          message.payload = { $case: "createStep", value: CreateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 308: {
          if (tag !== 2466) {
            break;
          }

          message.payload = { $case: "updateStep", value: UpdateStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 309: {
          if (tag !== 2474) {
            break;
          }

          message.payload = { $case: "deleteStep", value: DeleteStep.decode(reader, reader.uint32()) };
          continue;
        }
        case 310: {
          if (tag !== 2482) {
            break;
          }

          message.payload = {
            $case: "createStepCondition",
            value: CreateStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 311: {
          if (tag !== 2490) {
            break;
          }

          message.payload = {
            $case: "updateStepCondition",
            value: UpdateStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 312: {
          if (tag !== 2498) {
            break;
          }

          message.payload = {
            $case: "deleteStepCondition",
            value: DeleteStepCondition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 313: {
          if (tag !== 2506) {
            break;
          }

          message.payload = {
            $case: "updateStepConditionPosition",
            value: UpdateStepConditionPosition.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 115: {
          if (tag !== 922) {
            break;
          }

          message.payload = {
            $case: "createKeyphraseBoosting",
            value: KeyphraseBoostingCreateKeyphrase.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 116: {
          if (tag !== 930) {
            break;
          }

          message.payload = {
            $case: "updateKeyphraseBoosting",
            value: KeyphraseBoostingUpdateKeyphrase.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 117: {
          if (tag !== 938) {
            break;
          }

          message.payload = {
            $case: "deleteKeyphraseBoosting",
            value: KeyphraseBoostingDeleteKeyphrase.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 300: {
          if (tag !== 2402) {
            break;
          }

          message.payload = {
            $case: "createApiIntegration",
            value: ApiIntegrationCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 301: {
          if (tag !== 2410) {
            break;
          }

          message.payload = {
            $case: "updateApiIntegration",
            value: ApiIntegrationUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 302: {
          if (tag !== 2418) {
            break;
          }

          message.payload = {
            $case: "deleteApiIntegration",
            value: ApiIntegrationDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 303: {
          if (tag !== 2426) {
            break;
          }

          message.payload = {
            $case: "updateApiIntegrationConfig",
            value: ApiIntegrationConfigUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 304: {
          if (tag !== 2434) {
            break;
          }

          message.payload = {
            $case: "createApiIntegrationOperation",
            value: ApiIntegrationOperationCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 305: {
          if (tag !== 2442) {
            break;
          }

          message.payload = {
            $case: "updateApiIntegrationOperation",
            value: ApiIntegrationOperationUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 306: {
          if (tag !== 2450) {
            break;
          }

          message.payload = {
            $case: "deleteApiIntegrationOperation",
            value: ApiIntegrationOperationDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 351: {
          if (tag !== 2810) {
            break;
          }

          message.payload = {
            $case: "createTranslation",
            value: LanguageHubTranslationsCreate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 352: {
          if (tag !== 2818) {
            break;
          }

          message.payload = {
            $case: "updateTranslation",
            value: LanguageHubTranslationsUpdate.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 353: {
          if (tag !== 2826) {
            break;
          }

          message.payload = {
            $case: "deleteTranslation",
            value: LanguageHubTranslationsDelete.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 358: {
          if (tag !== 2866) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateAsrSettings",
            value: VoiceChannelUpdateASRSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 359: {
          if (tag !== 2874) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateDisclaimer",
            value: VoiceChannelUpdateDisclaimer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 385: {
          if (tag !== 3082) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateBargeInConfig",
            value: VoiceChannelUpdateBargeInConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 386: {
          if (tag !== 3090) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateTemperature",
            value: VoiceChannelUpdateTemperature.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 387: {
          if (tag !== 3098) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetBargeInConfig",
            value: VoiceChannelResetBargeInConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 388: {
          if (tag !== 3106) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetTemperature",
            value: VoiceChannelResetTemperature.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 389: {
          if (tag !== 3114) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetVadConfig",
            value: VoiceChannelResetVadConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 390: {
          if (tag !== 3122) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetAudioEnhancement",
            value: VoiceChannelResetAudioEnhancement.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 391: {
          if (tag !== 3130) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetSilenceFillerUtterances",
            value: VoiceChannelResetSilenceFillerUtterances.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 392: {
          if (tag !== 3138) {
            break;
          }

          message.payload = {
            $case: "voiceChannelResetAsrConfig",
            value: VoiceChannelResetAsrConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 376: {
          if (tag !== 3010) {
            break;
          }

          message.payload = {
            $case: "channelUpdateGreeting",
            value: ChannelUpdateGreeting.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 377: {
          if (tag !== 3018) {
            break;
          }

          message.payload = {
            $case: "channelUpdateStylePrompt",
            value: ChannelUpdateStylePrompt.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 378: {
          if (tag !== 3026) {
            break;
          }

          message.payload = {
            $case: "channelUpdateSafetyFilters",
            value: ChannelUpdateSafetyFilters.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 379: {
          if (tag !== 3034) {
            break;
          }

          message.payload = {
            $case: "channelUpdateLlmSettings",
            value: ChannelUpdateLLMSettings.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 380: {
          if (tag !== 3042) {
            break;
          }

          message.payload = {
            $case: "channelUpdateStatus",
            value: ChannelUpdateStatus.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 381: {
          if (tag !== 3050) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateVadConfig",
            value: VoiceChannelUpdateVadConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 382: {
          if (tag !== 3058) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateAudioEnhancement",
            value: VoiceChannelUpdateAudioEnhancement.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 383: {
          if (tag !== 3066) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateSilenceFillerUtterances",
            value: VoiceChannelUpdateSilenceFillerUtterances.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 384: {
          if (tag !== 3074) {
            break;
          }

          message.payload = {
            $case: "voiceChannelUpdateAsrConfig",
            value: VoiceChannelUpdateAsrConfig.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 370: {
          if (tag !== 2962) {
            break;
          }

          message.payload = { $case: "csatUpdateConfig", value: CSATUpdateConfig.decode(reader, reader.uint32()) };
          continue;
        }
        case 371: {
          if (tag !== 2970) {
            break;
          }

          message.payload = { $case: "connectIntegration", value: IntegrationConnect.decode(reader, reader.uint32()) };
          continue;
        }
        case 372: {
          if (tag !== 2978) {
            break;
          }

          message.payload = { $case: "enableIntegration", value: IntegrationEnable.decode(reader, reader.uint32()) };
          continue;
        }
        case 375: {
          if (tag !== 3002) {
            break;
          }

          message.payload = { $case: "disableIntegration", value: IntegrationDisable.decode(reader, reader.uint32()) };
          continue;
        }
        case 373: {
          if (tag !== 2986) {
            break;
          }

          message.payload = {
            $case: "updateIntegrationFunctions",
            value: IntegrationUpdateFunctions.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 374: {
          if (tag !== 2994) {
            break;
          }

          message.payload = {
            $case: "disconnectIntegration",
            value: IntegrationDisconnect.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 385: {
          if (tag !== 3082) {
            break;
          }

          message.payload = { $case: "updateMcpConfig", value: MCPConfigUpdate.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Command {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      commandId: isSet(object.commandId)
        ? globalThis.String(object.commandId)
        : isSet(object.command_id)
        ? globalThis.String(object.command_id)
        : "",
      payload: isSet(object.createTopic)
        ? { $case: "createTopic", value: KnowledgeBaseCreateTopic.fromJSON(object.createTopic) }
        : isSet(object.create_topic)
        ? { $case: "createTopic", value: KnowledgeBaseCreateTopic.fromJSON(object.create_topic) }
        : isSet(object.updateTopic)
        ? { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.fromJSON(object.updateTopic) }
        : isSet(object.update_topic)
        ? { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.fromJSON(object.update_topic) }
        : isSet(object.deleteTopic)
        ? { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.fromJSON(object.deleteTopic) }
        : isSet(object.delete_topic)
        ? { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.fromJSON(object.delete_topic) }
        : isSet(object.importTopics)
        ? { $case: "importTopics", value: KnowledgeBaseImportTopics.fromJSON(object.importTopics) }
        : isSet(object.import_topics)
        ? { $case: "importTopics", value: KnowledgeBaseImportTopics.fromJSON(object.import_topics) }
        : isSet(object.toggleTopicStatus)
        ? { $case: "toggleTopicStatus", value: KnowledgeBaseToggleTopicStatus.fromJSON(object.toggleTopicStatus) }
        : isSet(object.toggle_topic_status)
        ? { $case: "toggleTopicStatus", value: KnowledgeBaseToggleTopicStatus.fromJSON(object.toggle_topic_status) }
        : isSet(object.smsCreateTemplate)
        ? { $case: "smsCreateTemplate", value: SMSCreateTemplate.fromJSON(object.smsCreateTemplate) }
        : isSet(object.sms_create_template)
        ? { $case: "smsCreateTemplate", value: SMSCreateTemplate.fromJSON(object.sms_create_template) }
        : isSet(object.smsUpdateTemplate)
        ? { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.fromJSON(object.smsUpdateTemplate) }
        : isSet(object.sms_update_template)
        ? { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.fromJSON(object.sms_update_template) }
        : isSet(object.smsDeleteTemplate)
        ? { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.fromJSON(object.smsDeleteTemplate) }
        : isSet(object.sms_delete_template)
        ? { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.fromJSON(object.sms_delete_template) }
        : isSet(object.handoffCreate)
        ? { $case: "handoffCreate", value: HandoffCreate.fromJSON(object.handoffCreate) }
        : isSet(object.handoff_create)
        ? { $case: "handoffCreate", value: HandoffCreate.fromJSON(object.handoff_create) }
        : isSet(object.handoffUpdate)
        ? { $case: "handoffUpdate", value: HandoffUpdate.fromJSON(object.handoffUpdate) }
        : isSet(object.handoff_update)
        ? { $case: "handoffUpdate", value: HandoffUpdate.fromJSON(object.handoff_update) }
        : isSet(object.handoffDelete)
        ? { $case: "handoffDelete", value: HandoffDelete.fromJSON(object.handoffDelete) }
        : isSet(object.handoff_delete)
        ? { $case: "handoffDelete", value: HandoffDelete.fromJSON(object.handoff_delete) }
        : isSet(object.handoffSetDefault)
        ? { $case: "handoffSetDefault", value: HandoffSetDefault.fromJSON(object.handoffSetDefault) }
        : isSet(object.handoff_set_default)
        ? { $case: "handoffSetDefault", value: HandoffSetDefault.fromJSON(object.handoff_set_default) }
        : isSet(object.handoffResetHandoffConfigs)
        ? {
          $case: "handoffResetHandoffConfigs",
          value: HandoffResetHandoffConfigs.fromJSON(object.handoffResetHandoffConfigs),
        }
        : isSet(object.handoff_reset_handoff_configs)
        ? {
          $case: "handoffResetHandoffConfigs",
          value: HandoffResetHandoffConfigs.fromJSON(object.handoff_reset_handoff_configs),
        }
        : isSet(object.variantCreateAttribute)
        ? { $case: "variantCreateAttribute", value: VariantCreateAttribute.fromJSON(object.variantCreateAttribute) }
        : isSet(object.variant_create_attribute)
        ? { $case: "variantCreateAttribute", value: VariantCreateAttribute.fromJSON(object.variant_create_attribute) }
        : isSet(object.variantUpdateAttribute)
        ? { $case: "variantUpdateAttribute", value: VariantUpdateAttribute.fromJSON(object.variantUpdateAttribute) }
        : isSet(object.variant_update_attribute)
        ? { $case: "variantUpdateAttribute", value: VariantUpdateAttribute.fromJSON(object.variant_update_attribute) }
        : isSet(object.variantDeleteAttribute)
        ? { $case: "variantDeleteAttribute", value: VariantDeleteAttribute.fromJSON(object.variantDeleteAttribute) }
        : isSet(object.variant_delete_attribute)
        ? { $case: "variantDeleteAttribute", value: VariantDeleteAttribute.fromJSON(object.variant_delete_attribute) }
        : isSet(object.variantCreateVariant)
        ? { $case: "variantCreateVariant", value: VariantCreateVariant.fromJSON(object.variantCreateVariant) }
        : isSet(object.variant_create_variant)
        ? { $case: "variantCreateVariant", value: VariantCreateVariant.fromJSON(object.variant_create_variant) }
        : isSet(object.variantUpdateVariant)
        ? { $case: "variantUpdateVariant", value: VariantUpdateVariant.fromJSON(object.variantUpdateVariant) }
        : isSet(object.variant_update_variant)
        ? { $case: "variantUpdateVariant", value: VariantUpdateVariant.fromJSON(object.variant_update_variant) }
        : isSet(object.variantDeleteVariant)
        ? { $case: "variantDeleteVariant", value: VariantDeleteVariant.fromJSON(object.variantDeleteVariant) }
        : isSet(object.variant_delete_variant)
        ? { $case: "variantDeleteVariant", value: VariantDeleteVariant.fromJSON(object.variant_delete_variant) }
        : isSet(object.variantSetDefaultVariant)
        ? {
          $case: "variantSetDefaultVariant",
          value: VariantSetDefaultVariant.fromJSON(object.variantSetDefaultVariant),
        }
        : isSet(object.variant_set_default_variant)
        ? {
          $case: "variantSetDefaultVariant",
          value: VariantSetDefaultVariant.fromJSON(object.variant_set_default_variant),
        }
        : isSet(object.variantImportVariants)
        ? { $case: "variantImportVariants", value: VariantImportVariants.fromJSON(object.variantImportVariants) }
        : isSet(object.variant_import_variants)
        ? { $case: "variantImportVariants", value: VariantImportVariants.fromJSON(object.variant_import_variants) }
        : isSet(object.stopKeywordsCreate)
        ? { $case: "stopKeywordsCreate", value: StopKeywordCreate.fromJSON(object.stopKeywordsCreate) }
        : isSet(object.stop_keywords_create)
        ? { $case: "stopKeywordsCreate", value: StopKeywordCreate.fromJSON(object.stop_keywords_create) }
        : isSet(object.stopKeywordsUpdate)
        ? { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.fromJSON(object.stopKeywordsUpdate) }
        : isSet(object.stop_keywords_update)
        ? { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.fromJSON(object.stop_keywords_update) }
        : isSet(object.stopKeywordsDelete)
        ? { $case: "stopKeywordsDelete", value: StopKeywordDelete.fromJSON(object.stopKeywordsDelete) }
        : isSet(object.stop_keywords_delete)
        ? { $case: "stopKeywordsDelete", value: StopKeywordDelete.fromJSON(object.stop_keywords_delete) }
        : isSet(object.updateLlmSettings)
        ? { $case: "updateLlmSettings", value: LLMSettingsUpdateLLMSettings.fromJSON(object.updateLlmSettings) }
        : isSet(object.update_llm_settings)
        ? { $case: "updateLlmSettings", value: LLMSettingsUpdateLLMSettings.fromJSON(object.update_llm_settings) }
        : isSet(object.updateContentFilterSettings)
        ? {
          $case: "updateContentFilterSettings",
          value: ContentFilterSettingsUpdateContentFilterSettings.fromJSON(object.updateContentFilterSettings),
        }
        : isSet(object.update_content_filter_settings)
        ? {
          $case: "updateContentFilterSettings",
          value: ContentFilterSettingsUpdateContentFilterSettings.fromJSON(object.update_content_filter_settings),
        }
        : isSet(object.updateAsrSettings)
        ? { $case: "updateAsrSettings", value: ASRSettingsUpdateASRSettings.fromJSON(object.updateAsrSettings) }
        : isSet(object.update_asr_settings)
        ? { $case: "updateAsrSettings", value: ASRSettingsUpdateASRSettings.fromJSON(object.update_asr_settings) }
        : isSet(object.updateTtsSettings)
        ? { $case: "updateTtsSettings", value: LanguagesUpdateDefaultLanguage.fromJSON(object.updateTtsSettings) }
        : isSet(object.update_tts_settings)
        ? { $case: "updateTtsSettings", value: LanguagesUpdateDefaultLanguage.fromJSON(object.update_tts_settings) }
        : isSet(object.languagesUpdateDefaultLanguage)
        ? {
          $case: "languagesUpdateDefaultLanguage",
          value: LanguagesUpdateDefaultLanguage.fromJSON(object.languagesUpdateDefaultLanguage),
        }
        : isSet(object.languages_update_default_language)
        ? {
          $case: "languagesUpdateDefaultLanguage",
          value: LanguagesUpdateDefaultLanguage.fromJSON(object.languages_update_default_language),
        }
        : isSet(object.languagesAddLanguage)
        ? { $case: "languagesAddLanguage", value: LanguagesAddLanguage.fromJSON(object.languagesAddLanguage) }
        : isSet(object.languages_add_language)
        ? { $case: "languagesAddLanguage", value: LanguagesAddLanguage.fromJSON(object.languages_add_language) }
        : isSet(object.languagesDeleteLanguage)
        ? { $case: "languagesDeleteLanguage", value: LanguagesDeleteLanguage.fromJSON(object.languagesDeleteLanguage) }
        : isSet(object.languages_delete_language)
        ? {
          $case: "languagesDeleteLanguage",
          value: LanguagesDeleteLanguage.fromJSON(object.languages_delete_language),
        }
        : isSet(object.experimentalConfigUpdateConfig)
        ? {
          $case: "experimentalConfigUpdateConfig",
          value: ExperimentalConfigUpdateConfig.fromJSON(object.experimentalConfigUpdateConfig),
        }
        : isSet(object.experimental_config_update_config)
        ? {
          $case: "experimentalConfigUpdateConfig",
          value: ExperimentalConfigUpdateConfig.fromJSON(object.experimental_config_update_config),
        }
        : isSet(object.pronunciationsCreatePronunciation)
        ? {
          $case: "pronunciationsCreatePronunciation",
          value: PronunciationsCreatePronunciation.fromJSON(object.pronunciationsCreatePronunciation),
        }
        : isSet(object.pronunciations_create_pronunciation)
        ? {
          $case: "pronunciationsCreatePronunciation",
          value: PronunciationsCreatePronunciation.fromJSON(object.pronunciations_create_pronunciation),
        }
        : isSet(object.pronunciationsUpdatePronunciation)
        ? {
          $case: "pronunciationsUpdatePronunciation",
          value: PronunciationsUpdatePronunciation.fromJSON(object.pronunciationsUpdatePronunciation),
        }
        : isSet(object.pronunciations_update_pronunciation)
        ? {
          $case: "pronunciationsUpdatePronunciation",
          value: PronunciationsUpdatePronunciation.fromJSON(object.pronunciations_update_pronunciation),
        }
        : isSet(object.pronunciationsDeletePronunciation)
        ? {
          $case: "pronunciationsDeletePronunciation",
          value: PronunciationsDeletePronunciation.fromJSON(object.pronunciationsDeletePronunciation),
        }
        : isSet(object.pronunciations_delete_pronunciation)
        ? {
          $case: "pronunciationsDeletePronunciation",
          value: PronunciationsDeletePronunciation.fromJSON(object.pronunciations_delete_pronunciation),
        }
        : isSet(object.pronunciationsReorderPronunciations)
        ? {
          $case: "pronunciationsReorderPronunciations",
          value: PronunciationsReorderPronunciations.fromJSON(object.pronunciationsReorderPronunciations),
        }
        : isSet(object.pronunciations_reorder_pronunciations)
        ? {
          $case: "pronunciationsReorderPronunciations",
          value: PronunciationsReorderPronunciations.fromJSON(object.pronunciations_reorder_pronunciations),
        }
        : isSet(object.createTranscriptCorrections)
        ? {
          $case: "createTranscriptCorrections",
          value: TranscriptCorrectionsCreateTranscriptCorrections.fromJSON(object.createTranscriptCorrections),
        }
        : isSet(object.create_transcript_corrections)
        ? {
          $case: "createTranscriptCorrections",
          value: TranscriptCorrectionsCreateTranscriptCorrections.fromJSON(object.create_transcript_corrections),
        }
        : isSet(object.updateTranscriptCorrections)
        ? {
          $case: "updateTranscriptCorrections",
          value: TranscriptCorrectionsUpdateTranscriptCorrections.fromJSON(object.updateTranscriptCorrections),
        }
        : isSet(object.update_transcript_corrections)
        ? {
          $case: "updateTranscriptCorrections",
          value: TranscriptCorrectionsUpdateTranscriptCorrections.fromJSON(object.update_transcript_corrections),
        }
        : isSet(object.deleteTranscriptCorrections)
        ? {
          $case: "deleteTranscriptCorrections",
          value: TranscriptCorrectionsDeleteTranscriptCorrections.fromJSON(object.deleteTranscriptCorrections),
        }
        : isSet(object.delete_transcript_corrections)
        ? {
          $case: "deleteTranscriptCorrections",
          value: TranscriptCorrectionsDeleteTranscriptCorrections.fromJSON(object.delete_transcript_corrections),
        }
        : isSet(object.updateGreeting)
        ? { $case: "updateGreeting", value: GreetingUpdateGreeting.fromJSON(object.updateGreeting) }
        : isSet(object.update_greeting)
        ? { $case: "updateGreeting", value: GreetingUpdateGreeting.fromJSON(object.update_greeting) }
        : isSet(object.updatePersonality)
        ? { $case: "updatePersonality", value: PersonalityUpdatePersonality.fromJSON(object.updatePersonality) }
        : isSet(object.update_personality)
        ? { $case: "updatePersonality", value: PersonalityUpdatePersonality.fromJSON(object.update_personality) }
        : isSet(object.updateRole)
        ? { $case: "updateRole", value: RoleUpdateRole.fromJSON(object.updateRole) }
        : isSet(object.update_role)
        ? { $case: "updateRole", value: RoleUpdateRole.fromJSON(object.update_role) }
        : isSet(object.updateDisclaimerMessage)
        ? {
          $case: "updateDisclaimerMessage",
          value: DisclaimerMessageUpdateDisclaimerMessage.fromJSON(object.updateDisclaimerMessage),
        }
        : isSet(object.update_disclaimer_message)
        ? {
          $case: "updateDisclaimerMessage",
          value: DisclaimerMessageUpdateDisclaimerMessage.fromJSON(object.update_disclaimer_message),
        }
        : isSet(object.updateRules)
        ? { $case: "updateRules", value: RulesUpdateRules.fromJSON(object.updateRules) }
        : isSet(object.update_rules)
        ? { $case: "updateRules", value: RulesUpdateRules.fromJSON(object.update_rules) }
        : isSet(object.updateLanguageBehavior)
        ? {
          $case: "updateLanguageBehavior",
          value: LanguageBehaviorUpdateLanguageBehavior.fromJSON(object.updateLanguageBehavior),
        }
        : isSet(object.update_language_behavior)
        ? {
          $case: "updateLanguageBehavior",
          value: LanguageBehaviorUpdateLanguageBehavior.fromJSON(object.update_language_behavior),
        }
        : isSet(object.createFunction)
        ? { $case: "createFunction", value: FunctionCreateFunction.fromJSON(object.createFunction) }
        : isSet(object.create_function)
        ? { $case: "createFunction", value: FunctionCreateFunction.fromJSON(object.create_function) }
        : isSet(object.updateFunction)
        ? { $case: "updateFunction", value: FunctionUpdateFunction.fromJSON(object.updateFunction) }
        : isSet(object.update_function)
        ? { $case: "updateFunction", value: FunctionUpdateFunction.fromJSON(object.update_function) }
        : isSet(object.deleteFunction)
        ? { $case: "deleteFunction", value: FunctionDeleteFunction.fromJSON(object.deleteFunction) }
        : isSet(object.delete_function)
        ? { $case: "deleteFunction", value: FunctionDeleteFunction.fromJSON(object.delete_function) }
        : isSet(object.updateLatencyControl)
        ? { $case: "updateLatencyControl", value: FunctionUpdateLatencyControl.fromJSON(object.updateLatencyControl) }
        : isSet(object.update_latency_control)
        ? { $case: "updateLatencyControl", value: FunctionUpdateLatencyControl.fromJSON(object.update_latency_control) }
        : isSet(object.createStartFunction)
        ? { $case: "createStartFunction", value: StartFunctionCreate.fromJSON(object.createStartFunction) }
        : isSet(object.create_start_function)
        ? { $case: "createStartFunction", value: StartFunctionCreate.fromJSON(object.create_start_function) }
        : isSet(object.updateStartFunction)
        ? { $case: "updateStartFunction", value: StartFunctionUpdate.fromJSON(object.updateStartFunction) }
        : isSet(object.update_start_function)
        ? { $case: "updateStartFunction", value: StartFunctionUpdate.fromJSON(object.update_start_function) }
        : isSet(object.deleteStartFunction)
        ? { $case: "deleteStartFunction", value: StartFunctionDelete.fromJSON(object.deleteStartFunction) }
        : isSet(object.delete_start_function)
        ? { $case: "deleteStartFunction", value: StartFunctionDelete.fromJSON(object.delete_start_function) }
        : isSet(object.createEndFunction)
        ? { $case: "createEndFunction", value: EndFunctionCreate.fromJSON(object.createEndFunction) }
        : isSet(object.create_end_function)
        ? { $case: "createEndFunction", value: EndFunctionCreate.fromJSON(object.create_end_function) }
        : isSet(object.updateEndFunction)
        ? { $case: "updateEndFunction", value: EndFunctionUpdate.fromJSON(object.updateEndFunction) }
        : isSet(object.update_end_function)
        ? { $case: "updateEndFunction", value: EndFunctionUpdate.fromJSON(object.update_end_function) }
        : isSet(object.deleteEndFunction)
        ? { $case: "deleteEndFunction", value: EndFunctionDelete.fromJSON(object.deleteEndFunction) }
        : isSet(object.delete_end_function)
        ? { $case: "deleteEndFunction", value: EndFunctionDelete.fromJSON(object.delete_end_function) }
        : isSet(object.voiceAddAgentVoice)
        ? { $case: "voiceAddAgentVoice", value: VoiceAddAgentVoice.fromJSON(object.voiceAddAgentVoice) }
        : isSet(object.voice_add_agent_voice)
        ? { $case: "voiceAddAgentVoice", value: VoiceAddAgentVoice.fromJSON(object.voice_add_agent_voice) }
        : isSet(object.voiceDeleteAgentVoice)
        ? { $case: "voiceDeleteAgentVoice", value: VoiceDeleteAgentVoice.fromJSON(object.voiceDeleteAgentVoice) }
        : isSet(object.voice_delete_agent_voice)
        ? { $case: "voiceDeleteAgentVoice", value: VoiceDeleteAgentVoice.fromJSON(object.voice_delete_agent_voice) }
        : isSet(object.voiceUpdateAgentVoice)
        ? { $case: "voiceUpdateAgentVoice", value: VoiceUpdateAgentVoice.fromJSON(object.voiceUpdateAgentVoice) }
        : isSet(object.voice_update_agent_voice)
        ? { $case: "voiceUpdateAgentVoice", value: VoiceUpdateAgentVoice.fromJSON(object.voice_update_agent_voice) }
        : isSet(object.voiceCreateAgentVoiceSettings)
        ? {
          $case: "voiceCreateAgentVoiceSettings",
          value: VoiceCreateAgentVoiceSettings.fromJSON(object.voiceCreateAgentVoiceSettings),
        }
        : isSet(object.voice_create_agent_voice_settings)
        ? {
          $case: "voiceCreateAgentVoiceSettings",
          value: VoiceCreateAgentVoiceSettings.fromJSON(object.voice_create_agent_voice_settings),
        }
        : isSet(object.voiceUpdateAgentVoiceSettings)
        ? {
          $case: "voiceUpdateAgentVoiceSettings",
          value: VoiceUpdateAgentVoiceSettings.fromJSON(object.voiceUpdateAgentVoiceSettings),
        }
        : isSet(object.voice_update_agent_voice_settings)
        ? {
          $case: "voiceUpdateAgentVoiceSettings",
          value: VoiceUpdateAgentVoiceSettings.fromJSON(object.voice_update_agent_voice_settings),
        }
        : isSet(object.voiceUpdateDisclaimerVoice)
        ? {
          $case: "voiceUpdateDisclaimerVoice",
          value: VoiceUpdateDisclaimerVoice.fromJSON(object.voiceUpdateDisclaimerVoice),
        }
        : isSet(object.voice_update_disclaimer_voice)
        ? {
          $case: "voiceUpdateDisclaimerVoice",
          value: VoiceUpdateDisclaimerVoice.fromJSON(object.voice_update_disclaimer_voice),
        }
        : isSet(object.voiceCreateDisclaimerVoiceSettings)
        ? {
          $case: "voiceCreateDisclaimerVoiceSettings",
          value: VoiceCreateDisclaimerVoiceSettings.fromJSON(object.voiceCreateDisclaimerVoiceSettings),
        }
        : isSet(object.voice_create_disclaimer_voice_settings)
        ? {
          $case: "voiceCreateDisclaimerVoiceSettings",
          value: VoiceCreateDisclaimerVoiceSettings.fromJSON(object.voice_create_disclaimer_voice_settings),
        }
        : isSet(object.voiceUpdateDisclaimerVoiceSettings)
        ? {
          $case: "voiceUpdateDisclaimerVoiceSettings",
          value: VoiceUpdateDisclaimerVoiceSettings.fromJSON(object.voiceUpdateDisclaimerVoiceSettings),
        }
        : isSet(object.voice_update_disclaimer_voice_settings)
        ? {
          $case: "voiceUpdateDisclaimerVoiceSettings",
          value: VoiceUpdateDisclaimerVoiceSettings.fromJSON(object.voice_update_disclaimer_voice_settings),
        }
        : isSet(object.voiceAddFavoriteVoice)
        ? { $case: "voiceAddFavoriteVoice", value: VoiceAddFavoriteVoice.fromJSON(object.voiceAddFavoriteVoice) }
        : isSet(object.voice_add_favorite_voice)
        ? { $case: "voiceAddFavoriteVoice", value: VoiceAddFavoriteVoice.fromJSON(object.voice_add_favorite_voice) }
        : isSet(object.voiceRemoveFavoriteVoice)
        ? {
          $case: "voiceRemoveFavoriteVoice",
          value: VoiceRemoveFavoriteVoice.fromJSON(object.voiceRemoveFavoriteVoice),
        }
        : isSet(object.voice_remove_favorite_voice)
        ? {
          $case: "voiceRemoveFavoriteVoice",
          value: VoiceRemoveFavoriteVoice.fromJSON(object.voice_remove_favorite_voice),
        }
        : isSet(object.entityCreate)
        ? { $case: "entityCreate", value: EntityCreate.fromJSON(object.entityCreate) }
        : isSet(object.entity_create)
        ? { $case: "entityCreate", value: EntityCreate.fromJSON(object.entity_create) }
        : isSet(object.entityUpdate)
        ? { $case: "entityUpdate", value: EntityUpdate.fromJSON(object.entityUpdate) }
        : isSet(object.entity_update)
        ? { $case: "entityUpdate", value: EntityUpdate.fromJSON(object.entity_update) }
        : isSet(object.entityDelete)
        ? { $case: "entityDelete", value: EntityDelete.fromJSON(object.entityDelete) }
        : isSet(object.entity_delete)
        ? { $case: "entityDelete", value: EntityDelete.fromJSON(object.entity_delete) }
        : isSet(object.variableCreate)
        ? { $case: "variableCreate", value: VariableCreate.fromJSON(object.variableCreate) }
        : isSet(object.variable_create)
        ? { $case: "variableCreate", value: VariableCreate.fromJSON(object.variable_create) }
        : isSet(object.variableUpdate)
        ? { $case: "variableUpdate", value: VariableUpdate.fromJSON(object.variableUpdate) }
        : isSet(object.variable_update)
        ? { $case: "variableUpdate", value: VariableUpdate.fromJSON(object.variable_update) }
        : isSet(object.variableDelete)
        ? { $case: "variableDelete", value: VariableDelete.fromJSON(object.variableDelete) }
        : isSet(object.variable_delete)
        ? { $case: "variableDelete", value: VariableDelete.fromJSON(object.variable_delete) }
        : isSet(object.createFlowStep)
        ? { $case: "createFlowStep", value: FlowCreateStep.fromJSON(object.createFlowStep) }
        : isSet(object.create_flow_step)
        ? { $case: "createFlowStep", value: FlowCreateStep.fromJSON(object.create_flow_step) }
        : isSet(object.updateFlowStep)
        ? { $case: "updateFlowStep", value: FlowUpdateStep.fromJSON(object.updateFlowStep) }
        : isSet(object.update_flow_step)
        ? { $case: "updateFlowStep", value: FlowUpdateStep.fromJSON(object.update_flow_step) }
        : isSet(object.deleteFlowStep)
        ? { $case: "deleteFlowStep", value: FlowDeleteStep.fromJSON(object.deleteFlowStep) }
        : isSet(object.delete_flow_step)
        ? { $case: "deleteFlowStep", value: FlowDeleteStep.fromJSON(object.delete_flow_step) }
        : isSet(object.updateFlowStepPosition)
        ? { $case: "updateFlowStepPosition", value: FlowUpdateStepPosition.fromJSON(object.updateFlowStepPosition) }
        : isSet(object.update_flow_step_position)
        ? { $case: "updateFlowStepPosition", value: FlowUpdateStepPosition.fromJSON(object.update_flow_step_position) }
        : isSet(object.updateFlowStepPositions)
        ? { $case: "updateFlowStepPositions", value: FlowUpdateStepPositions.fromJSON(object.updateFlowStepPositions) }
        : isSet(object.update_flow_step_positions)
        ? {
          $case: "updateFlowStepPositions",
          value: FlowUpdateStepPositions.fromJSON(object.update_flow_step_positions),
        }
        : isSet(object.updateFlowStepDtmfConfig)
        ? {
          $case: "updateFlowStepDtmfConfig",
          value: FlowUpdateStepDtmfConfig.fromJSON(object.updateFlowStepDtmfConfig),
        }
        : isSet(object.update_flow_step_dtmf_config)
        ? {
          $case: "updateFlowStepDtmfConfig",
          value: FlowUpdateStepDtmfConfig.fromJSON(object.update_flow_step_dtmf_config),
        }
        : isSet(object.updateFlowStepAsrConfig)
        ? { $case: "updateFlowStepAsrConfig", value: FlowUpdateStepAsrConfig.fromJSON(object.updateFlowStepAsrConfig) }
        : isSet(object.update_flow_step_asr_config)
        ? {
          $case: "updateFlowStepAsrConfig",
          value: FlowUpdateStepAsrConfig.fromJSON(object.update_flow_step_asr_config),
        }
        : isSet(object.createFlowTransitionFunction)
        ? {
          $case: "createFlowTransitionFunction",
          value: FlowCreateTransitionFunction.fromJSON(object.createFlowTransitionFunction),
        }
        : isSet(object.create_flow_transition_function)
        ? {
          $case: "createFlowTransitionFunction",
          value: FlowCreateTransitionFunction.fromJSON(object.create_flow_transition_function),
        }
        : isSet(object.updateFlowTransitionFunction)
        ? {
          $case: "updateFlowTransitionFunction",
          value: FlowUpdateTransitionFunction.fromJSON(object.updateFlowTransitionFunction),
        }
        : isSet(object.update_flow_transition_function)
        ? {
          $case: "updateFlowTransitionFunction",
          value: FlowUpdateTransitionFunction.fromJSON(object.update_flow_transition_function),
        }
        : isSet(object.deleteFlowTransitionFunction)
        ? {
          $case: "deleteFlowTransitionFunction",
          value: FlowDeleteTransitionFunction.fromJSON(object.deleteFlowTransitionFunction),
        }
        : isSet(object.delete_flow_transition_function)
        ? {
          $case: "deleteFlowTransitionFunction",
          value: FlowDeleteTransitionFunction.fromJSON(object.delete_flow_transition_function),
        }
        : isSet(object.deleteFlow)
        ? { $case: "deleteFlow", value: FlowDeleteFlow.fromJSON(object.deleteFlow) }
        : isSet(object.delete_flow)
        ? { $case: "deleteFlow", value: FlowDeleteFlow.fromJSON(object.delete_flow) }
        : isSet(object.createFlow)
        ? { $case: "createFlow", value: FlowCreateFlow.fromJSON(object.createFlow) }
        : isSet(object.create_flow)
        ? { $case: "createFlow", value: FlowCreateFlow.fromJSON(object.create_flow) }
        : isSet(object.importFlow)
        ? { $case: "importFlow", value: FlowImportFlow.fromJSON(object.importFlow) }
        : isSet(object.import_flow)
        ? { $case: "importFlow", value: FlowImportFlow.fromJSON(object.import_flow) }
        : isSet(object.updateFlow)
        ? { $case: "updateFlow", value: FlowUpdateFlow.fromJSON(object.updateFlow) }
        : isSet(object.update_flow)
        ? { $case: "updateFlow", value: FlowUpdateFlow.fromJSON(object.update_flow) }
        : isSet(object.updateFlowTransitionFunctionLatencyControl)
        ? {
          $case: "updateFlowTransitionFunctionLatencyControl",
          value: FlowUpdateTransitionFunctionLatencyControl.fromJSON(object.updateFlowTransitionFunctionLatencyControl),
        }
        : isSet(object.update_flow_transition_function_latency_control)
        ? {
          $case: "updateFlowTransitionFunctionLatencyControl",
          value: FlowUpdateTransitionFunctionLatencyControl.fromJSON(
            object.update_flow_transition_function_latency_control,
          ),
        }
        : isSet(object.createNoCodeStep)
        ? { $case: "createNoCodeStep", value: CreateNoCodeStep.fromJSON(object.createNoCodeStep) }
        : isSet(object.create_no_code_step)
        ? { $case: "createNoCodeStep", value: CreateNoCodeStep.fromJSON(object.create_no_code_step) }
        : isSet(object.updateNoCodeStep)
        ? { $case: "updateNoCodeStep", value: UpdateNoCodeStep.fromJSON(object.updateNoCodeStep) }
        : isSet(object.update_no_code_step)
        ? { $case: "updateNoCodeStep", value: UpdateNoCodeStep.fromJSON(object.update_no_code_step) }
        : isSet(object.deleteNoCodeStep)
        ? { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.fromJSON(object.deleteNoCodeStep) }
        : isSet(object.delete_no_code_step)
        ? { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.fromJSON(object.delete_no_code_step) }
        : isSet(object.updateNoCodeStepPosition)
        ? {
          $case: "updateNoCodeStepPosition",
          value: UpdateNoCodeStepPosition.fromJSON(object.updateNoCodeStepPosition),
        }
        : isSet(object.update_no_code_step_position)
        ? {
          $case: "updateNoCodeStepPosition",
          value: UpdateNoCodeStepPosition.fromJSON(object.update_no_code_step_position),
        }
        : isSet(object.createNoCodeCondition)
        ? { $case: "createNoCodeCondition", value: CreateNoCodeCondition.fromJSON(object.createNoCodeCondition) }
        : isSet(object.create_no_code_condition)
        ? { $case: "createNoCodeCondition", value: CreateNoCodeCondition.fromJSON(object.create_no_code_condition) }
        : isSet(object.deleteNoCodeCondition)
        ? { $case: "deleteNoCodeCondition", value: DeleteNoCodeCondition.fromJSON(object.deleteNoCodeCondition) }
        : isSet(object.delete_no_code_condition)
        ? { $case: "deleteNoCodeCondition", value: DeleteNoCodeCondition.fromJSON(object.delete_no_code_condition) }
        : isSet(object.updateNoCodeCondition)
        ? { $case: "updateNoCodeCondition", value: UpdateNoCodeCondition.fromJSON(object.updateNoCodeCondition) }
        : isSet(object.update_no_code_condition)
        ? { $case: "updateNoCodeCondition", value: UpdateNoCodeCondition.fromJSON(object.update_no_code_condition) }
        : isSet(object.updateNoCodeConditionPosition)
        ? {
          $case: "updateNoCodeConditionPosition",
          value: UpdateNoCodeConditionPosition.fromJSON(object.updateNoCodeConditionPosition),
        }
        : isSet(object.update_no_code_condition_position)
        ? {
          $case: "updateNoCodeConditionPosition",
          value: UpdateNoCodeConditionPosition.fromJSON(object.update_no_code_condition_position),
        }
        : isSet(object.updateNoCodeConditionExitFlowPosition)
        ? {
          $case: "updateNoCodeConditionExitFlowPosition",
          value: UpdateNoCodeConditionExitFlowPosition.fromJSON(object.updateNoCodeConditionExitFlowPosition),
        }
        : isSet(object.update_no_code_condition_exit_flow_position)
        ? {
          $case: "updateNoCodeConditionExitFlowPosition",
          value: UpdateNoCodeConditionExitFlowPosition.fromJSON(object.update_no_code_condition_exit_flow_position),
        }
        : isSet(object.moveFlowComponent)
        ? { $case: "moveFlowComponent", value: MoveFlowComponent.fromJSON(object.moveFlowComponent) }
        : isSet(object.move_flow_component)
        ? { $case: "moveFlowComponent", value: MoveFlowComponent.fromJSON(object.move_flow_component) }
        : isSet(object.moveFlowComponents)
        ? { $case: "moveFlowComponents", value: MoveFlowComponents.fromJSON(object.moveFlowComponents) }
        : isSet(object.move_flow_components)
        ? { $case: "moveFlowComponents", value: MoveFlowComponents.fromJSON(object.move_flow_components) }
        : isSet(object.createStep)
        ? { $case: "createStep", value: CreateStep.fromJSON(object.createStep) }
        : isSet(object.create_step)
        ? { $case: "createStep", value: CreateStep.fromJSON(object.create_step) }
        : isSet(object.updateStep)
        ? { $case: "updateStep", value: UpdateStep.fromJSON(object.updateStep) }
        : isSet(object.update_step)
        ? { $case: "updateStep", value: UpdateStep.fromJSON(object.update_step) }
        : isSet(object.deleteStep)
        ? { $case: "deleteStep", value: DeleteStep.fromJSON(object.deleteStep) }
        : isSet(object.delete_step)
        ? { $case: "deleteStep", value: DeleteStep.fromJSON(object.delete_step) }
        : isSet(object.createStepCondition)
        ? { $case: "createStepCondition", value: CreateStepCondition.fromJSON(object.createStepCondition) }
        : isSet(object.create_step_condition)
        ? { $case: "createStepCondition", value: CreateStepCondition.fromJSON(object.create_step_condition) }
        : isSet(object.updateStepCondition)
        ? { $case: "updateStepCondition", value: UpdateStepCondition.fromJSON(object.updateStepCondition) }
        : isSet(object.update_step_condition)
        ? { $case: "updateStepCondition", value: UpdateStepCondition.fromJSON(object.update_step_condition) }
        : isSet(object.deleteStepCondition)
        ? { $case: "deleteStepCondition", value: DeleteStepCondition.fromJSON(object.deleteStepCondition) }
        : isSet(object.delete_step_condition)
        ? { $case: "deleteStepCondition", value: DeleteStepCondition.fromJSON(object.delete_step_condition) }
        : isSet(object.updateStepConditionPosition)
        ? {
          $case: "updateStepConditionPosition",
          value: UpdateStepConditionPosition.fromJSON(object.updateStepConditionPosition),
        }
        : isSet(object.update_step_condition_position)
        ? {
          $case: "updateStepConditionPosition",
          value: UpdateStepConditionPosition.fromJSON(object.update_step_condition_position),
        }
        : isSet(object.createKeyphraseBoosting)
        ? {
          $case: "createKeyphraseBoosting",
          value: KeyphraseBoostingCreateKeyphrase.fromJSON(object.createKeyphraseBoosting),
        }
        : isSet(object.create_keyphrase_boosting)
        ? {
          $case: "createKeyphraseBoosting",
          value: KeyphraseBoostingCreateKeyphrase.fromJSON(object.create_keyphrase_boosting),
        }
        : isSet(object.updateKeyphraseBoosting)
        ? {
          $case: "updateKeyphraseBoosting",
          value: KeyphraseBoostingUpdateKeyphrase.fromJSON(object.updateKeyphraseBoosting),
        }
        : isSet(object.update_keyphrase_boosting)
        ? {
          $case: "updateKeyphraseBoosting",
          value: KeyphraseBoostingUpdateKeyphrase.fromJSON(object.update_keyphrase_boosting),
        }
        : isSet(object.deleteKeyphraseBoosting)
        ? {
          $case: "deleteKeyphraseBoosting",
          value: KeyphraseBoostingDeleteKeyphrase.fromJSON(object.deleteKeyphraseBoosting),
        }
        : isSet(object.delete_keyphrase_boosting)
        ? {
          $case: "deleteKeyphraseBoosting",
          value: KeyphraseBoostingDeleteKeyphrase.fromJSON(object.delete_keyphrase_boosting),
        }
        : isSet(object.createApiIntegration)
        ? { $case: "createApiIntegration", value: ApiIntegrationCreate.fromJSON(object.createApiIntegration) }
        : isSet(object.create_api_integration)
        ? { $case: "createApiIntegration", value: ApiIntegrationCreate.fromJSON(object.create_api_integration) }
        : isSet(object.updateApiIntegration)
        ? { $case: "updateApiIntegration", value: ApiIntegrationUpdate.fromJSON(object.updateApiIntegration) }
        : isSet(object.update_api_integration)
        ? { $case: "updateApiIntegration", value: ApiIntegrationUpdate.fromJSON(object.update_api_integration) }
        : isSet(object.deleteApiIntegration)
        ? { $case: "deleteApiIntegration", value: ApiIntegrationDelete.fromJSON(object.deleteApiIntegration) }
        : isSet(object.delete_api_integration)
        ? { $case: "deleteApiIntegration", value: ApiIntegrationDelete.fromJSON(object.delete_api_integration) }
        : isSet(object.updateApiIntegrationConfig)
        ? {
          $case: "updateApiIntegrationConfig",
          value: ApiIntegrationConfigUpdate.fromJSON(object.updateApiIntegrationConfig),
        }
        : isSet(object.update_api_integration_config)
        ? {
          $case: "updateApiIntegrationConfig",
          value: ApiIntegrationConfigUpdate.fromJSON(object.update_api_integration_config),
        }
        : isSet(object.createApiIntegrationOperation)
        ? {
          $case: "createApiIntegrationOperation",
          value: ApiIntegrationOperationCreate.fromJSON(object.createApiIntegrationOperation),
        }
        : isSet(object.create_api_integration_operation)
        ? {
          $case: "createApiIntegrationOperation",
          value: ApiIntegrationOperationCreate.fromJSON(object.create_api_integration_operation),
        }
        : isSet(object.updateApiIntegrationOperation)
        ? {
          $case: "updateApiIntegrationOperation",
          value: ApiIntegrationOperationUpdate.fromJSON(object.updateApiIntegrationOperation),
        }
        : isSet(object.update_api_integration_operation)
        ? {
          $case: "updateApiIntegrationOperation",
          value: ApiIntegrationOperationUpdate.fromJSON(object.update_api_integration_operation),
        }
        : isSet(object.deleteApiIntegrationOperation)
        ? {
          $case: "deleteApiIntegrationOperation",
          value: ApiIntegrationOperationDelete.fromJSON(object.deleteApiIntegrationOperation),
        }
        : isSet(object.delete_api_integration_operation)
        ? {
          $case: "deleteApiIntegrationOperation",
          value: ApiIntegrationOperationDelete.fromJSON(object.delete_api_integration_operation),
        }
        : isSet(object.createTranslation)
        ? { $case: "createTranslation", value: LanguageHubTranslationsCreate.fromJSON(object.createTranslation) }
        : isSet(object.create_translation)
        ? { $case: "createTranslation", value: LanguageHubTranslationsCreate.fromJSON(object.create_translation) }
        : isSet(object.updateTranslation)
        ? { $case: "updateTranslation", value: LanguageHubTranslationsUpdate.fromJSON(object.updateTranslation) }
        : isSet(object.update_translation)
        ? { $case: "updateTranslation", value: LanguageHubTranslationsUpdate.fromJSON(object.update_translation) }
        : isSet(object.deleteTranslation)
        ? { $case: "deleteTranslation", value: LanguageHubTranslationsDelete.fromJSON(object.deleteTranslation) }
        : isSet(object.delete_translation)
        ? { $case: "deleteTranslation", value: LanguageHubTranslationsDelete.fromJSON(object.delete_translation) }
        : isSet(object.voiceChannelUpdateAsrSettings)
        ? {
          $case: "voiceChannelUpdateAsrSettings",
          value: VoiceChannelUpdateASRSettings.fromJSON(object.voiceChannelUpdateAsrSettings),
        }
        : isSet(object.voice_channel_update_asr_settings)
        ? {
          $case: "voiceChannelUpdateAsrSettings",
          value: VoiceChannelUpdateASRSettings.fromJSON(object.voice_channel_update_asr_settings),
        }
        : isSet(object.voiceChannelUpdateDisclaimer)
        ? {
          $case: "voiceChannelUpdateDisclaimer",
          value: VoiceChannelUpdateDisclaimer.fromJSON(object.voiceChannelUpdateDisclaimer),
        }
        : isSet(object.voice_channel_update_disclaimer)
        ? {
          $case: "voiceChannelUpdateDisclaimer",
          value: VoiceChannelUpdateDisclaimer.fromJSON(object.voice_channel_update_disclaimer),
        }
        : isSet(object.voiceChannelUpdateBargeInConfig)
        ? {
          $case: "voiceChannelUpdateBargeInConfig",
          value: VoiceChannelUpdateBargeInConfig.fromJSON(object.voiceChannelUpdateBargeInConfig),
        }
        : isSet(object.voice_channel_update_barge_in_config)
        ? {
          $case: "voiceChannelUpdateBargeInConfig",
          value: VoiceChannelUpdateBargeInConfig.fromJSON(object.voice_channel_update_barge_in_config),
        }
        : isSet(object.voiceChannelUpdateTemperature)
        ? {
          $case: "voiceChannelUpdateTemperature",
          value: VoiceChannelUpdateTemperature.fromJSON(object.voiceChannelUpdateTemperature),
        }
        : isSet(object.voice_channel_update_temperature)
        ? {
          $case: "voiceChannelUpdateTemperature",
          value: VoiceChannelUpdateTemperature.fromJSON(object.voice_channel_update_temperature),
        }
        : isSet(object.voiceChannelResetBargeInConfig)
        ? {
          $case: "voiceChannelResetBargeInConfig",
          value: VoiceChannelResetBargeInConfig.fromJSON(object.voiceChannelResetBargeInConfig),
        }
        : isSet(object.voice_channel_reset_barge_in_config)
        ? {
          $case: "voiceChannelResetBargeInConfig",
          value: VoiceChannelResetBargeInConfig.fromJSON(object.voice_channel_reset_barge_in_config),
        }
        : isSet(object.voiceChannelResetTemperature)
        ? {
          $case: "voiceChannelResetTemperature",
          value: VoiceChannelResetTemperature.fromJSON(object.voiceChannelResetTemperature),
        }
        : isSet(object.voice_channel_reset_temperature)
        ? {
          $case: "voiceChannelResetTemperature",
          value: VoiceChannelResetTemperature.fromJSON(object.voice_channel_reset_temperature),
        }
        : isSet(object.voiceChannelResetVadConfig)
        ? {
          $case: "voiceChannelResetVadConfig",
          value: VoiceChannelResetVadConfig.fromJSON(object.voiceChannelResetVadConfig),
        }
        : isSet(object.voice_channel_reset_vad_config)
        ? {
          $case: "voiceChannelResetVadConfig",
          value: VoiceChannelResetVadConfig.fromJSON(object.voice_channel_reset_vad_config),
        }
        : isSet(object.voiceChannelResetAudioEnhancement)
        ? {
          $case: "voiceChannelResetAudioEnhancement",
          value: VoiceChannelResetAudioEnhancement.fromJSON(object.voiceChannelResetAudioEnhancement),
        }
        : isSet(object.voice_channel_reset_audio_enhancement)
        ? {
          $case: "voiceChannelResetAudioEnhancement",
          value: VoiceChannelResetAudioEnhancement.fromJSON(object.voice_channel_reset_audio_enhancement),
        }
        : isSet(object.voiceChannelResetSilenceFillerUtterances)
        ? {
          $case: "voiceChannelResetSilenceFillerUtterances",
          value: VoiceChannelResetSilenceFillerUtterances.fromJSON(object.voiceChannelResetSilenceFillerUtterances),
        }
        : isSet(object.voice_channel_reset_silence_filler_utterances)
        ? {
          $case: "voiceChannelResetSilenceFillerUtterances",
          value: VoiceChannelResetSilenceFillerUtterances.fromJSON(
            object.voice_channel_reset_silence_filler_utterances,
          ),
        }
        : isSet(object.voiceChannelResetAsrConfig)
        ? {
          $case: "voiceChannelResetAsrConfig",
          value: VoiceChannelResetAsrConfig.fromJSON(object.voiceChannelResetAsrConfig),
        }
        : isSet(object.voice_channel_reset_asr_config)
        ? {
          $case: "voiceChannelResetAsrConfig",
          value: VoiceChannelResetAsrConfig.fromJSON(object.voice_channel_reset_asr_config),
        }
        : isSet(object.channelUpdateGreeting)
        ? { $case: "channelUpdateGreeting", value: ChannelUpdateGreeting.fromJSON(object.channelUpdateGreeting) }
        : isSet(object.channel_update_greeting)
        ? { $case: "channelUpdateGreeting", value: ChannelUpdateGreeting.fromJSON(object.channel_update_greeting) }
        : isSet(object.channelUpdateStylePrompt)
        ? {
          $case: "channelUpdateStylePrompt",
          value: ChannelUpdateStylePrompt.fromJSON(object.channelUpdateStylePrompt),
        }
        : isSet(object.channel_update_style_prompt)
        ? {
          $case: "channelUpdateStylePrompt",
          value: ChannelUpdateStylePrompt.fromJSON(object.channel_update_style_prompt),
        }
        : isSet(object.channelUpdateSafetyFilters)
        ? {
          $case: "channelUpdateSafetyFilters",
          value: ChannelUpdateSafetyFilters.fromJSON(object.channelUpdateSafetyFilters),
        }
        : isSet(object.channel_update_safety_filters)
        ? {
          $case: "channelUpdateSafetyFilters",
          value: ChannelUpdateSafetyFilters.fromJSON(object.channel_update_safety_filters),
        }
        : isSet(object.channelUpdateLlmSettings)
        ? {
          $case: "channelUpdateLlmSettings",
          value: ChannelUpdateLLMSettings.fromJSON(object.channelUpdateLlmSettings),
        }
        : isSet(object.channel_update_llm_settings)
        ? {
          $case: "channelUpdateLlmSettings",
          value: ChannelUpdateLLMSettings.fromJSON(object.channel_update_llm_settings),
        }
        : isSet(object.channelUpdateStatus)
        ? { $case: "channelUpdateStatus", value: ChannelUpdateStatus.fromJSON(object.channelUpdateStatus) }
        : isSet(object.channel_update_status)
        ? { $case: "channelUpdateStatus", value: ChannelUpdateStatus.fromJSON(object.channel_update_status) }
        : isSet(object.voiceChannelUpdateVadConfig)
        ? {
          $case: "voiceChannelUpdateVadConfig",
          value: VoiceChannelUpdateVadConfig.fromJSON(object.voiceChannelUpdateVadConfig),
        }
        : isSet(object.voice_channel_update_vad_config)
        ? {
          $case: "voiceChannelUpdateVadConfig",
          value: VoiceChannelUpdateVadConfig.fromJSON(object.voice_channel_update_vad_config),
        }
        : isSet(object.voiceChannelUpdateAudioEnhancement)
        ? {
          $case: "voiceChannelUpdateAudioEnhancement",
          value: VoiceChannelUpdateAudioEnhancement.fromJSON(object.voiceChannelUpdateAudioEnhancement),
        }
        : isSet(object.voice_channel_update_audio_enhancement)
        ? {
          $case: "voiceChannelUpdateAudioEnhancement",
          value: VoiceChannelUpdateAudioEnhancement.fromJSON(object.voice_channel_update_audio_enhancement),
        }
        : isSet(object.voiceChannelUpdateSilenceFillerUtterances)
        ? {
          $case: "voiceChannelUpdateSilenceFillerUtterances",
          value: VoiceChannelUpdateSilenceFillerUtterances.fromJSON(object.voiceChannelUpdateSilenceFillerUtterances),
        }
        : isSet(object.voice_channel_update_silence_filler_utterances)
        ? {
          $case: "voiceChannelUpdateSilenceFillerUtterances",
          value: VoiceChannelUpdateSilenceFillerUtterances.fromJSON(
            object.voice_channel_update_silence_filler_utterances,
          ),
        }
        : isSet(object.voiceChannelUpdateAsrConfig)
        ? {
          $case: "voiceChannelUpdateAsrConfig",
          value: VoiceChannelUpdateAsrConfig.fromJSON(object.voiceChannelUpdateAsrConfig),
        }
        : isSet(object.voice_channel_update_asr_config)
        ? {
          $case: "voiceChannelUpdateAsrConfig",
          value: VoiceChannelUpdateAsrConfig.fromJSON(object.voice_channel_update_asr_config),
        }
        : isSet(object.csatUpdateConfig)
        ? { $case: "csatUpdateConfig", value: CSATUpdateConfig.fromJSON(object.csatUpdateConfig) }
        : isSet(object.csat_update_config)
        ? { $case: "csatUpdateConfig", value: CSATUpdateConfig.fromJSON(object.csat_update_config) }
        : isSet(object.connectIntegration)
        ? { $case: "connectIntegration", value: IntegrationConnect.fromJSON(object.connectIntegration) }
        : isSet(object.connect_integration)
        ? { $case: "connectIntegration", value: IntegrationConnect.fromJSON(object.connect_integration) }
        : isSet(object.enableIntegration)
        ? { $case: "enableIntegration", value: IntegrationEnable.fromJSON(object.enableIntegration) }
        : isSet(object.enable_integration)
        ? { $case: "enableIntegration", value: IntegrationEnable.fromJSON(object.enable_integration) }
        : isSet(object.disableIntegration)
        ? { $case: "disableIntegration", value: IntegrationDisable.fromJSON(object.disableIntegration) }
        : isSet(object.disable_integration)
        ? { $case: "disableIntegration", value: IntegrationDisable.fromJSON(object.disable_integration) }
        : isSet(object.updateIntegrationFunctions)
        ? {
          $case: "updateIntegrationFunctions",
          value: IntegrationUpdateFunctions.fromJSON(object.updateIntegrationFunctions),
        }
        : isSet(object.update_integration_functions)
        ? {
          $case: "updateIntegrationFunctions",
          value: IntegrationUpdateFunctions.fromJSON(object.update_integration_functions),
        }
        : isSet(object.disconnectIntegration)
        ? { $case: "disconnectIntegration", value: IntegrationDisconnect.fromJSON(object.disconnectIntegration) }
        : isSet(object.disconnect_integration)
        ? { $case: "disconnectIntegration", value: IntegrationDisconnect.fromJSON(object.disconnect_integration) }
        : isSet(object.updateMcpConfig)
        ? { $case: "updateMcpConfig", value: MCPConfigUpdate.fromJSON(object.updateMcpConfig) }
        : isSet(object.update_mcp_config)
        ? { $case: "updateMcpConfig", value: MCPConfigUpdate.fromJSON(object.update_mcp_config) }
        : undefined,
    };
  },

  toJSON(message: Command): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.commandId !== "") {
      obj.commandId = message.commandId;
    }
    if (message.payload?.$case === "createTopic") {
      obj.createTopic = KnowledgeBaseCreateTopic.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTopic") {
      obj.updateTopic = KnowledgeBaseUpdateTopic.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteTopic") {
      obj.deleteTopic = KnowledgeBaseDeleteTopic.toJSON(message.payload.value);
    } else if (message.payload?.$case === "importTopics") {
      obj.importTopics = KnowledgeBaseImportTopics.toJSON(message.payload.value);
    } else if (message.payload?.$case === "toggleTopicStatus") {
      obj.toggleTopicStatus = KnowledgeBaseToggleTopicStatus.toJSON(message.payload.value);
    } else if (message.payload?.$case === "smsCreateTemplate") {
      obj.smsCreateTemplate = SMSCreateTemplate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "smsUpdateTemplate") {
      obj.smsUpdateTemplate = SMSUpdateTemplate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "smsDeleteTemplate") {
      obj.smsDeleteTemplate = SMSDeleteTemplate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffCreate") {
      obj.handoffCreate = HandoffCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffUpdate") {
      obj.handoffUpdate = HandoffUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffDelete") {
      obj.handoffDelete = HandoffDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffSetDefault") {
      obj.handoffSetDefault = HandoffSetDefault.toJSON(message.payload.value);
    } else if (message.payload?.$case === "handoffResetHandoffConfigs") {
      obj.handoffResetHandoffConfigs = HandoffResetHandoffConfigs.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantCreateAttribute") {
      obj.variantCreateAttribute = VariantCreateAttribute.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantUpdateAttribute") {
      obj.variantUpdateAttribute = VariantUpdateAttribute.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantDeleteAttribute") {
      obj.variantDeleteAttribute = VariantDeleteAttribute.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantCreateVariant") {
      obj.variantCreateVariant = VariantCreateVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantUpdateVariant") {
      obj.variantUpdateVariant = VariantUpdateVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantDeleteVariant") {
      obj.variantDeleteVariant = VariantDeleteVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantSetDefaultVariant") {
      obj.variantSetDefaultVariant = VariantSetDefaultVariant.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variantImportVariants") {
      obj.variantImportVariants = VariantImportVariants.toJSON(message.payload.value);
    } else if (message.payload?.$case === "stopKeywordsCreate") {
      obj.stopKeywordsCreate = StopKeywordCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "stopKeywordsUpdate") {
      obj.stopKeywordsUpdate = StopKeywordUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "stopKeywordsDelete") {
      obj.stopKeywordsDelete = StopKeywordDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateLlmSettings") {
      obj.updateLlmSettings = LLMSettingsUpdateLLMSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateContentFilterSettings") {
      obj.updateContentFilterSettings = ContentFilterSettingsUpdateContentFilterSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateAsrSettings") {
      obj.updateAsrSettings = ASRSettingsUpdateASRSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTtsSettings") {
      obj.updateTtsSettings = LanguagesUpdateDefaultLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "languagesUpdateDefaultLanguage") {
      obj.languagesUpdateDefaultLanguage = LanguagesUpdateDefaultLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "languagesAddLanguage") {
      obj.languagesAddLanguage = LanguagesAddLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "languagesDeleteLanguage") {
      obj.languagesDeleteLanguage = LanguagesDeleteLanguage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "experimentalConfigUpdateConfig") {
      obj.experimentalConfigUpdateConfig = ExperimentalConfigUpdateConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsCreatePronunciation") {
      obj.pronunciationsCreatePronunciation = PronunciationsCreatePronunciation.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsUpdatePronunciation") {
      obj.pronunciationsUpdatePronunciation = PronunciationsUpdatePronunciation.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsDeletePronunciation") {
      obj.pronunciationsDeletePronunciation = PronunciationsDeletePronunciation.toJSON(message.payload.value);
    } else if (message.payload?.$case === "pronunciationsReorderPronunciations") {
      obj.pronunciationsReorderPronunciations = PronunciationsReorderPronunciations.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createTranscriptCorrections") {
      obj.createTranscriptCorrections = TranscriptCorrectionsCreateTranscriptCorrections.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTranscriptCorrections") {
      obj.updateTranscriptCorrections = TranscriptCorrectionsUpdateTranscriptCorrections.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteTranscriptCorrections") {
      obj.deleteTranscriptCorrections = TranscriptCorrectionsDeleteTranscriptCorrections.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateGreeting") {
      obj.updateGreeting = GreetingUpdateGreeting.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updatePersonality") {
      obj.updatePersonality = PersonalityUpdatePersonality.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateRole") {
      obj.updateRole = RoleUpdateRole.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateDisclaimerMessage") {
      obj.updateDisclaimerMessage = DisclaimerMessageUpdateDisclaimerMessage.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateRules") {
      obj.updateRules = RulesUpdateRules.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateLanguageBehavior") {
      obj.updateLanguageBehavior = LanguageBehaviorUpdateLanguageBehavior.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFunction") {
      obj.createFunction = FunctionCreateFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFunction") {
      obj.updateFunction = FunctionUpdateFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFunction") {
      obj.deleteFunction = FunctionDeleteFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateLatencyControl") {
      obj.updateLatencyControl = FunctionUpdateLatencyControl.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createStartFunction") {
      obj.createStartFunction = StartFunctionCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStartFunction") {
      obj.updateStartFunction = StartFunctionUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteStartFunction") {
      obj.deleteStartFunction = StartFunctionDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createEndFunction") {
      obj.createEndFunction = EndFunctionCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateEndFunction") {
      obj.updateEndFunction = EndFunctionUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteEndFunction") {
      obj.deleteEndFunction = EndFunctionDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceAddAgentVoice") {
      obj.voiceAddAgentVoice = VoiceAddAgentVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceDeleteAgentVoice") {
      obj.voiceDeleteAgentVoice = VoiceDeleteAgentVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateAgentVoice") {
      obj.voiceUpdateAgentVoice = VoiceUpdateAgentVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceCreateAgentVoiceSettings") {
      obj.voiceCreateAgentVoiceSettings = VoiceCreateAgentVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateAgentVoiceSettings") {
      obj.voiceUpdateAgentVoiceSettings = VoiceUpdateAgentVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateDisclaimerVoice") {
      obj.voiceUpdateDisclaimerVoice = VoiceUpdateDisclaimerVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceCreateDisclaimerVoiceSettings") {
      obj.voiceCreateDisclaimerVoiceSettings = VoiceCreateDisclaimerVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceUpdateDisclaimerVoiceSettings") {
      obj.voiceUpdateDisclaimerVoiceSettings = VoiceUpdateDisclaimerVoiceSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceAddFavoriteVoice") {
      obj.voiceAddFavoriteVoice = VoiceAddFavoriteVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceRemoveFavoriteVoice") {
      obj.voiceRemoveFavoriteVoice = VoiceRemoveFavoriteVoice.toJSON(message.payload.value);
    } else if (message.payload?.$case === "entityCreate") {
      obj.entityCreate = EntityCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "entityUpdate") {
      obj.entityUpdate = EntityUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "entityDelete") {
      obj.entityDelete = EntityDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variableCreate") {
      obj.variableCreate = VariableCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variableUpdate") {
      obj.variableUpdate = VariableUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "variableDelete") {
      obj.variableDelete = VariableDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFlowStep") {
      obj.createFlowStep = FlowCreateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStep") {
      obj.updateFlowStep = FlowUpdateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFlowStep") {
      obj.deleteFlowStep = FlowDeleteStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepPosition") {
      obj.updateFlowStepPosition = FlowUpdateStepPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepPositions") {
      obj.updateFlowStepPositions = FlowUpdateStepPositions.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepDtmfConfig") {
      obj.updateFlowStepDtmfConfig = FlowUpdateStepDtmfConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowStepAsrConfig") {
      obj.updateFlowStepAsrConfig = FlowUpdateStepAsrConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFlowTransitionFunction") {
      obj.createFlowTransitionFunction = FlowCreateTransitionFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowTransitionFunction") {
      obj.updateFlowTransitionFunction = FlowUpdateTransitionFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFlowTransitionFunction") {
      obj.deleteFlowTransitionFunction = FlowDeleteTransitionFunction.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteFlow") {
      obj.deleteFlow = FlowDeleteFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createFlow") {
      obj.createFlow = FlowCreateFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "importFlow") {
      obj.importFlow = FlowImportFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlow") {
      obj.updateFlow = FlowUpdateFlow.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateFlowTransitionFunctionLatencyControl") {
      obj.updateFlowTransitionFunctionLatencyControl = FlowUpdateTransitionFunctionLatencyControl.toJSON(
        message.payload.value,
      );
    } else if (message.payload?.$case === "createNoCodeStep") {
      obj.createNoCodeStep = CreateNoCodeStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeStep") {
      obj.updateNoCodeStep = UpdateNoCodeStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteNoCodeStep") {
      obj.deleteNoCodeStep = DeleteNoCodeStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeStepPosition") {
      obj.updateNoCodeStepPosition = UpdateNoCodeStepPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createNoCodeCondition") {
      obj.createNoCodeCondition = CreateNoCodeCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteNoCodeCondition") {
      obj.deleteNoCodeCondition = DeleteNoCodeCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeCondition") {
      obj.updateNoCodeCondition = UpdateNoCodeCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeConditionPosition") {
      obj.updateNoCodeConditionPosition = UpdateNoCodeConditionPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateNoCodeConditionExitFlowPosition") {
      obj.updateNoCodeConditionExitFlowPosition = UpdateNoCodeConditionExitFlowPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "moveFlowComponent") {
      obj.moveFlowComponent = MoveFlowComponent.toJSON(message.payload.value);
    } else if (message.payload?.$case === "moveFlowComponents") {
      obj.moveFlowComponents = MoveFlowComponents.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createStep") {
      obj.createStep = CreateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStep") {
      obj.updateStep = UpdateStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteStep") {
      obj.deleteStep = DeleteStep.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createStepCondition") {
      obj.createStepCondition = CreateStepCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStepCondition") {
      obj.updateStepCondition = UpdateStepCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteStepCondition") {
      obj.deleteStepCondition = DeleteStepCondition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateStepConditionPosition") {
      obj.updateStepConditionPosition = UpdateStepConditionPosition.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createKeyphraseBoosting") {
      obj.createKeyphraseBoosting = KeyphraseBoostingCreateKeyphrase.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateKeyphraseBoosting") {
      obj.updateKeyphraseBoosting = KeyphraseBoostingUpdateKeyphrase.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteKeyphraseBoosting") {
      obj.deleteKeyphraseBoosting = KeyphraseBoostingDeleteKeyphrase.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createApiIntegration") {
      obj.createApiIntegration = ApiIntegrationCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateApiIntegration") {
      obj.updateApiIntegration = ApiIntegrationUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteApiIntegration") {
      obj.deleteApiIntegration = ApiIntegrationDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateApiIntegrationConfig") {
      obj.updateApiIntegrationConfig = ApiIntegrationConfigUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createApiIntegrationOperation") {
      obj.createApiIntegrationOperation = ApiIntegrationOperationCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateApiIntegrationOperation") {
      obj.updateApiIntegrationOperation = ApiIntegrationOperationUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteApiIntegrationOperation") {
      obj.deleteApiIntegrationOperation = ApiIntegrationOperationDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "createTranslation") {
      obj.createTranslation = LanguageHubTranslationsCreate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateTranslation") {
      obj.updateTranslation = LanguageHubTranslationsUpdate.toJSON(message.payload.value);
    } else if (message.payload?.$case === "deleteTranslation") {
      obj.deleteTranslation = LanguageHubTranslationsDelete.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateAsrSettings") {
      obj.voiceChannelUpdateAsrSettings = VoiceChannelUpdateASRSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateDisclaimer") {
      obj.voiceChannelUpdateDisclaimer = VoiceChannelUpdateDisclaimer.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateBargeInConfig") {
      obj.voiceChannelUpdateBargeInConfig = VoiceChannelUpdateBargeInConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateTemperature") {
      obj.voiceChannelUpdateTemperature = VoiceChannelUpdateTemperature.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetBargeInConfig") {
      obj.voiceChannelResetBargeInConfig = VoiceChannelResetBargeInConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetTemperature") {
      obj.voiceChannelResetTemperature = VoiceChannelResetTemperature.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetVadConfig") {
      obj.voiceChannelResetVadConfig = VoiceChannelResetVadConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetAudioEnhancement") {
      obj.voiceChannelResetAudioEnhancement = VoiceChannelResetAudioEnhancement.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelResetSilenceFillerUtterances") {
      obj.voiceChannelResetSilenceFillerUtterances = VoiceChannelResetSilenceFillerUtterances.toJSON(
        message.payload.value,
      );
    } else if (message.payload?.$case === "voiceChannelResetAsrConfig") {
      obj.voiceChannelResetAsrConfig = VoiceChannelResetAsrConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateGreeting") {
      obj.channelUpdateGreeting = ChannelUpdateGreeting.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateStylePrompt") {
      obj.channelUpdateStylePrompt = ChannelUpdateStylePrompt.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateSafetyFilters") {
      obj.channelUpdateSafetyFilters = ChannelUpdateSafetyFilters.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateLlmSettings") {
      obj.channelUpdateLlmSettings = ChannelUpdateLLMSettings.toJSON(message.payload.value);
    } else if (message.payload?.$case === "channelUpdateStatus") {
      obj.channelUpdateStatus = ChannelUpdateStatus.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateVadConfig") {
      obj.voiceChannelUpdateVadConfig = VoiceChannelUpdateVadConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateAudioEnhancement") {
      obj.voiceChannelUpdateAudioEnhancement = VoiceChannelUpdateAudioEnhancement.toJSON(message.payload.value);
    } else if (message.payload?.$case === "voiceChannelUpdateSilenceFillerUtterances") {
      obj.voiceChannelUpdateSilenceFillerUtterances = VoiceChannelUpdateSilenceFillerUtterances.toJSON(
        message.payload.value,
      );
    } else if (message.payload?.$case === "voiceChannelUpdateAsrConfig") {
      obj.voiceChannelUpdateAsrConfig = VoiceChannelUpdateAsrConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "csatUpdateConfig") {
      obj.csatUpdateConfig = CSATUpdateConfig.toJSON(message.payload.value);
    } else if (message.payload?.$case === "connectIntegration") {
      obj.connectIntegration = IntegrationConnect.toJSON(message.payload.value);
    } else if (message.payload?.$case === "enableIntegration") {
      obj.enableIntegration = IntegrationEnable.toJSON(message.payload.value);
    } else if (message.payload?.$case === "disableIntegration") {
      obj.disableIntegration = IntegrationDisable.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateIntegrationFunctions") {
      obj.updateIntegrationFunctions = IntegrationUpdateFunctions.toJSON(message.payload.value);
    } else if (message.payload?.$case === "disconnectIntegration") {
      obj.disconnectIntegration = IntegrationDisconnect.toJSON(message.payload.value);
    } else if (message.payload?.$case === "updateMcpConfig") {
      obj.updateMcpConfig = MCPConfigUpdate.toJSON(message.payload.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Command>): Command {
    return Command.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Command>): Command {
    const message = createBaseCommand();
    message.type = object.type ?? "";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.commandId = object.commandId ?? "";
    switch (object.payload?.$case) {
      case "createTopic": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createTopic", value: KnowledgeBaseCreateTopic.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateTopic": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateTopic", value: KnowledgeBaseUpdateTopic.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteTopic": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteTopic", value: KnowledgeBaseDeleteTopic.fromPartial(object.payload.value) };
        }
        break;
      }
      case "importTopics": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "importTopics",
            value: KnowledgeBaseImportTopics.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "toggleTopicStatus": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "toggleTopicStatus",
            value: KnowledgeBaseToggleTopicStatus.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "smsCreateTemplate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "smsCreateTemplate", value: SMSCreateTemplate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "smsUpdateTemplate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "smsUpdateTemplate", value: SMSUpdateTemplate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "smsDeleteTemplate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "smsDeleteTemplate", value: SMSDeleteTemplate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffCreate", value: HandoffCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffUpdate", value: HandoffUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffDelete", value: HandoffDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffSetDefault": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "handoffSetDefault", value: HandoffSetDefault.fromPartial(object.payload.value) };
        }
        break;
      }
      case "handoffResetHandoffConfigs": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "handoffResetHandoffConfigs",
            value: HandoffResetHandoffConfigs.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantCreateAttribute": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantCreateAttribute",
            value: VariantCreateAttribute.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantUpdateAttribute": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantUpdateAttribute",
            value: VariantUpdateAttribute.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantDeleteAttribute": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantDeleteAttribute",
            value: VariantDeleteAttribute.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantCreateVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantCreateVariant",
            value: VariantCreateVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantUpdateVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantUpdateVariant",
            value: VariantUpdateVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantDeleteVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantDeleteVariant",
            value: VariantDeleteVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantSetDefaultVariant": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantSetDefaultVariant",
            value: VariantSetDefaultVariant.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "variantImportVariants": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "variantImportVariants",
            value: VariantImportVariants.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "stopKeywordsCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "stopKeywordsCreate", value: StopKeywordCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "stopKeywordsUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "stopKeywordsUpdate", value: StopKeywordUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "stopKeywordsDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "stopKeywordsDelete", value: StopKeywordDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateLlmSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateLlmSettings",
            value: LLMSettingsUpdateLLMSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateContentFilterSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateContentFilterSettings",
            value: ContentFilterSettingsUpdateContentFilterSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateAsrSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateAsrSettings",
            value: ASRSettingsUpdateASRSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateTtsSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateTtsSettings",
            value: LanguagesUpdateDefaultLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "languagesUpdateDefaultLanguage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "languagesUpdateDefaultLanguage",
            value: LanguagesUpdateDefaultLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "languagesAddLanguage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "languagesAddLanguage",
            value: LanguagesAddLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "languagesDeleteLanguage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "languagesDeleteLanguage",
            value: LanguagesDeleteLanguage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "experimentalConfigUpdateConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "experimentalConfigUpdateConfig",
            value: ExperimentalConfigUpdateConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsCreatePronunciation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsCreatePronunciation",
            value: PronunciationsCreatePronunciation.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsUpdatePronunciation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsUpdatePronunciation",
            value: PronunciationsUpdatePronunciation.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsDeletePronunciation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsDeletePronunciation",
            value: PronunciationsDeletePronunciation.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "pronunciationsReorderPronunciations": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "pronunciationsReorderPronunciations",
            value: PronunciationsReorderPronunciations.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createTranscriptCorrections": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createTranscriptCorrections",
            value: TranscriptCorrectionsCreateTranscriptCorrections.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateTranscriptCorrections": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateTranscriptCorrections",
            value: TranscriptCorrectionsUpdateTranscriptCorrections.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteTranscriptCorrections": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteTranscriptCorrections",
            value: TranscriptCorrectionsDeleteTranscriptCorrections.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateGreeting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateGreeting",
            value: GreetingUpdateGreeting.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updatePersonality": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updatePersonality",
            value: PersonalityUpdatePersonality.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateRole": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateRole", value: RoleUpdateRole.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateDisclaimerMessage": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateDisclaimerMessage",
            value: DisclaimerMessageUpdateDisclaimerMessage.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateRules": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateRules", value: RulesUpdateRules.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateLanguageBehavior": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateLanguageBehavior",
            value: LanguageBehaviorUpdateLanguageBehavior.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createFunction",
            value: FunctionCreateFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFunction",
            value: FunctionUpdateFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteFunction",
            value: FunctionDeleteFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateLatencyControl": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateLatencyControl",
            value: FunctionUpdateLatencyControl.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createStartFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createStartFunction",
            value: StartFunctionCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateStartFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateStartFunction",
            value: StartFunctionUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteStartFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteStartFunction",
            value: StartFunctionDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createEndFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createEndFunction", value: EndFunctionCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateEndFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateEndFunction", value: EndFunctionUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteEndFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteEndFunction", value: EndFunctionDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "voiceAddAgentVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceAddAgentVoice",
            value: VoiceAddAgentVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceDeleteAgentVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceDeleteAgentVoice",
            value: VoiceDeleteAgentVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateAgentVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateAgentVoice",
            value: VoiceUpdateAgentVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceCreateAgentVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceCreateAgentVoiceSettings",
            value: VoiceCreateAgentVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateAgentVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateAgentVoiceSettings",
            value: VoiceUpdateAgentVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateDisclaimerVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateDisclaimerVoice",
            value: VoiceUpdateDisclaimerVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceCreateDisclaimerVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceCreateDisclaimerVoiceSettings",
            value: VoiceCreateDisclaimerVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceUpdateDisclaimerVoiceSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceUpdateDisclaimerVoiceSettings",
            value: VoiceUpdateDisclaimerVoiceSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceAddFavoriteVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceAddFavoriteVoice",
            value: VoiceAddFavoriteVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceRemoveFavoriteVoice": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceRemoveFavoriteVoice",
            value: VoiceRemoveFavoriteVoice.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "entityCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "entityCreate", value: EntityCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "entityUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "entityUpdate", value: EntityUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "entityDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "entityDelete", value: EntityDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "variableCreate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "variableCreate", value: VariableCreate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "variableUpdate": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "variableUpdate", value: VariableUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
      case "variableDelete": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "variableDelete", value: VariableDelete.fromPartial(object.payload.value) };
        }
        break;
      }
      case "createFlowStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createFlowStep", value: FlowCreateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlowStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateFlowStep", value: FlowUpdateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteFlowStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteFlowStep", value: FlowDeleteStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlowStepPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepPosition",
            value: FlowUpdateStepPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowStepPositions": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepPositions",
            value: FlowUpdateStepPositions.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowStepDtmfConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepDtmfConfig",
            value: FlowUpdateStepDtmfConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowStepAsrConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowStepAsrConfig",
            value: FlowUpdateStepAsrConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createFlowTransitionFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createFlowTransitionFunction",
            value: FlowCreateTransitionFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateFlowTransitionFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowTransitionFunction",
            value: FlowUpdateTransitionFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteFlowTransitionFunction": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteFlowTransitionFunction",
            value: FlowDeleteTransitionFunction.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteFlow", value: FlowDeleteFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "createFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createFlow", value: FlowCreateFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "importFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "importFlow", value: FlowImportFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlow": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateFlow", value: FlowUpdateFlow.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateFlowTransitionFunctionLatencyControl": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateFlowTransitionFunctionLatencyControl",
            value: FlowUpdateTransitionFunctionLatencyControl.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createNoCodeStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createNoCodeStep", value: CreateNoCodeStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateNoCodeStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateNoCodeStep", value: UpdateNoCodeStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteNoCodeStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteNoCodeStep", value: DeleteNoCodeStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateNoCodeStepPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeStepPosition",
            value: UpdateNoCodeStepPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createNoCodeCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createNoCodeCondition",
            value: CreateNoCodeCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteNoCodeCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteNoCodeCondition",
            value: DeleteNoCodeCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateNoCodeCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeCondition",
            value: UpdateNoCodeCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateNoCodeConditionPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeConditionPosition",
            value: UpdateNoCodeConditionPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateNoCodeConditionExitFlowPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateNoCodeConditionExitFlowPosition",
            value: UpdateNoCodeConditionExitFlowPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "moveFlowComponent": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "moveFlowComponent", value: MoveFlowComponent.fromPartial(object.payload.value) };
        }
        break;
      }
      case "moveFlowComponents": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "moveFlowComponents",
            value: MoveFlowComponents.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "createStep", value: CreateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "updateStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateStep", value: UpdateStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "deleteStep": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "deleteStep", value: DeleteStep.fromPartial(object.payload.value) };
        }
        break;
      }
      case "createStepCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createStepCondition",
            value: CreateStepCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateStepCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateStepCondition",
            value: UpdateStepCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteStepCondition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteStepCondition",
            value: DeleteStepCondition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateStepConditionPosition": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateStepConditionPosition",
            value: UpdateStepConditionPosition.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createKeyphraseBoosting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createKeyphraseBoosting",
            value: KeyphraseBoostingCreateKeyphrase.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateKeyphraseBoosting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateKeyphraseBoosting",
            value: KeyphraseBoostingUpdateKeyphrase.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteKeyphraseBoosting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteKeyphraseBoosting",
            value: KeyphraseBoostingDeleteKeyphrase.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createApiIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createApiIntegration",
            value: ApiIntegrationCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateApiIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateApiIntegration",
            value: ApiIntegrationUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteApiIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteApiIntegration",
            value: ApiIntegrationDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateApiIntegrationConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateApiIntegrationConfig",
            value: ApiIntegrationConfigUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createApiIntegrationOperation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createApiIntegrationOperation",
            value: ApiIntegrationOperationCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateApiIntegrationOperation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateApiIntegrationOperation",
            value: ApiIntegrationOperationUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteApiIntegrationOperation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteApiIntegrationOperation",
            value: ApiIntegrationOperationDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "createTranslation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "createTranslation",
            value: LanguageHubTranslationsCreate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateTranslation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateTranslation",
            value: LanguageHubTranslationsUpdate.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "deleteTranslation": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "deleteTranslation",
            value: LanguageHubTranslationsDelete.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateAsrSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateAsrSettings",
            value: VoiceChannelUpdateASRSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateDisclaimer": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateDisclaimer",
            value: VoiceChannelUpdateDisclaimer.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateBargeInConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateBargeInConfig",
            value: VoiceChannelUpdateBargeInConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateTemperature": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateTemperature",
            value: VoiceChannelUpdateTemperature.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetBargeInConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetBargeInConfig",
            value: VoiceChannelResetBargeInConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetTemperature": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetTemperature",
            value: VoiceChannelResetTemperature.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetVadConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetVadConfig",
            value: VoiceChannelResetVadConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetAudioEnhancement": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetAudioEnhancement",
            value: VoiceChannelResetAudioEnhancement.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetSilenceFillerUtterances": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetSilenceFillerUtterances",
            value: VoiceChannelResetSilenceFillerUtterances.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelResetAsrConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelResetAsrConfig",
            value: VoiceChannelResetAsrConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateGreeting": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateGreeting",
            value: ChannelUpdateGreeting.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateStylePrompt": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateStylePrompt",
            value: ChannelUpdateStylePrompt.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateSafetyFilters": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateSafetyFilters",
            value: ChannelUpdateSafetyFilters.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateLlmSettings": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateLlmSettings",
            value: ChannelUpdateLLMSettings.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "channelUpdateStatus": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "channelUpdateStatus",
            value: ChannelUpdateStatus.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateVadConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateVadConfig",
            value: VoiceChannelUpdateVadConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateAudioEnhancement": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateAudioEnhancement",
            value: VoiceChannelUpdateAudioEnhancement.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateSilenceFillerUtterances": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateSilenceFillerUtterances",
            value: VoiceChannelUpdateSilenceFillerUtterances.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "voiceChannelUpdateAsrConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "voiceChannelUpdateAsrConfig",
            value: VoiceChannelUpdateAsrConfig.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "csatUpdateConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "csatUpdateConfig", value: CSATUpdateConfig.fromPartial(object.payload.value) };
        }
        break;
      }
      case "connectIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "connectIntegration",
            value: IntegrationConnect.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "enableIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "enableIntegration", value: IntegrationEnable.fromPartial(object.payload.value) };
        }
        break;
      }
      case "disableIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "disableIntegration",
            value: IntegrationDisable.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateIntegrationFunctions": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "updateIntegrationFunctions",
            value: IntegrationUpdateFunctions.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "disconnectIntegration": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = {
            $case: "disconnectIntegration",
            value: IntegrationDisconnect.fromPartial(object.payload.value),
          };
        }
        break;
      }
      case "updateMcpConfig": {
        if (object.payload?.value !== undefined && object.payload?.value !== null) {
          message.payload = { $case: "updateMcpConfig", value: MCPConfigUpdate.fromPartial(object.payload.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseCommandBatch(): CommandBatch {
  return { lastKnownSequence: Long.UZERO, commands: [] };
}

export const CommandBatch: MessageFns<CommandBatch> = {
  encode(message: CommandBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (!message.lastKnownSequence.equals(Long.UZERO)) {
      writer.uint32(8).uint64(message.lastKnownSequence.toString());
    }
    for (const v of message.commands) {
      Command.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.lastKnownSequence = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commands.push(Command.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommandBatch {
    return {
      lastKnownSequence: isSet(object.lastKnownSequence)
        ? Long.fromValue(object.lastKnownSequence)
        : isSet(object.last_known_sequence)
        ? Long.fromValue(object.last_known_sequence)
        : Long.UZERO,
      commands: globalThis.Array.isArray(object?.commands) ? object.commands.map((e: any) => Command.fromJSON(e)) : [],
    };
  },

  toJSON(message: CommandBatch): unknown {
    const obj: any = {};
    if (!message.lastKnownSequence.equals(Long.UZERO)) {
      obj.lastKnownSequence = (message.lastKnownSequence || Long.UZERO).toString();
    }
    if (message.commands?.length) {
      obj.commands = message.commands.map((e) => Command.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CommandBatch>): CommandBatch {
    return CommandBatch.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CommandBatch>): CommandBatch {
    const message = createBaseCommandBatch();
    message.lastKnownSequence = (object.lastKnownSequence !== undefined && object.lastKnownSequence !== null)
      ? Long.fromValue(object.lastKnownSequence)
      : Long.UZERO;
    message.commands = object.commands?.map((e) => Command.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBranchCreated(): BranchCreated {
  return { id: "", createdAt: undefined, createdBy: "", snapshotKey: "" };
}

export const BranchCreated: MessageFns<BranchCreated> = {
  encode(message: BranchCreated, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(26).string(message.createdBy);
    }
    if (message.snapshotKey !== "") {
      writer.uint32(34).string(message.snapshotKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BranchCreated {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBranchCreated();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BranchCreated {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
    };
  },

  toJSON(message: BranchCreated): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    return obj;
  },

  create(base?: DeepPartial<BranchCreated>): BranchCreated {
    return BranchCreated.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BranchCreated>): BranchCreated {
    const message = createBaseBranchCreated();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.snapshotKey = object.snapshotKey ?? "";
    return message;
  },
};

function createBaseBranchTriggerMerge(): BranchTriggerMerge {
  return { branchId: "", userTimestamp: undefined, triggeredBy: "" };
}

export const BranchTriggerMerge: MessageFns<BranchTriggerMerge> = {
  encode(message: BranchTriggerMerge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.branchId !== "") {
      writer.uint32(10).string(message.branchId);
    }
    if (message.userTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.userTimestamp), writer.uint32(18).fork()).join();
    }
    if (message.triggeredBy !== "") {
      writer.uint32(26).string(message.triggeredBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BranchTriggerMerge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBranchTriggerMerge();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.branchId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.triggeredBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BranchTriggerMerge {
    return {
      branchId: isSet(object.branchId)
        ? globalThis.String(object.branchId)
        : isSet(object.branch_id)
        ? globalThis.String(object.branch_id)
        : "",
      userTimestamp: isSet(object.userTimestamp)
        ? fromJsonTimestamp(object.userTimestamp)
        : isSet(object.user_timestamp)
        ? fromJsonTimestamp(object.user_timestamp)
        : undefined,
      triggeredBy: isSet(object.triggeredBy)
        ? globalThis.String(object.triggeredBy)
        : isSet(object.triggered_by)
        ? globalThis.String(object.triggered_by)
        : "",
    };
  },

  toJSON(message: BranchTriggerMerge): unknown {
    const obj: any = {};
    if (message.branchId !== "") {
      obj.branchId = message.branchId;
    }
    if (message.userTimestamp !== undefined) {
      obj.userTimestamp = message.userTimestamp.toISOString();
    }
    if (message.triggeredBy !== "") {
      obj.triggeredBy = message.triggeredBy;
    }
    return obj;
  },

  create(base?: DeepPartial<BranchTriggerMerge>): BranchTriggerMerge {
    return BranchTriggerMerge.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BranchTriggerMerge>): BranchTriggerMerge {
    const message = createBaseBranchTriggerMerge();
    message.branchId = object.branchId ?? "";
    message.userTimestamp = object.userTimestamp ?? undefined;
    message.triggeredBy = object.triggeredBy ?? "";
    return message;
  },
};

function createBaseConflictResolution(): ConflictResolution {
  return { path: [], strategy: 0, value: undefined };
}

export const ConflictResolution: MessageFns<ConflictResolution> = {
  encode(message: ConflictResolution, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.path) {
      writer.uint32(10).string(v!);
    }
    if (message.strategy !== 0) {
      writer.uint32(16).int32(message.strategy);
    }
    if (message.value !== undefined) {
      Struct.encode(Struct.wrap(message.value), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConflictResolution {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConflictResolution();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.strategy = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConflictResolution {
    return {
      path: globalThis.Array.isArray(object?.path) ? object.path.map((e: any) => globalThis.String(e)) : [],
      strategy: isSet(object.strategy) ? resolutionStrategyFromJSON(object.strategy) : 0,
      value: isObject(object.value) ? object.value : undefined,
    };
  },

  toJSON(message: ConflictResolution): unknown {
    const obj: any = {};
    if (message.path?.length) {
      obj.path = message.path;
    }
    if (message.strategy !== 0) {
      obj.strategy = resolutionStrategyToJSON(message.strategy);
    }
    if (message.value !== undefined) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<ConflictResolution>): ConflictResolution {
    return ConflictResolution.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConflictResolution>): ConflictResolution {
    const message = createBaseConflictResolution();
    message.path = object.path?.map((e) => e) || [];
    message.strategy = object.strategy ?? 0;
    message.value = object.value ?? undefined;
    return message;
  },
};

function createBaseBranchMerged(): BranchMerged {
  return {
    branchId: "",
    mergedAt: undefined,
    mergedBy: "",
    mainSequence: Long.UZERO,
    snapshotKey: "",
    resolutions: [],
  };
}

export const BranchMerged: MessageFns<BranchMerged> = {
  encode(message: BranchMerged, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.branchId !== "") {
      writer.uint32(10).string(message.branchId);
    }
    if (message.mergedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.mergedAt), writer.uint32(18).fork()).join();
    }
    if (message.mergedBy !== "") {
      writer.uint32(26).string(message.mergedBy);
    }
    if (!message.mainSequence.equals(Long.UZERO)) {
      writer.uint32(32).uint64(message.mainSequence.toString());
    }
    if (message.snapshotKey !== "") {
      writer.uint32(42).string(message.snapshotKey);
    }
    for (const v of message.resolutions) {
      ConflictResolution.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BranchMerged {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBranchMerged();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.branchId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mergedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mergedBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.mainSequence = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.resolutions.push(ConflictResolution.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BranchMerged {
    return {
      branchId: isSet(object.branchId)
        ? globalThis.String(object.branchId)
        : isSet(object.branch_id)
        ? globalThis.String(object.branch_id)
        : "",
      mergedAt: isSet(object.mergedAt)
        ? fromJsonTimestamp(object.mergedAt)
        : isSet(object.merged_at)
        ? fromJsonTimestamp(object.merged_at)
        : undefined,
      mergedBy: isSet(object.mergedBy)
        ? globalThis.String(object.mergedBy)
        : isSet(object.merged_by)
        ? globalThis.String(object.merged_by)
        : "",
      mainSequence: isSet(object.mainSequence)
        ? Long.fromValue(object.mainSequence)
        : isSet(object.main_sequence)
        ? Long.fromValue(object.main_sequence)
        : Long.UZERO,
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
      resolutions: globalThis.Array.isArray(object?.resolutions)
        ? object.resolutions.map((e: any) => ConflictResolution.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BranchMerged): unknown {
    const obj: any = {};
    if (message.branchId !== "") {
      obj.branchId = message.branchId;
    }
    if (message.mergedAt !== undefined) {
      obj.mergedAt = message.mergedAt.toISOString();
    }
    if (message.mergedBy !== "") {
      obj.mergedBy = message.mergedBy;
    }
    if (!message.mainSequence.equals(Long.UZERO)) {
      obj.mainSequence = (message.mainSequence || Long.UZERO).toString();
    }
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    if (message.resolutions?.length) {
      obj.resolutions = message.resolutions.map((e) => ConflictResolution.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<BranchMerged>): BranchMerged {
    return BranchMerged.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BranchMerged>): BranchMerged {
    const message = createBaseBranchMerged();
    message.branchId = object.branchId ?? "";
    message.mergedAt = object.mergedAt ?? undefined;
    message.mergedBy = object.mergedBy ?? "";
    message.mainSequence = (object.mainSequence !== undefined && object.mainSequence !== null)
      ? Long.fromValue(object.mainSequence)
      : Long.UZERO;
    message.snapshotKey = object.snapshotKey ?? "";
    message.resolutions = object.resolutions?.map((e) => ConflictResolution.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBranchDeleted(): BranchDeleted {
  return { branchId: "", deletedAt: undefined, deletedBy: "" };
}

export const BranchDeleted: MessageFns<BranchDeleted> = {
  encode(message: BranchDeleted, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.branchId !== "") {
      writer.uint32(10).string(message.branchId);
    }
    if (message.deletedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.deletedAt), writer.uint32(18).fork()).join();
    }
    if (message.deletedBy !== "") {
      writer.uint32(26).string(message.deletedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BranchDeleted {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBranchDeleted();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.branchId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deletedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deletedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BranchDeleted {
    return {
      branchId: isSet(object.branchId)
        ? globalThis.String(object.branchId)
        : isSet(object.branch_id)
        ? globalThis.String(object.branch_id)
        : "",
      deletedAt: isSet(object.deletedAt)
        ? fromJsonTimestamp(object.deletedAt)
        : isSet(object.deleted_at)
        ? fromJsonTimestamp(object.deleted_at)
        : undefined,
      deletedBy: isSet(object.deletedBy)
        ? globalThis.String(object.deletedBy)
        : isSet(object.deleted_by)
        ? globalThis.String(object.deleted_by)
        : "",
    };
  },

  toJSON(message: BranchDeleted): unknown {
    const obj: any = {};
    if (message.branchId !== "") {
      obj.branchId = message.branchId;
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = message.deletedAt.toISOString();
    }
    if (message.deletedBy !== "") {
      obj.deletedBy = message.deletedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<BranchDeleted>): BranchDeleted {
    return BranchDeleted.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BranchDeleted>): BranchDeleted {
    const message = createBaseBranchDeleted();
    message.branchId = object.branchId ?? "";
    message.deletedAt = object.deletedAt ?? undefined;
    message.deletedBy = object.deletedBy ?? "";
    return message;
  },
};

function createBaseProjectCreated(): ProjectCreated {
  return { createdAt: undefined, createdBy: "", name: "", snapshotKey: "" };
}

export const ProjectCreated: MessageFns<ProjectCreated> = {
  encode(message: ProjectCreated, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(10).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(18).string(message.createdBy);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.snapshotKey !== "") {
      writer.uint32(34).string(message.snapshotKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectCreated {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectCreated();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectCreated {
    return {
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
    };
  },

  toJSON(message: ProjectCreated): unknown {
    const obj: any = {};
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectCreated>): ProjectCreated {
    return ProjectCreated.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectCreated>): ProjectCreated {
    const message = createBaseProjectCreated();
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.name = object.name ?? "";
    message.snapshotKey = object.snapshotKey ?? "";
    return message;
  },
};

function createBaseProjectLoadedFromJupiter(): ProjectLoadedFromJupiter {
  return { loadedAt: undefined, artifactVersion: "", ragKbVersion: "", snapshotKey: "" };
}

export const ProjectLoadedFromJupiter: MessageFns<ProjectLoadedFromJupiter> = {
  encode(message: ProjectLoadedFromJupiter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.loadedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.loadedAt), writer.uint32(10).fork()).join();
    }
    if (message.artifactVersion !== "") {
      writer.uint32(18).string(message.artifactVersion);
    }
    if (message.ragKbVersion !== "") {
      writer.uint32(26).string(message.ragKbVersion);
    }
    if (message.snapshotKey !== "") {
      writer.uint32(34).string(message.snapshotKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectLoadedFromJupiter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectLoadedFromJupiter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.loadedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.artifactVersion = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ragKbVersion = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectLoadedFromJupiter {
    return {
      loadedAt: isSet(object.loadedAt)
        ? fromJsonTimestamp(object.loadedAt)
        : isSet(object.loaded_at)
        ? fromJsonTimestamp(object.loaded_at)
        : undefined,
      artifactVersion: isSet(object.artifactVersion)
        ? globalThis.String(object.artifactVersion)
        : isSet(object.artifact_version)
        ? globalThis.String(object.artifact_version)
        : "",
      ragKbVersion: isSet(object.ragKbVersion)
        ? globalThis.String(object.ragKbVersion)
        : isSet(object.rag_kb_version)
        ? globalThis.String(object.rag_kb_version)
        : "",
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
    };
  },

  toJSON(message: ProjectLoadedFromJupiter): unknown {
    const obj: any = {};
    if (message.loadedAt !== undefined) {
      obj.loadedAt = message.loadedAt.toISOString();
    }
    if (message.artifactVersion !== "") {
      obj.artifactVersion = message.artifactVersion;
    }
    if (message.ragKbVersion !== "") {
      obj.ragKbVersion = message.ragKbVersion;
    }
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectLoadedFromJupiter>): ProjectLoadedFromJupiter {
    return ProjectLoadedFromJupiter.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectLoadedFromJupiter>): ProjectLoadedFromJupiter {
    const message = createBaseProjectLoadedFromJupiter();
    message.loadedAt = object.loadedAt ?? undefined;
    message.artifactVersion = object.artifactVersion ?? "";
    message.ragKbVersion = object.ragKbVersion ?? "";
    message.snapshotKey = object.snapshotKey ?? "";
    return message;
  },
};

function createBaseDeploymentCompleted(): DeploymentCompleted {
  return {
    branchId: "",
    clientEnv: "",
    snapshotKey: "",
    artifactVersion: "",
    ragKbVersion: "",
    functionDeploymentVersion: "",
    lambdaDeploymentVersion: "",
    versionHash: "",
  };
}

export const DeploymentCompleted: MessageFns<DeploymentCompleted> = {
  encode(message: DeploymentCompleted, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.branchId !== "") {
      writer.uint32(10).string(message.branchId);
    }
    if (message.clientEnv !== "") {
      writer.uint32(18).string(message.clientEnv);
    }
    if (message.snapshotKey !== "") {
      writer.uint32(26).string(message.snapshotKey);
    }
    if (message.artifactVersion !== "") {
      writer.uint32(34).string(message.artifactVersion);
    }
    if (message.ragKbVersion !== "") {
      writer.uint32(42).string(message.ragKbVersion);
    }
    if (message.functionDeploymentVersion !== "") {
      writer.uint32(50).string(message.functionDeploymentVersion);
    }
    if (message.lambdaDeploymentVersion !== "") {
      writer.uint32(66).string(message.lambdaDeploymentVersion);
    }
    if (message.versionHash !== "") {
      writer.uint32(58).string(message.versionHash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeploymentCompleted {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeploymentCompleted();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.branchId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clientEnv = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.artifactVersion = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ragKbVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.functionDeploymentVersion = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.lambdaDeploymentVersion = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.versionHash = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeploymentCompleted {
    return {
      branchId: isSet(object.branchId)
        ? globalThis.String(object.branchId)
        : isSet(object.branch_id)
        ? globalThis.String(object.branch_id)
        : "",
      clientEnv: isSet(object.clientEnv)
        ? globalThis.String(object.clientEnv)
        : isSet(object.client_env)
        ? globalThis.String(object.client_env)
        : "",
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
      artifactVersion: isSet(object.artifactVersion)
        ? globalThis.String(object.artifactVersion)
        : isSet(object.artifact_version)
        ? globalThis.String(object.artifact_version)
        : "",
      ragKbVersion: isSet(object.ragKbVersion)
        ? globalThis.String(object.ragKbVersion)
        : isSet(object.rag_kb_version)
        ? globalThis.String(object.rag_kb_version)
        : "",
      functionDeploymentVersion: isSet(object.functionDeploymentVersion)
        ? globalThis.String(object.functionDeploymentVersion)
        : isSet(object.function_deployment_version)
        ? globalThis.String(object.function_deployment_version)
        : "",
      lambdaDeploymentVersion: isSet(object.lambdaDeploymentVersion)
        ? globalThis.String(object.lambdaDeploymentVersion)
        : isSet(object.lambda_deployment_version)
        ? globalThis.String(object.lambda_deployment_version)
        : "",
      versionHash: isSet(object.versionHash)
        ? globalThis.String(object.versionHash)
        : isSet(object.version_hash)
        ? globalThis.String(object.version_hash)
        : "",
    };
  },

  toJSON(message: DeploymentCompleted): unknown {
    const obj: any = {};
    if (message.branchId !== "") {
      obj.branchId = message.branchId;
    }
    if (message.clientEnv !== "") {
      obj.clientEnv = message.clientEnv;
    }
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    if (message.artifactVersion !== "") {
      obj.artifactVersion = message.artifactVersion;
    }
    if (message.ragKbVersion !== "") {
      obj.ragKbVersion = message.ragKbVersion;
    }
    if (message.functionDeploymentVersion !== "") {
      obj.functionDeploymentVersion = message.functionDeploymentVersion;
    }
    if (message.lambdaDeploymentVersion !== "") {
      obj.lambdaDeploymentVersion = message.lambdaDeploymentVersion;
    }
    if (message.versionHash !== "") {
      obj.versionHash = message.versionHash;
    }
    return obj;
  },

  create(base?: DeepPartial<DeploymentCompleted>): DeploymentCompleted {
    return DeploymentCompleted.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeploymentCompleted>): DeploymentCompleted {
    const message = createBaseDeploymentCompleted();
    message.branchId = object.branchId ?? "";
    message.clientEnv = object.clientEnv ?? "";
    message.snapshotKey = object.snapshotKey ?? "";
    message.artifactVersion = object.artifactVersion ?? "";
    message.ragKbVersion = object.ragKbVersion ?? "";
    message.functionDeploymentVersion = object.functionDeploymentVersion ?? "";
    message.lambdaDeploymentVersion = object.lambdaDeploymentVersion ?? "";
    message.versionHash = object.versionHash ?? "";
    return message;
  },
};

function createBaseDeploymentRollback(): DeploymentRollback {
  return {
    branchId: "",
    snapshotKey: "",
    artifactVersion: "",
    ragKbVersion: "",
    functionDeploymentVersion: "",
    versionHash: "",
  };
}

export const DeploymentRollback: MessageFns<DeploymentRollback> = {
  encode(message: DeploymentRollback, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.branchId !== "") {
      writer.uint32(10).string(message.branchId);
    }
    if (message.snapshotKey !== "") {
      writer.uint32(26).string(message.snapshotKey);
    }
    if (message.artifactVersion !== "") {
      writer.uint32(34).string(message.artifactVersion);
    }
    if (message.ragKbVersion !== "") {
      writer.uint32(42).string(message.ragKbVersion);
    }
    if (message.functionDeploymentVersion !== "") {
      writer.uint32(50).string(message.functionDeploymentVersion);
    }
    if (message.versionHash !== "") {
      writer.uint32(58).string(message.versionHash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeploymentRollback {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeploymentRollback();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.branchId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.artifactVersion = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ragKbVersion = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.functionDeploymentVersion = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.versionHash = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeploymentRollback {
    return {
      branchId: isSet(object.branchId)
        ? globalThis.String(object.branchId)
        : isSet(object.branch_id)
        ? globalThis.String(object.branch_id)
        : "",
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
      artifactVersion: isSet(object.artifactVersion)
        ? globalThis.String(object.artifactVersion)
        : isSet(object.artifact_version)
        ? globalThis.String(object.artifact_version)
        : "",
      ragKbVersion: isSet(object.ragKbVersion)
        ? globalThis.String(object.ragKbVersion)
        : isSet(object.rag_kb_version)
        ? globalThis.String(object.rag_kb_version)
        : "",
      functionDeploymentVersion: isSet(object.functionDeploymentVersion)
        ? globalThis.String(object.functionDeploymentVersion)
        : isSet(object.function_deployment_version)
        ? globalThis.String(object.function_deployment_version)
        : "",
      versionHash: isSet(object.versionHash)
        ? globalThis.String(object.versionHash)
        : isSet(object.version_hash)
        ? globalThis.String(object.version_hash)
        : "",
    };
  },

  toJSON(message: DeploymentRollback): unknown {
    const obj: any = {};
    if (message.branchId !== "") {
      obj.branchId = message.branchId;
    }
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    if (message.artifactVersion !== "") {
      obj.artifactVersion = message.artifactVersion;
    }
    if (message.ragKbVersion !== "") {
      obj.ragKbVersion = message.ragKbVersion;
    }
    if (message.functionDeploymentVersion !== "") {
      obj.functionDeploymentVersion = message.functionDeploymentVersion;
    }
    if (message.versionHash !== "") {
      obj.versionHash = message.versionHash;
    }
    return obj;
  },

  create(base?: DeepPartial<DeploymentRollback>): DeploymentRollback {
    return DeploymentRollback.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeploymentRollback>): DeploymentRollback {
    const message = createBaseDeploymentRollback();
    message.branchId = object.branchId ?? "";
    message.snapshotKey = object.snapshotKey ?? "";
    message.artifactVersion = object.artifactVersion ?? "";
    message.ragKbVersion = object.ragKbVersion ?? "";
    message.functionDeploymentVersion = object.functionDeploymentVersion ?? "";
    message.versionHash = object.versionHash ?? "";
    return message;
  },
};

function createBaseLoadedFromBundle(): LoadedFromBundle {
  return { snapshotKey: "" };
}

export const LoadedFromBundle: MessageFns<LoadedFromBundle> = {
  encode(message: LoadedFromBundle, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.snapshotKey !== "") {
      writer.uint32(10).string(message.snapshotKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoadedFromBundle {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadedFromBundle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadedFromBundle {
    return {
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
    };
  },

  toJSON(message: LoadedFromBundle): unknown {
    const obj: any = {};
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    return obj;
  },

  create(base?: DeepPartial<LoadedFromBundle>): LoadedFromBundle {
    return LoadedFromBundle.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LoadedFromBundle>): LoadedFromBundle {
    const message = createBaseLoadedFromBundle();
    message.snapshotKey = object.snapshotKey ?? "";
    return message;
  },
};

function createBaseFunctionDeploymentCompleted(): FunctionDeploymentCompleted {
  return { branchId: "", snapshotKey: "", functionDeploymentId: "", lambdaDeploymentVersion: "" };
}

export const FunctionDeploymentCompleted: MessageFns<FunctionDeploymentCompleted> = {
  encode(message: FunctionDeploymentCompleted, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.branchId !== "") {
      writer.uint32(10).string(message.branchId);
    }
    if (message.snapshotKey !== "") {
      writer.uint32(18).string(message.snapshotKey);
    }
    if (message.functionDeploymentId !== "") {
      writer.uint32(26).string(message.functionDeploymentId);
    }
    if (message.lambdaDeploymentVersion !== "") {
      writer.uint32(34).string(message.lambdaDeploymentVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionDeploymentCompleted {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionDeploymentCompleted();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.branchId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.snapshotKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.functionDeploymentId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lambdaDeploymentVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionDeploymentCompleted {
    return {
      branchId: isSet(object.branchId)
        ? globalThis.String(object.branchId)
        : isSet(object.branch_id)
        ? globalThis.String(object.branch_id)
        : "",
      snapshotKey: isSet(object.snapshotKey)
        ? globalThis.String(object.snapshotKey)
        : isSet(object.snapshot_key)
        ? globalThis.String(object.snapshot_key)
        : "",
      functionDeploymentId: isSet(object.functionDeploymentId)
        ? globalThis.String(object.functionDeploymentId)
        : isSet(object.function_deployment_id)
        ? globalThis.String(object.function_deployment_id)
        : "",
      lambdaDeploymentVersion: isSet(object.lambdaDeploymentVersion)
        ? globalThis.String(object.lambdaDeploymentVersion)
        : isSet(object.lambda_deployment_version)
        ? globalThis.String(object.lambda_deployment_version)
        : "",
    };
  },

  toJSON(message: FunctionDeploymentCompleted): unknown {
    const obj: any = {};
    if (message.branchId !== "") {
      obj.branchId = message.branchId;
    }
    if (message.snapshotKey !== "") {
      obj.snapshotKey = message.snapshotKey;
    }
    if (message.functionDeploymentId !== "") {
      obj.functionDeploymentId = message.functionDeploymentId;
    }
    if (message.lambdaDeploymentVersion !== "") {
      obj.lambdaDeploymentVersion = message.lambdaDeploymentVersion;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionDeploymentCompleted>): FunctionDeploymentCompleted {
    return FunctionDeploymentCompleted.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionDeploymentCompleted>): FunctionDeploymentCompleted {
    const message = createBaseFunctionDeploymentCompleted();
    message.branchId = object.branchId ?? "";
    message.snapshotKey = object.snapshotKey ?? "";
    message.functionDeploymentId = object.functionDeploymentId ?? "";
    message.lambdaDeploymentVersion = object.lambdaDeploymentVersion ?? "";
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
